import 'core-js/modules/es6.function.name.js';
import React, { useRef, useEffect, forwardRef, useMemo, useState, useCallback } from 'react';
import 'core-js/modules/es6.object.assign.js';
import styled from 'styled-components';
import 'core-js/modules/es6.array.map.js';
import 'core-js/modules/es6.string.includes.js';
import 'core-js/modules/es7.array.includes.js';
import 'core-js/modules/es6.regexp.split.js';
import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.object.to-string.js';
import 'core-js/modules/es6.array.iterator.js';
import 'core-js/modules/web.dom.iterable.js';
import md from 'markdown-ast';
import 'core-js/modules/es6.regexp.replace.js';
import 'core-js/modules/es6.number.constructor.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.array.slice.js';
import { createPortal } from 'react-dom';
import 'core-js/modules/es6.array.find.js';
import 'core-js/modules/es6.map.js';
import 'core-js/modules/es6.string.iterator.js';
import 'core-js/modules/es6.string.starts-with.js';
import 'core-js/modules/es7.object.entries.js';
import 'core-js/modules/es6.array.find-index.js';
import 'core-js/modules/es6.regexp.to-string.js';
import 'core-js/modules/es6.promise.js';
import require$$0 from 'stream';

function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) {
      t && (r = t);
      var n = 0,
        F = function () {};
      return {
        s: F,
        n: function () {
          return n >= r.length ? {
            done: true
          } : {
            done: false,
            value: r[n++]
          };
        },
        e: function (r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = true,
    u = false;
  return {
    s: function () {
      t = t.call(r);
    },
    n: function () {
      var r = t.next();
      return a = r.done, r;
    },
    e: function (r) {
      u = true, o = r;
    },
    f: function () {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = true,
      o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = true, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = false,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function (t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = true, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), true), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function () {
    return this;
  }), _regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function () {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorAsync(n, e, r, t, o) {
  var a = _regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise);
}
function _regeneratorAsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (_regeneratorDefine(_regeneratorAsyncIterator.prototype), _regeneratorDefine(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), _regeneratorDefine(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, true);
}
function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine = function (e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      function o(r, n) {
        _regeneratorDefine(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      }
      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine(e, r, n, t);
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = false, e;
    return e.done = true, e;
  };
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function () {
        return e && r >= e.length && (e = undefined), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(typeof e + " is not iterable");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (undefined !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : undefined;
  }
}
function _regeneratorRuntime() {

  var r = _regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    throw: 1,
    return: 2,
    break: 3,
    continue: 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function () {
          return t(n.a, 2);
        },
        catch: function () {
          return n.v;
        },
        abrupt: function (r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function (r, o, a) {
          return e.resultName = o, t(n.d, _regeneratorValues(r), a);
        },
        finish: function (r) {
          return t(n.f, r);
        }
      }, t = function (r, t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = undefined), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (_regeneratorRuntime = function () {
    return {
      wrap: function (e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function (r, e) {
        return new _OverloadYield(r, e);
      },
      AsyncIterator: _regeneratorAsyncIterator,
      async: function (r, e, t, o, u) {
        return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var fontWeight = {
  thin: 100,
  'extra-light': 200,
  light: 300,
  normal: 400,
  medium: 500,
  'semi-bold': 600,
  bold: 700,
  'extra-bold': 800,
  black: 900
};
var alignment = {
  start: 'flex-start',
  end: 'flex-end',
  center: 'center',
  between: 'space-between',
  // not sure about these three
  evenly: 'space-evenly',
  around: 'space-around',
  normal: 'row',
  reverse: 'row-reverse'
};
var tone = {
  default: '#E8E8E8',
  info: '#E0F0FF',
  success: '#CDFEE1',
  attention: '#FFEF9D',
  warning: '#FFD6A4',
  critical: '#FEDAD9',
  plain: '#FFFFFF'
};
var text = {
  default: '#616161',
  info: '#00527C',
  success: '#0C5132',
  attention: '#4F4700',
  warning: '#5E4200',
  critical: '#8E1F0B',
  plain: '#616161'
};

var _templateObject$g;
var Block = styled.div(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n  font-family:\n    ", ", sans-serif;\n  font-size: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  text-align: ", ";\n  box-sizing: border-box;\n  width: ", ";\n  height: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: ", ";\n  align-items: ", ";\n  gap: ", ";\n  padding: ", ";\n  margin: ", ";\n  border: ", ";\n  border-width: ", ";\n  border-style: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  color: ", ";\n  background-color: ", ";\n"])), function (prop) {
  return prop.fontFamily ? prop.fontFamily : 'inherit';
}, function (prop) {
  return prop.textSize && prop.textSize;
}, function (prop) {
  return prop.fontWeight && fontWeight[prop.fontWeight];
}, function (prop) {
  return prop.fontStyle && prop.fontStyle;
}, function (prop) {
  return prop.textAlign && prop.textAlign;
}, function (prop) {
  return prop.width && prop.width;
}, function (prop) {
  return prop.height || 'inherit';
}, function (prop) {
  return prop.verticalAlign && alignment[prop.verticalAlign];
}, function (prop) {
  return prop.horizontalAlign && alignment[prop.horizontalAlign];
}, function (prop) {
  return prop.gap && prop.gap;
}, function (prop) {
  return prop.padding && prop.padding;
}, function (prop) {
  return prop.margin && prop.margin;
}, function (prop) {
  return prop.border && prop.border;
}, function (prop) {
  return prop.borderWidth && prop.borderWidth;
}, function (prop) {
  return prop.borderStyle && prop.borderStyle;
}, function (prop) {
  return prop.borderColor && prop.borderColor;
}, function (prop) {
  return prop.cornerRadius && prop.cornerRadius;
}, function (prop) {
  return prop.color && prop.color;
}, function (prop) {
  return prop.bgColor && prop.bgColor;
});
var BlockLayout = function BlockLayout(_ref) {
  var id = _ref.id,
    _ref$verticalAlign = _ref.verticalAlign,
    verticalAlign = _ref$verticalAlign === undefined ? 'center' : _ref$verticalAlign,
    _ref$horizontalAlign = _ref.horizontalAlign,
    horizontalAlign = _ref$horizontalAlign === undefined ? 'center' : _ref$horizontalAlign,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === undefined ? 'start' : _ref$textAlign,
    textSize = _ref.textSize,
    fontFamily = _ref.fontFamily,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === undefined ? 'normal' : _ref$fontWeight,
    _ref$fontStyle = _ref.fontStyle,
    fontStyle = _ref$fontStyle === undefined ? 'normal' : _ref$fontStyle,
    bgColor = _ref.bgColor,
    color = _ref.color,
    _ref$gap = _ref.gap,
    gap = _ref$gap === undefined ? '6px' : _ref$gap,
    padding = _ref.padding,
    margin = _ref.margin,
    border = _ref.border,
    borderWidth = _ref.borderWidth,
    borderStyle = _ref.borderStyle,
    borderColor = _ref.borderColor,
    cornerRadius = _ref.cornerRadius,
    height = _ref.height,
    _ref$width = _ref.width,
    width = _ref$width === undefined ? '100%' : _ref$width,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Block, {
    id: id,
    verticalAlign: verticalAlign,
    horizontalAlign: horizontalAlign,
    textAlign: textAlign,
    textSize: textSize,
    fontFamily: fontFamily,
    fontWeight: fontWeight,
    fontStyle: fontStyle,
    bgColor: bgColor,
    color: color,
    gap: gap,
    padding: padding,
    margin: margin,
    border: border,
    borderWidth: borderWidth,
    borderStyle: borderStyle,
    borderColor: borderColor,
    cornerRadius: cornerRadius,
    height: height,
    width: width
  }, children);
};

var _templateObject$f, _templateObject2$3, _templateObject3$1, _templateObject4$1, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1;
styled.div(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n  font-size: 1.42rem;\n  line-height: 2;\n  color: #202223;\n  font-weight: bold;\n"])));
styled.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n  margin: 2rem 0 3rem;\n  ", ";\n"])), function (props) {
  return props.maxWidth ? "max-width: ".concat(props.maxWidth, ";") : null;
});
var colorCoding = {
  info: 'rgba(234, 244, 255, 1)',
  textInfo: 'rgba(0, 58, 90, 1)',
  success: '#d4edda',
  warning: '#fff3cd',
  danger: '#f8d7da',
  primary: '#cce5ff',
  secondary: '#e2e3e5'
};
var FlexDiv = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  display: flex;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  & .grow {\n    flex-grow: 1;\n  }\n"])), function (props) {
  return props.flexdir ? "flex-direction: ".concat(props.flexdir, ";") : null;
}, function (props) {
  return props.margintop ? "margin-top: ".concat(props.margintop, ";") : null;
}, function (props) {
  return props.hide ? "display: none;" : null;
}, function (props) {
  return props.gap ? "gap: ".concat(props.gap, ";") : null;
}, function (props) {
  return props.columngap ? "column-gap: ".concat(props.columngap, ";") : null;
}, function (props) {
  return props.rowgap ? "row-gap: ".concat(props.rowgap, ";") : null;
}, function (props) {
  return props.ai ? "align-items: ".concat(props.ai) : 'start';
}, function (props) {
  return props.flexwrap ? "flex-wrap: ".concat(props.flexwrap, ";") : null;
}, function (props) {
  return props.height ? "height: ".concat(props.height, ";") : null;
}, function (props) {
  return props.width ? "width: ".concat(props.width, ";") : null;
}, function (props) {
  return props.maxwidth ? "max-width: ".concat(props.maxwidth, ";") : null;
}, function (props) {
  return props.minwidth ? "min-width: ".concat(props.minwidth, ";") : null;
}, function (props) {
  return props.margin ? "margin: ".concat(props.margin, ";") : null;
}, function (props) {
  return props.padding ? "padding: ".concat(props.padding, ";") : null;
}, function (props) {
  return props.jc ? "justify-content: ".concat(props.jc, ";") : null;
}, function (props) {
  return props.border ? "border: ".concat(props.border, ";") : null;
}, function (props) {
  return props.position ? "position: ".concat(props.position, ";") : null;
}, function (props) {
  return props.top ? "top: ".concat(props.top, ";") : null;
}, function (props) {
  return props.left ? "left: ".concat(props.left, ";") : null;
}, function (props) {
  return props.backgroundcolor ? "background-color: ".concat(props.backgroundcolor, ";") : null;
}, function (props) {
  return props.bg ? "background-color: ".concat(colorCoding[props.bg], ";") : null;
}, function (props) {
  return props.borderbottom ? "border-bottom: ".concat(props.borderbottom, ";") : null;
}, function (props) {
  return props.borderradius ? "border-radius: ".concat(props.borderradius, ";") : null;
}, function (props) {
  return props.zindex ? "z-index: ".concat(props.zindex, ";") : '0';
}, function (props) {
  return props.minheight ? "min-height: ".concat(props.minheight, ";") : null;
}, function (props) {
  return props.maxheight ? "max-height: ".concat(props.maxheight, ";") : null;
}, function (props) {
  return props.overflow ? "overflow: ".concat(props.overflow, ";") : null;
}, function (props) {
  return props.transform ? "transform: ".concat(props.transform, ";") : null;
}, function (props) {
  return props.boxshadow ? "box-shadow: ".concat(props.boxshadow, ";") : null;
}, function (props) {
  return props.boxsizing ? "box-sizing: ".concat(props.boxsizing, ";") : null;
}, function (props) {
  return props.fontSize ? "font-size: ".concat(props.fontSize, ";") : null;
}, function (props) {
  return props.color ? "color: ".concat(props.color, ";") : null;
});
styled.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  ", " ", "\n  label {\n    font-size: 1.4rem;\n    color: #1f1f1f;\n  }\n"])), function (props) {
  return props.maxWidth ? "max-width: ".concat(props.maxWidth, ";") : null;
}, function (props) {
  return props.pr ? "padding-right: ".concat(props.pr, ";") : null;
});
styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: #1f1f1f;\n  font-size: 1.4rem;\n  ", ";\n"])), function (props) {
  return props.mt ? "margin-top: ".concat(props.mt, ";") : null;
});
styled.p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-bottom: 10px;\n"])));
styled.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  color: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  line-height: ", ";\n  padding: ", ";\n  padding: ", ";\n  width: ", ";\n  height: ", ";\n"])), function (_ref) {
  var fontSize = _ref.fontSize;
  return fontSize;
}, function (_ref2) {
  var color = _ref2.color;
  return color;
}, function (_ref3) {
  var tone = _ref3.tone;
  return tone && colorCoding[tone];
}, function (_ref4) {
  var fontWeight = _ref4.fontWeight;
  return fontWeight;
}, function (_ref5) {
  var fontStyle = _ref5.fontStyle;
  return fontStyle;
}, function (_ref6) {
  var lineheight = _ref6.lineheight;
  return lineheight;
}, function (_ref7) {
  var padding = _ref7.padding;
  return padding;
}, function (_ref8) {
  var margin = _ref8.margin;
  return margin;
}, function (_ref9) {
  var width = _ref9.width;
  return width;
}, function (_ref0) {
  var height = _ref0.height;
  return height;
});
styled.button(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: ", ";\n  align-items: ", ";\n  gap: ", ";\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  background: ", ";\n  border-radius: ", ";\n  border: ", ";\n  color: ", ";\n  text-align: center;\n  font-size: ", ";\n  font-style: normal;\n  font-weight: ", ";\n  line-height: ", ";\n  cursor: pointer;\n  box-shadow: ", ";\n  classname: ", ";\n"])), function (_ref1) {
  var padding = _ref1.padding;
  return padding;
}, function (_ref10) {
  var alignButton = _ref10.alignButton;
  return alignButton;
}, function (_ref11) {
  var gap = _ref11.gap;
  return gap;
}, function (_ref12) {
  var width = _ref12.width;
  return width;
}, function (_ref13) {
  var height = _ref13.height;
  return height;
}, function (_ref14) {
  var backgroundColor = _ref14.backgroundColor;
  return backgroundColor;
}, function (_ref15) {
  var background = _ref15.background;
  return background;
}, function (_ref16) {
  var borderRadius = _ref16.borderRadius;
  return borderRadius;
}, function (_ref17) {
  var border = _ref17.border;
  return border;
}, function (_ref18) {
  var color = _ref18.color;
  return color;
}, function (_ref19) {
  var fontSize = _ref19.fontSize;
  return fontSize;
}, function (_ref20) {
  var fontWeight = _ref20.fontWeight;
  return fontWeight;
}, function (_ref21) {
  var lineHeight = _ref21.lineHeight;
  return lineHeight;
}, function (_ref22) {
  var boxShadow = _ref22.boxShadow;
  return boxShadow;
}, function (_ref23) {
  var className = _ref23.className;
  return className;
});
var StyledTable$1 = styled.table(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-family: inherit, sans-serif;\n  box-sizing: border-box;\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  border: ", ";\n  border-radius: ", ";\n  & thead {\n    background-color: ", ";\n  }\n  & tr > th {\n    padding: ", ";\n    border-bottom: ", ";\n    font-weight: 400;\n    font-size: ", "px;\n    color: ", ";\n    text-align: ", ";\n  }\n  & tr > td {\n    white-space: nowrap;\n    padding: ", ";\n    border-bottom: ", ";\n    font-size: ", "px;\n    color: ", ";\n    text-align: ", ";\n  }\n  & tr > td.error-row {\n    color: ", " !important;\n    background-color: ", ";\n    // border-bottom: none;\n  }\n  & tr.error-row {\n    color: ", " !important;\n    background-color: ", ";\n    // border-bottom: none;\n  }\n  & tbody tr:last-child td {\n    border-bottom: none;\n  }\n"])), function (prop) {
  return prop.border && prop.border;
}, function (prop) {
  return prop.cornerRadius ? prop.cornerRadius : '5px';
}, function (prop) {
  return prop.headerBackgroundColor && prop.headerBackgroundColor;
}, function (prop) {
  return prop.padding ? prop.padding : '16px';
}, function (prop) {
  return prop.border ? prop.border : '1px solid #E1E3E5';
}, function (prop) {
  return prop.headingFontSize ? prop.headingFontSize : '14';
}, function (prop) {
  return prop.headingColor ? prop.headingColor : '#707070';
}, function (prop) {
  return prop.headingAlign ? prop.headingAlign : 'center';
}, function (prop) {
  return prop.padding ? prop.padding : '8px';
}, function (prop) {
  return prop.border ? prop.border : '1px solid #E1E3E5';
}, function (prop) {
  return prop.contentFontSize ? prop.contentFontSize : '14';
}, function (prop) {
  return prop.contentColor ? prop.contentColor : '#000000';
}, function (prop) {
  return prop.contentAlign ? prop.contentAlign : 'start';
}, function (prop) {
  return prop.errorContentColor && prop.errorContentColor;
}, function (prop) {
  return prop.errorBgColor && prop.errorBgColor;
}, function (prop) {
  return prop.errorContentColor && prop.errorContentColor;
}, function (prop) {
  return prop.errorBgColor && prop.errorBgColor;
});
var StyledContainer$1 = styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n  overflow: auto;\n  max-height: 40vh;\n  // border: 1px solid #e1e3e5;\n  border-radius: 5px;\n"])));
styled.input(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  border: none;\n  margin: 0;\n  padding: 0;\n  &::placeholder {\n    color: #707070;\n  }\n  &:focus,\n  &:focus-visible {\n    outline: none;\n  }\n  box-shadow: none;\n  font-family: inherit;\n  caret-color: transparent; /* Hides the caret */\n  resize: none; /* Prevents resizing */\n\n  ", "\n"])), function (props) {
  return props.disabled && "\n    background-color: #f2f2f2;\n    pointer-events: none;\n  ";
});

var _templateObject$e;
var StyledComponent = styled.p(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n  font-size: ", ";\n  text-align: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  color: ", ";\n  overflow: ", ";\n  text-overflow: ", ";\n  white-space: ", ";\n  margin: ", ";\n  max-width: ", ";\n  overflow-wrap: ", ";\n  word-break: ", ";\n  padding ", ";\n  background-color ", ";\n  border-radius ", ";\n  cursor: ", ";\n  width: ", ";\n"])), function (prop) {
  return prop.textSize || '14px';
}, function (prop) {
  return prop.textAlign || 'start';
}, function (prop) {
  return prop.fontFamily || 'inherit';
}, function (prop) {
  return prop.fontWeight || 400;
}, function (prop) {
  return prop.fontStyle || 'normal';
}, function (prop) {
  return prop.color || '#000000';
}, function (prop) {
  return prop.overflow || 'visible';
}, function (prop) {
  return prop.textOverflow || 'clip';
}, function (prop) {
  return prop.whiteSpace || 'normal';
}, function (prop) {
  return prop.margin || '0';
}, function (prop) {
  return prop.maxWidth || '100%';
}, function (prop) {
  return prop.overflowWrap || 'break-word';
}, function (prop) {
  return prop.wrapMode || 'break-word';
}, function (prop) {
  return prop.padding || '0';
}, function (prop) {
  return prop.backgroundcolor || 'transparent';
}, function (prop) {
  return prop.borderRadius || '0';
}, function (prop) {
  return prop.cursor || 'none';
}, function (prop) {
  return prop.width;
});
var Text = function Text(_ref) {
  var children = _ref.children,
    _ref$as = _ref.as,
    as = _ref$as === undefined ? 'p' : _ref$as,
    textSize = _ref.textSize,
    textAlign = _ref.textAlign,
    fontFamily = _ref.fontFamily,
    fontWeight = _ref.fontWeight,
    fontStyle = _ref.fontStyle,
    color = _ref.color,
    overflow = _ref.overflow,
    textOverflow = _ref.textOverflow,
    whiteSpace = _ref.whiteSpace,
    margin = _ref.margin,
    maxWidth = _ref.maxWidth,
    overflowWrap = _ref.overflowWrap,
    wordBreak = _ref.wordBreak,
    padding = _ref.padding,
    backgroundcolor = _ref.backgroundcolor,
    borderRadius = _ref.borderRadius,
    cursor = _ref.cursor,
    width = _ref.width,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === undefined ? function () {} : _ref$onClick;
  return /*#__PURE__*/React.createElement(StyledComponent, {
    as: as,
    textSize: textSize,
    textAlign: textAlign,
    fontFamily: fontFamily,
    fontWeight: fontWeight,
    fontStyle: fontStyle,
    color: color,
    overflow: overflow,
    textOverflow: textOverflow,
    whiteSpace: whiteSpace,
    margin: margin,
    maxWidth: maxWidth,
    overflowWrap: overflowWrap,
    wordBreak: wordBreak,
    padding: padding,
    backgroundcolor: backgroundcolor,
    borderRadius: borderRadius,
    cursor: cursor,
    width: width,
    onClick: onClick
  }, children);
};

var _templateObject$d;
var Line = styled.div(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  ", ";\n  background-color: ", ";\n\n  & > * {\n    display: none;\n  }\n"])), function (props) {
  return props.type === 'Vertical' ? "\n      width: ".concat(props.thickness ? props.thickness : 1, "px;\n      height: 100%;\n    ") : "\n      height: ".concat(props.thickness ? props.thickness : 1, "px;\n      width: 100%;\n    ");
}, function (prop) {
  return prop.color ? prop.color : '#DEDEDE';
});
var Divider = function Divider(_ref) {
  var _ref$thickness = _ref.thickness,
    thickness = _ref$thickness === undefined ? 1 : _ref$thickness,
    _ref$color = _ref.color,
    color = _ref$color === undefined ? 'rgba(222, 222, 222, 1)' : _ref$color,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === undefined ? '#000' : _ref$textColor,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === undefined ? '12px' : _ref$fontSize,
    _ref$text = _ref.text,
    text = _ref$text === undefined ? '' : _ref$text,
    _ref$margin = _ref.margin,
    margin = _ref$margin === undefined ? '0px' : _ref$margin,
    _ref$type = _ref.type,
    type = _ref$type === undefined ? 'Horizontal' : _ref$type,
    mainHeight = _ref.mainHeight;
  return /*#__PURE__*/React.createElement(FlexDiv, {
    ai: "center",
    flexdir: type === 'Vertical' ? 'column' : 'row',
    height: mainHeight,
    width: "100%"
  }, /*#__PURE__*/React.createElement(Line, {
    thickness: thickness,
    color: color,
    type: type
  }, /*#__PURE__*/React.createElement("div", null)), text && (/*#__PURE__*/React.createElement(Text, {
    margin: margin,
    color: textColor,
    textSize: fontSize
  }, text)), /*#__PURE__*/React.createElement(Line, {
    thickness: thickness,
    color: color,
    type: type
  }, /*#__PURE__*/React.createElement("div", null)));
};

var _templateObject$c;
var Inline = styled.div(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n  font-family:\n    ", ", sans-serif;\n  font-size: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  text-align: ", ";\n  box-sizing: border-box;\n  width: ", ";\n  height: ", ";\n  display: flex;\n  flex-direction: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  gap: ", ";\n  padding: ", ";\n  margin: ", ";\n  border: ", ";\n  border-radius: ", ";\n  flex-wrap: ", ";\n  color: ", ";\n  background-color: ", ";\n"])), function (prop) {
  return prop.fontFamily ? prop.fontFamily : 'inherit';
}, function (prop) {
  return prop.textSize && prop.textSize;
}, function (prop) {
  return prop.fontWeight && fontWeight[prop.fontWeight];
}, function (prop) {
  return prop.fontStyle && prop.fontStyle;
}, function (prop) {
  return prop.textAlign && prop.textAlign;
}, function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (prop) {
  return prop.direction && alignment[prop.direction];
}, function (prop) {
  return prop.horizontalAlign && alignment[prop.horizontalAlign];
}, function (prop) {
  return prop.verticalAlign && alignment[prop.verticalAlign];
}, function (prop) {
  return prop.gap && prop.gap;
}, function (prop) {
  return prop.padding && prop.padding;
}, function (prop) {
  return prop.margin && prop.margin;
}, function (prop) {
  return prop.border && prop.border;
}, function (prop) {
  return prop.cornerRadius && prop.cornerRadius;
}, function (prop) {
  return prop.wrap === false ? 'nowrap' : 'wrap';
}, function (prop) {
  return prop.color && prop.color;
}, function (prop) {
  return prop.bgColor && prop.bgColor;
});
var InlineLayout = function InlineLayout(_ref) {
  var id = _ref.id,
    _ref$verticalAlign = _ref.verticalAlign,
    verticalAlign = _ref$verticalAlign === undefined ? 'center' : _ref$verticalAlign,
    _ref$horizontalAlign = _ref.horizontalAlign,
    horizontalAlign = _ref$horizontalAlign === undefined ? 'center' : _ref$horizontalAlign,
    _ref$direction = _ref.direction,
    direction = _ref$direction === undefined ? 'normal' : _ref$direction,
    gap = _ref.gap,
    wrap = _ref.wrap,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === undefined ? 'start' : _ref$textAlign,
    textSize = _ref.textSize,
    fontFamily = _ref.fontFamily,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === undefined ? 400 : _ref$fontWeight,
    _ref$fontStyle = _ref.fontStyle,
    fontStyle = _ref$fontStyle === undefined ? 'normal' : _ref$fontStyle,
    bgColor = _ref.bgColor,
    color = _ref.color,
    padding = _ref.padding,
    margin = _ref.margin,
    border = _ref.border,
    cornerRadius = _ref.cornerRadius,
    children = _ref.children,
    _ref$height = _ref.height,
    height = _ref$height === undefined ? '100%' : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === undefined ? '100%' : _ref$width;
  return /*#__PURE__*/React.createElement(Inline, {
    id: id,
    verticalAlign: verticalAlign,
    horizontalAlign: horizontalAlign,
    direction: direction,
    gap: gap,
    textAlign: textAlign,
    textSize: textSize,
    fontFamily: fontFamily,
    fontWeight: fontWeight,
    fontStyle: fontStyle,
    bgColor: bgColor,
    color: color,
    wrap: wrap,
    padding: padding,
    margin: margin,
    border: border,
    cornerRadius: cornerRadius,
    height: height,
    width: width
  }, children);
};

var _templateObject$b;
var StyledSpinner = styled.span(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n  height: 100%;\n  min-height: 20px;\n  min-width: 20px;\n  border: 2px solid ", ";\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n\n  @keyframes rotation {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"])), function (prop) {
  return prop.color ? prop.color : '#000';
});
var Spinner = function Spinner(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React.createElement(StyledSpinner, {
    color: color
  });
};

var _templateObject$a, _templateObject2$2;
// styling the button component based on props
var StyledButton = styled.button(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: flex;\n  justify-content: ", ";\n  align-items: center;\n  ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: ", ";\n  font-family: ", ", sans-serif;\n  font-size: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  transition: all 0.2s ease-in-out;\n  opacity: ", ";\n  white-space: ", ";\n  width: max-content;\n  background-color: ", ";\n  margin: ", ";\n\n  color: ", ";\n\n  cursor: ", ";\n\n  text-decoration: ", ";\n  align-self: ", ";\n\n  & .icon-before {\n    display: inherit;\n    margin-right: ", "px;\n    margin-top: auto;\n    margin-bottom: auto;\n    svg {\n      width: ", "px;\n      height: ", "px;\n    }\n  }\n\n  & .icon-after {\n    display: inherit;\n    margin-left: ", "px;\n    margin-top: auto;\n    margin-bottom: auto;\n    svg {\n      width: ", "px;\n      height: ", "px;\n    }\n  }\n\n  //&.primary:hover {\n  //    background-color: #ffffff;\n  //    color: #121212;\n  //}\n  //&.secondary:hover {\n  //    background-color: #dedede;\n  //}\n  //&.plain:hover {\n  //    background-color: #dedede;\n  //}\n  //\n  // figure out the hover animations later\n"])), function (props) {
  return props.textAlign && alignment[props.textAlign];
}, function (props) {
  return props.fullWidth && 'width: 100%';
}, function (props) {
  return props.borderColor;
}, function (prop) {
  return prop.cornerRadius && prop.cornerRadius;
}, function (props) {
  return props.padding ? props.padding : props.kind === 'plain' ? '0' : '12px 22px';
}, function (props) {
  return props.fontFamily && props.fontFamily;
}, function (props) {
  return props.textSize && props.textSize;
}, function (props) {
  return props.fontWeight && fontWeight[props.fontWeight];
}, function (props) {
  return props.fontStyle && props.fontStyle;
}, function (props) {
  return props.disabled ? 0.5 : 1;
}, function (props) {
  return props.whitespace;
}, function (props) {
  return props.bgColor ? props.bgColor : props.kind === 'primary' ? '#121212' : 'transparent';
}, function (prop) {
  return prop.margin && prop.margin;
}, function (props) {
  return props.color ? props.color : props.kind === 'primary' ? '#ffffff' : '#121212';
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.kind === 'underline' && 'underline';
}, function (props) {
  return props.alignSelf && props.alignSelf;
}, function (props) {
  return props.iconSpacing && props.iconSpacing;
}, function (props) {
  return props.iconBeforeSize && props.iconBeforeSize;
}, function (props) {
  return props.iconBeforeSize && props.iconBeforeSize;
}, function (props) {
  return props.iconSpacing && props.iconSpacing;
}, function (props) {
  return props.iconAfterSize && props.iconAfterSize;
}, function (props) {
  return props.iconAfterSize && props.iconAfterSize;
});
var Button = function Button(_ref) {
  var id = _ref.id,
    _ref$kind = _ref.kind,
    kind = _ref$kind === undefined ? 'primary' : _ref$kind,
    padding = _ref.padding,
    _ref$cornerRadius = _ref.cornerRadius,
    cornerRadius = _ref$cornerRadius === undefined ? '4px' : _ref$cornerRadius,
    bgColor = _ref.bgColor,
    color = _ref.color,
    textSize = _ref.textSize,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === undefined ? 'center' : _ref$textAlign,
    _ref$fontFamily = _ref.fontFamily,
    fontFamily = _ref$fontFamily === undefined ? 'inherit' : _ref$fontFamily,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === undefined ? 'medium' : _ref$fontWeight,
    _ref$fontStyle = _ref.fontStyle,
    fontStyle = _ref$fontStyle === undefined ? 'normal' : _ref$fontStyle,
    iconBefore = _ref.iconBefore,
    iconAfter = _ref.iconAfter,
    _ref$iconBeforeSize = _ref.iconBeforeSize,
    iconBeforeSize = _ref$iconBeforeSize === undefined ? 24 : _ref$iconBeforeSize,
    _ref$iconAfterSize = _ref.iconAfterSize,
    iconAfterSize = _ref$iconAfterSize === undefined ? 24 : _ref$iconAfterSize,
    _ref$iconSpacing = _ref.iconSpacing,
    iconSpacing = _ref$iconSpacing === undefined ? 10 : _ref$iconSpacing,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === undefined ? false : _ref$fullWidth,
    children = _ref.children,
    onClick = _ref.onClick,
    loading = _ref.loading,
    disabled = _ref.disabled,
    borderColor = _ref.borderColor,
    _ref$whitespace = _ref.whitespace,
    whitespace = _ref$whitespace === undefined ? 'normal' : _ref$whitespace,
    spinnerColor = _ref.spinnerColor,
    margin = _ref.margin,
    alignSelf = _ref.alignSelf;
  return /*#__PURE__*/React.createElement(StyledButton, {
    id: id,
    kind: kind,
    padding: padding,
    cornerRadius: cornerRadius,
    bgColor: bgColor,
    color: color,
    textSize: textSize,
    textAlign: textAlign,
    fontWeight: fontWeight,
    fontStyle: fontStyle,
    iconBefore: iconBefore,
    iconAfter: iconAfter,
    iconBeforeSize: iconBeforeSize,
    iconAfterSize: iconAfterSize,
    iconSpacing: iconSpacing,
    fullWidth: fullWidth,
    onClick: onClick,
    disabled: disabled,
    style: {
      fontFamily: fontFamily
    },
    alignSelf: alignSelf,
    borderColor: borderColor ? borderColor : kind === 'secondary' ? '#dedede' : 'transparent',
    whitespace: whitespace,
    margin: margin
  }, loading && (/*#__PURE__*/React.createElement(StyledSpinnerCon, null, /*#__PURE__*/React.createElement(Spinner, {
    color: spinnerColor
  }))), !loading && iconBefore && (/*#__PURE__*/React.createElement("span", {
    className: "icon-before"
  }, iconBefore)), !loading && children, !loading && iconAfter && /*#__PURE__*/React.createElement("span", {
    className: "icon-after"
  }, iconAfter));
};
var StyledSpinnerCon = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 4vw;\n"])));

var _templateObject$9;
var StyledBadge = styled.button(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  font-family:\n    ", ", sans-serif;\n  font-size: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: ", ";\n  gap: 5px;\n\n  & img {\n    margin-right: 4px;\n    width: 14px;\n    height: 14px;\n  }\n"])), function (prop) {
  return prop.fontFamily ? prop.fontFamily : 'inherit';
}, function (prop) {
  return prop.textSize && prop.textSize;
}, function (prop) {
  return prop.fontWeight && fontWeight[prop.fontWeight];
}, function (prop) {
  return prop.fontStyle && prop.fontStyle;
}, function (prop) {
  return prop.bgColor ? prop.bgColor : tone[prop.kind];
}, function (prop) {
  return prop.color ? prop.color : text[prop.kind];
}, function (prop) {
  return prop.size === 'small' ? '1px 7px' : prop.size === 'medium' ? '2px 8px' : prop.size === 'large' && prop.size || '4px 8px';
}, function (prop) {
  return prop.borderColor ? prop.borderColor : prop.kind === 'plain' ? '#DEDEDE' : 'transparent';
}, function (prop) {
  return prop.shape === 'round' ? '20px' : '10px';
});
var Badge = function Badge(_ref) {
  var _ref$kind = _ref.kind,
    kind = _ref$kind === undefined ? 'default' : _ref$kind,
    textSize = _ref.textSize,
    fontFamily = _ref.fontFamily,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === undefined ? 'normal' : _ref$fontWeight,
    _ref$fontStyle = _ref.fontStyle,
    fontStyle = _ref$fontStyle === undefined ? 'normal' : _ref$fontStyle,
    bgColor = _ref.bgColor,
    color = _ref.color,
    _ref$size = _ref.size,
    size = _ref$size === undefined ? 'large' : _ref$size,
    _ref$shape = _ref.shape,
    shape = _ref$shape === undefined ? 'round' : _ref$shape,
    icon = _ref.icon,
    _ref$children = _ref.children,
    children = _ref$children === undefined ? 'Badge' : _ref$children,
    borderColor = _ref.borderColor;
  return /*#__PURE__*/React.createElement(StyledBadge, {
    "data-testid": "testid",
    kind: kind,
    textSize: textSize,
    fontWeight: fontWeight,
    fontStyle: fontStyle,
    bgColor: bgColor,
    color: color,
    size: size,
    shape: shape,
    icon: icon,
    style: {
      fontFamily: fontFamily
    },
    borderColor: borderColor
  }, icon, " ", children);
};

var _getMdComponentAst = function getMdComponentAst(ast) {
  var components = {
    title: {
      component: 'heading',
      type: 'block',
      attributes: [{
        key: 'rank',
        value: 'level'
      }]
    },
    text: {
      component: 'paragraph',
      type: 'component'
    },
    textWithBlock: {
      component: 'paragraph',
      type: 'block'
    },
    italic: {
      component: 'italic',
      type: 'block',
      properties: {
        fontStyle: 'italic'
      }
    },
    bold: {
      component: 'bold',
      type: 'block',
      properties: {
        fontWeight: '700'
      }
    },
    break: {
      component: 'break',
      type: 'component'
    }
  };
  var componentAst = [];
  // creating a new ast based on our logic to concatenate all the blocks in one single array
  addLineBreaksInMdAst(ast).forEach(function (node) {
    var nodeType = node.type;
    var componentToUse = components[nodeType];
    // check if component is not found then use default ones
    if (!componentToUse) {
      nodeType = (node === null || node === undefined ? undefined : node.block) ? 'textWithBlock' : 'text';
      componentToUse = components[nodeType];
    }
    var _componentToUse = componentToUse,
      properties = _componentToUse.properties,
      attributes = _componentToUse.attributes,
      component = _componentToUse.component;
    // creating a sub node with component and properties
    // sub node is basically a new node with modified properties
    var subNode = {
      component: component
    };
    // looping over all the attributes to extract property from node and reassign with different key
    // eslint-disable-next-line no-unused-expressions
    attributes === null || attributes === undefined ? undefined : attributes.forEach(function (attribute) {
      subNode[attribute.value] = node[attribute.key];
    });
    if (properties) subNode.props = properties;
    //  we again recursively call the function to get the block nodes
    // blocks are same as of nodes
    if (components[nodeType].type === 'block' && node.block) {
      subNode.blocks = _getMdComponentAst(node.block.map(function (block) {
        return Object.assign(Object.assign({}, block), {
          // we keep these fields same as parent ones to keep them unique
          // because blocks are normal blocks without any info about parents
          type: nodeType,
          rank: node.rank,
          bullet: node.bullet
        });
      }));
    } else {
      subNode.content = (node === null || node === undefined ? undefined : node.text) || '';
    }
    subNode.bullet = (node === null || node === undefined ? undefined : node.bullet) || '';
    componentAst.push(subNode);
  });
  return componentAst;
};
// creates a new ast with line breaks as separate nodes all line breaks are extracted from strings
var addLineBreaksInMdAst = function addLineBreaksInMdAst(ast) {
  var updatedAst = [];
  ast.forEach(function (node, i) {
    var _a, _b;
    // checks for line breaks in the text
    if ((_a = node === null || node === undefined ? undefined : node.text) === null || _a === undefined ? undefined : _a.includes('\n')) {
      // split string by line breaks and add each line as a separate node
      var astWithBreaks = node.text.split('\n').reduce(function (acc, content, index) {
        // first push line break and then content
        if (index) acc.push('\n');
        if (content !== '') acc.push(content);
        return acc;
      }, []);
      // based on line breaks, add break or text nodes
      astWithBreaks.forEach(function (content) {
        updatedAst.push({
          type: content === '\n' ? 'break' : node.type,
          text: content
        });
      });
    }
    // checks for list followed by list because it should have a line break after every list item
    else if (node.type === 'list' && ((_b = ast === null || ast === undefined ? undefined : ast[i + 1]) === null || _b === undefined ? undefined : _b.type) === 'list') {
      updatedAst.push(node);
      updatedAst.push({
        type: 'break',
        text: '\n'
      });
    } else updatedAst.push(node);
  });
  return updatedAst;
};
var Heading = function Heading(props) {
  return /*#__PURE__*/React.createElement(Text, Object.assign({
    fontWeight: "600"
  }, props));
};
var MdComponentsConfig = {
  heading: {
    component: Heading,
    additionalProps: {
      level: {
        name: 'textSize',
        values: {
          1: '20px',
          2: '16px',
          3: '14px'
        }
      },
      textAlign: {
        name: 'textAlign'
      },
      fontFamily: {
        name: 'fontFamily'
      }
    }
  },
  paragraph: {
    component: Text,
    additionalProps: {
      fontSize: {
        name: 'textSize'
      },
      textAlign: {
        name: 'textAlign'
      },
      color: {
        name: 'color'
      },
      fontWeight: {
        name: 'fontWeight'
      },
      fontFamily: {
        name: 'fontFamily'
      }
    }
  },
  italic: {
    component: Text,
    props: {
      fontStyle: 'italic'
    },
    additionalProps: {
      fontSize: {
        name: 'textSize'
      },
      textAlign: {
        name: 'textAlign'
      },
      color: {
        name: 'color'
      },
      fontWeight: {
        name: 'fontWeight'
      },
      fontFamily: {
        name: 'fontFamily'
      }
    }
  },
  bold: {
    component: Text,
    props: {
      fontWeight: '600'
    },
    additionalProps: {
      fontSize: {
        name: 'textSize'
      },
      textAlign: {
        name: 'textAlign'
      },
      color: {
        name: 'color'
      },
      fontFamily: {
        name: 'fontFamily'
      }
    }
  }
};
var getProps = function getProps(componentType, props) {
  var _a;
  var componentProps = {};
  Object.keys(props).forEach(function (prop) {
    var _a, _b;
    // based on props from config we extract additional props
    var propConfig = (_b = (_a = MdComponentsConfig[componentType]) === null || _a === undefined ? undefined : _a.additionalProps) === null || _b === undefined ? undefined : _b[prop];
    if (propConfig) {
      // if prop exist we assign it to component props
      var propName = propConfig.name;
      componentProps[propName] = propConfig.values ? propConfig.values[props[prop]] : props[prop];
    }
  });
  // extracting existing props from config
  var existingProps = ((_a = MdComponentsConfig[componentType]) === null || _a === undefined ? undefined : _a.props) || {};
  return Object.assign(Object.assign({}, componentProps), existingProps);
};
// now from our own ast we extract components based on line breaks
var getMdComponentsFromMd = function getMdComponentsFromMd(mdAst) {
  var additionalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  //  components are 2 level array, f
  // first level is for vertical displaying components
  // and inside first there's nested second level which is used to display components horizontally
  // [              ---> first level vertical
  //   ['level 1']           ---> second level horizontal
  //   ['level 2']
  // ],
  // [
  //  ['level 3']
  // ]
  // it will look something like this in preview
  // level 1 level 2
  // level 3
  var components = [[]];
  // tracking index of second level of array
  var nestedComponentActiveIndex = 0;
  var handleBreak = function handleBreak(node) {
    var noOfEmptyLines =
    // - 2 because one break is used to change the line
    node.content.replaceAll('\n', 'b').split('b').length - 2;
    var areMultipleLineBreaks = noOfEmptyLines > 0;
    // if the nested array exist then we push a text element with
    // hidden white color for line break to be visible
    if (components[nestedComponentActiveIndex] && !areMultipleLineBreaks) components[nestedComponentActiveIndex].push(/*#__PURE__*/React.createElement("div", {
      style: {
        color: 'transparent'
      }
    }, "h"));
    // if there're multiple line breaks then push hidden text elem for each line break
    if (areMultipleLineBreaks) for (var index = 0; index < noOfEmptyLines; index += 1) {
      components.push([]);
      // after each line break we increment the index of nested array
      // so it goes to next line
      nestedComponentActiveIndex += 1;
      components[nestedComponentActiveIndex].push(/*#__PURE__*/React.createElement("div", {
        style: {
          color: 'transparent'
        }
      }, "h"));
    }
    // at last we again push an empty nested array so all other elements can be in same level
    components.push([]);
    nestedComponentActiveIndex += 1;
  };
  mdAst.forEach(function (node) {
    // if there're blocks we first concatenate all the blocks in one single array
    if (node.blocks) {
      node.blocks.forEach(function (block) {
        // handling breaks in block
        if (block.component === 'break') handleBreak(block);else {
          var ComponentToUse = MdComponentsConfig[block.component].component;
          // we extract all the component props from config which component needs
          var props = getProps(block.component, Object.assign(Object.assign({}, block), additionalProps));
          // at last we push nested components in nested array
          components[nestedComponentActiveIndex].push(/*#__PURE__*/React.createElement(ComponentToUse, Object.assign({
            as: 'span'
          }, props), block.bullet || '', " ", block.content));
        }
      });
    } else if (node.component === 'break') {
      handleBreak(node);
    } else {
      // if it's not a block we repeat above steps but for node
      var ComponentToUse = MdComponentsConfig[node.component].component;
      var props = getProps(node.component, Object.assign(Object.assign({}, node), additionalProps));
      components[nestedComponentActiveIndex].push(/*#__PURE__*/React.createElement(ComponentToUse, Object.assign({
        as: 'span'
      }, props), node.bullet || '', " ", node.content));
    }
  });
  return components;
};
var verticalAlign = {
  left: 'start',
  center: 'end',
  right: 'center'
};
var getMd = function getMd() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var props = arguments.length > 1 ? arguments[1] : undefined;
  var width = arguments.length > 2 ? arguments[2] : undefined;
  var alignment = arguments.length > 3 ? arguments[3] : undefined;
  var ast = md(string); // returns md from library
  var mdd = _getMdComponentAst(ast); // modifies md to our own ast
  var components = getMdComponentsFromMd(mdd, props); // creating component tree from our mdd ast
  return /*#__PURE__*/React.createElement(BlockLayout, {
    width: width,
    flexdir: "column",
    verticalAlign: verticalAlign[alignment]
  }, components.map(function (subComponents) {
    return /*#__PURE__*/React.createElement(InlineLayout, {
      horizontalAlign: 'start'
    }, subComponents.length > 0 ? subComponents.reduce(function (acc, component, index) {
      // If it's the first element, just return it
      if (index === 0) return component;
      // Otherwise, clone the accumulated elements and add the new component
      return /*#__PURE__*/React.cloneElement(acc, {}, [].concat(_toConsumableArray(React.Children.toArray(acc.props.children)), [component]));
    }) : null);
  }));
};
var useMd = function useMd() {
  return function (string, props, alignment) {
    return getMd(string, props, alignment);
  };
};
var MdText = function MdText(_ref) {
  var children = _ref.children,
    fontSize = _ref.fontSize,
    alignment = _ref.alignment,
    color = _ref.color,
    fontWeight = _ref.fontWeight,
    fontFamily = _ref.fontFamily,
    width = _ref.width;
  var md = useMd();
  return md(children, {
    fontSize: fontSize,
    alignment: alignment,
    color: color,
    fontWeight: fontWeight,
    fontFamily: fontFamily
  }, width, alignment);
};

var _templateObject$8;
var Dialog$1 = styled.dialog(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  font-family:\n    ", ", sans-serif;\n  font-size: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  text-align: ", ";\n  box-sizing: border-box;\n  width: ", ";\n  max-width: 950px;\n  min-width: 300px;\n  padding: 0;\n  border: none;\n  color: ", ";\n  background-color: ", ";\n  border-radius: 11px;\n  &::backdrop {\n    background-color: #0000007f;\n    opacity: 100%;\n  }\n  box-shadow:\n    0 -2px 4px rgba(0, 0, 0, 0.08),\n    0 1px 1px rgba(0, 0, 0, 0.028),\n    0 3px 3px rgba(0, 0, 0, 0.035),\n    0 6px 6px rgba(0, 0, 0, 0.045),\n    0 12px 12px rgba(0, 0, 0, 0.055),\n    0 32px 32px rgba(0, 0, 0, 0.08);\n"])), function (prop) {
  return prop.fontFamily ? prop.fontFamily : 'inherit';
}, function (prop) {
  return prop.textSize && prop.textSize;
}, function (prop) {
  return prop.fontWeight && fontWeight[prop.fontWeight];
}, function (prop) {
  return prop.fontStyle && prop.fontStyle;
}, function (prop) {
  return prop.textAlign && prop.textAlign;
}, function (prop) {
  return prop.isMobile ? '90vw' : '60vw';
}, function (prop) {
  return prop.color && prop.color;
}, function (prop) {
  return prop.bgColor && prop.bgColor;
});
var Modal = function Modal(_ref) {
  var openModal = _ref.openModal,
    closeModal = _ref.closeModal;
    _ref.back;
    var _ref$title = _ref.title,
    title = _ref$title === undefined ? 'Modal' : _ref$title,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === undefined ? 'start' : _ref$textAlign,
    textSize = _ref.textSize,
    fontFamily = _ref.fontFamily,
    fontWeight = _ref.fontWeight,
    _ref$fontStyle = _ref.fontStyle,
    fontStyle = _ref$fontStyle === undefined ? 'normal' : _ref$fontStyle,
    bgColor = _ref.bgColor,
    color = _ref.color,
    locationFontFamily = _ref.locationFontFamily,
    locationColor = _ref.locationColor,
    locationTextSize = _ref.locationTextSize,
    selectedLocationDisplayName = _ref.selectedLocationDisplayName,
    hideLocationOptions = _ref.hideLocationOptions,
    children = _ref.children,
    _ref$isAdmin = _ref.isAdmin,
    isAdmin = _ref$isAdmin === undefined ? false : _ref$isAdmin,
    _ref$isInternalDashbo = _ref.isInternalDashboard,
    isInternalDashboard = _ref$isInternalDashbo === undefined ? false : _ref$isInternalDashbo;
  var ref = useRef(null);
  useEffect(function () {
    var _a, _b;
    if (openModal) {
      (_a = ref.current) === null || _a === undefined ? undefined : _a.showModal();
    } else {
      (_b = ref.current) === null || _b === undefined ? undefined : _b.close();
    }
  }, [openModal]);
  var handleCancel = function handleCancel(e) {
    e.preventDefault();
    if (e.target === ref.current) {
      closeModal();
    }
  };
  return /*#__PURE__*/React.createElement(ModalWrapper, {
    ref: ref,
    isAdmin: isAdmin,
    isInternalDashboard: isInternalDashboard,
    closeModal: closeModal,
    handleCancel: handleCancel
  }, /*#__PURE__*/React.createElement(BlockLayout, {
    gap: '0px',
    height: "auto",
    cornerRadius: 'inherit'
  }, /*#__PURE__*/React.createElement(InlineLayout, {
    padding: '21px 14px',
    bgColor: bgColor,
    horizontalAlign: "between",
    wrap: false,
    height: "auto",
    cornerRadius: "11px 11px 0 0"
  }, /*#__PURE__*/React.createElement(InlineLayout, {
    horizontalAlign: "start",
    textSize: textSize,
    fontFamily: fontFamily,
    textAlign: textAlign,
    fontWeight: fontWeight,
    fontStyle: fontStyle,
    color: color,
    gap: "7px",
    height: "auto",
    wrap: false,
    width: "auto"
  }, /*#__PURE__*/React.createElement(MdText, {
    fontSize: textSize,
    alignment: textAlign,
    color: color,
    fontWeight: fontWeight,
    fontFamily: fontFamily,
    width: 'auto'
  }, title), !hideLocationOptions && /*#__PURE__*/React.createElement(Badge, {
    kind: "plain",
    icon: /*#__PURE__*/React.createElement(Marker, {
      color: locationColor,
      size: locationTextSize
    }),
    bgColor: bgColor,
    textSize: locationTextSize,
    fontFamily: locationFontFamily,
    fontWeight: 'medium',
    color: locationColor,
    borderColor: "".concat(locationColor, "33"),
    size: "0 7px"
  }, selectedLocationDisplayName)), /*#__PURE__*/React.createElement(Button, {
    kind: "plain",
    padding: "0",
    onClick: closeModal,
    iconSpacing: 0
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    color: color,
    size: 18
  }))), /*#__PURE__*/React.createElement(Divider, {
    color: '#F5F5F5'
  }), children));
};
var ModalWrapper = /*#__PURE__*/forwardRef(function (_a, ref) {
  var handleCancel = _a.handleCancel,
    isAdmin = _a.isAdmin,
    isInternalDashboard = _a.isInternalDashboard,
    children = _a.children,
    otherProps = __rest(_a, ["handleCancel", "isAdmin", "isInternalDashboard", "children"]);
  var isMobile = window.innerWidth < 768;
  if (isAdmin || isInternalDashboard) return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      width: '100%',
      borderRadius: '11px',
      backgroundColor: '#FFFFFF',
      boxShadow: "0 -2px 4px rgba(0, 0, 0, 0.08),\n            0 1px 1px rgba(0, 0, 0, 0.028),\n            0 3px 3px rgba(0, 0, 0, 0.035),\n            0 6px 6px rgba(0, 0, 0, 0.045),\n            0 12px 12px rgba(0, 0, 0, 0.055),\n            0 32px 32px rgba(0, 0, 0, 0.08)"
    },
    id: 'mrca-dialog'
  }, children);
  return /*#__PURE__*/React.createElement(Dialog$1, Object.assign({
    id: 'mrca-dialog',
    ref: ref,
    isMobile: isMobile
  }, otherProps, {
    onCancel: function onCancel(e) {
      return handleCancel(e);
    }
  }), children);
});
var Marker = function Marker(_ref2) {
  var _ref2$color = _ref2.color,
    color = _ref2$color === undefined ? '#000000' : _ref2$color,
    _ref2$size = _ref2.size,
    size = _ref2$size === undefined ? '14px' : _ref2$size;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1C5.686 1 3 3.686 3 7c0 3.5 3.5 7.5 6 9.5 2.5-2 6-6 6-9.5 0-3.314-2.686-6-6-6Zm0 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z",
    fill: color
  }));
};
var CloseIcon = function CloseIcon(_ref3) {
  var _ref3$color = _ref3.color,
    color = _ref3$color === undefined ? '#000000' : _ref3$color,
    _ref3$size = _ref3.size,
    size = _ref3$size === undefined ? 18 : _ref3$size;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.80011 4.80078L12.0001 12.0008M19.2001 19.2008L12.0001 12.0008M12.0001 12.0008L19.2001 4.80078M12.0001 12.0008L4.80011 19.2008",
    stroke: color,
    "stroke-width": "1.4",
    "stroke-linecap": "round"
  }));
};

var ModalContainer = function ModalContainer(_ref) {
  var isOpen = _ref.isOpen,
    exit = _ref.exit,
    stage = _ref.stage,
    goBack = _ref.goBack,
    isAdmin = _ref.isAdmin,
    isInternalDashboard = _ref.isInternalDashboard,
    children = _ref.children,
    titleStyles = _ref.titleStyles,
    headerTitleKeys = _ref.headerTitleKeys,
    locationStyles = _ref.locationStyles,
    hideBackButton = _ref.hideBackButton,
    isShowBackBtn = _ref.isShowBackBtn,
    selectedLocationDisplayName = _ref.selectedLocationDisplayName,
    hideLocationOptions = _ref.hideLocationOptions;
    _ref.csvUploadFormat;
  return /*#__PURE__*/React.createElement(Modal, {
    openModal: isOpen,
    closeModal: exit,
    title: stage === 0 ? 'Select the location you are buying for' : headerTitleKeys.headerTitleText,
    fontFamily: headerTitleKeys.headerTitleFontFamily,
    textSize: "".concat(headerTitleKeys.headerTitleFontSize, "px"),
    color: headerTitleKeys.headerTitleTextColor,
    bgColor: titleStyles.uploadPopupHeaderBackgroundColor,
    back: isShowBackBtn && stage > 0 && !hideBackButton && goBack,
    isAdmin: isAdmin,
    isInternalDashboard: isInternalDashboard,
    fontWeight: '',
    locationColor: locationStyles.locationTextColor,
    locationTextSize: "".concat(locationStyles.locationFontSize, "px"),
    locationFontFamily: locationStyles.locationFontFamily,
    selectedLocationDisplayName: selectedLocationDisplayName,
    hideLocationOptions: hideLocationOptions
  }, children);
};

var Delete = function Delete(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? "#707070" : _ref$color;
  return /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    "clip-path": "url(#clip0_10764_19026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7999 3.50039V1.87039C9.7999 1.61082 9.58948 1.40039 9.3299 1.40039H4.6699C4.41033 1.40039 4.1999 1.61082 4.1999 1.87039V3.50039M9.7999 3.50039H4.1999M9.7999 3.50039H11.1999M12.5999 3.50039H11.1999M4.1999 3.50039H2.7999M1.3999 3.50039H2.7999M2.7999 3.50039V12.1304C2.7999 12.39 3.01033 12.6004 3.2699 12.6004H10.7299C10.9895 12.6004 11.1999 12.39 11.1999 12.1304V3.50039M5.59435 6.30039V9.80039M8.3999 6.30039V9.80039",
    stroke: color,
    "stroke-width": "1.4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10764_19026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "14",
    height: "14",
    fill: "white"
  }))));
};

var _templateObject$7;
var StyledBar = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  box-sizing: border-box;\n  text-align: start;\n  width: inherit;\n  height: 14px;\n  padding: 0;\n\n  & span {\n    position: absolute;\n    box-sizing: border-box;\n    border-radius: 5px;\n    height: 100%;\n    transition: width 0.3s ease-in-out;\n  }\n\n  & span:nth-child(1) {\n    width: 100%;\n    border: 1px solid ", ";\n    background-color: #f5f5f5;\n  }\n\n  & span:nth-child(2) {\n    width: ", "%;\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.titleColor ? "".concat(props.titleColor, "26") : '#dedede';
}, function (props) {
  return props.progress;
}, function (props) {
  return props.titleColor ? "".concat(props.titleColor.toLowerCase(), "cc") : '#3e3e3e';
});
var ProgressBar = function ProgressBar(_ref) {
  var _ref$progress = _ref.progress,
    progress = _ref$progress === undefined ? 0 : _ref$progress,
    title = _ref.title,
    titleTextSize = _ref.titleTextSize,
    titleFontFamily = _ref.titleFontFamily,
    titleColor = _ref.titleColor,
    helperText = _ref.helperText,
    helperTextSize = _ref.helperTextSize,
    helperFontFamily = _ref.helperFontFamily;
  return /*#__PURE__*/React.createElement(BlockLayout, {
    gap: "7px"
  }, /*#__PURE__*/React.createElement(InlineLayout, {
    horizontalAlign: "between",
    fontFamily: titleFontFamily
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      color: titleColor,
      fontSize: titleTextSize
    }
  }, title), /*#__PURE__*/React.createElement("div", {
    style: {
      color: titleColor ? "".concat(titleColor, "80") : "#707070",
      fontSize: titleTextSize
    }
  }, progress, "%")), /*#__PURE__*/React.createElement(StyledBar, {
    progress: progress,
    titleColor: titleColor
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      height: 'inherit'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      height: 'inherit'
    }
  })), /*#__PURE__*/React.createElement(InlineLayout, {
    horizontalAlign: "start",
    fontFamily: helperFontFamily
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: titleColor ? "".concat(titleColor, "80") : "#707070",
      fontSize: helperTextSize
    }
  }, helperText)));
};

var Minus = function Minus(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? "#707070" : _ref$color;
  return /*#__PURE__*/React.createElement("svg", {
    width: "15",
    height: "14",
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.55005 7H11.95",
    stroke: color,
    "stroke-width": "1.4",
    "stroke-linecap": "round"
  }));
};

var Plus = function Plus(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? "#707070" : _ref$color;
  return /*#__PURE__*/React.createElement("svg", {
    width: "15",
    height: "14",
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8501 6.99961H7.7501M7.7501 6.99961H12.6501M7.7501 6.99961L7.7501 2.09961M7.7501 6.99961L7.7501 11.8996",
    stroke: color,
    "stroke-width": "1.4",
    "stroke-linecap": "round"
  }));
};

var _templateObject$6;
var StepperContainer = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  text-align: start;\n  color: inherit;\n  background-color: ", ";\n  margin: ", ";\n  padding: 11px;\n  min-width: max-content;\n  width: ", ";\n  box-sizing: border-box;\n  & > div:first-child {\n    line-height: normal;\n  }\n  & img {\n    width: 100%;\n    height: 100%;\n    max-width: 14px;\n    max-height: 14px;\n  }\n  & label {\n    color: #707070;\n    font-size: 12px;\n    padding-right: 11px;\n  }\n  & .stepper-value {\n    color: ", ";\n    font-size: ", ";\n    margin: auto;\n    min-width: 35px;\n    width: ", ";\n    text-align: center;\n    input[type='number'] {\n      -webkit-appearance: none;\n      -moz-appearance: textfield;\n      appearance: textfield;\n      border: none;\n      background: transparent;\n      color: inherit;\n      font-size: inherit;\n      text-align: center;\n      outline: none;\n    }\n    input[type='number']::-webkit-outer-spin-button,\n    input[type='number']::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n  };\n  pointer-events: ", ";\n  opacity: ", ";\n  cursor: ", ";\n"])), function (props) {
  return props.color ? "".concat(props.color, "33") : "#dedede";
}, function (prop) {
  return prop.bgColor ? prop.bgColor : 'inherit';
}, function (prop) {
  return prop.margin && prop.margin;
}, function (prop) {
  return prop.isMobile ? 'inherit' : '100%';
}, function (prop) {
  return prop.color && prop.color;
}, function (props) {
  return props.isMobile ? '12px' : 'inherit';
}, function (prop) {
  return prop.stepperWidth && prop.stepperWidth;
}, function (prop) {
  return prop.disable && 'none';
}, function (prop) {
  return prop.disable ? '0.5' : '1';
}, function (prop) {
  return prop.disable && 'not-allowed';
});
var Stepper = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  _ref.label;
    var _ref$increment = _ref.increment,
    increment = _ref$increment === undefined ? 1 : _ref$increment,
    _ref$min = _ref.min,
    min = _ref$min === undefined ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === undefined ? 10 : _ref$max,
    id = _ref.id,
    onChange = _ref.onChange,
    value = _ref.value,
    isMobile = _ref.isMobile,
    color = _ref.color,
    bgColor = _ref.bgColor,
    stepperValueRef = _ref.stepperValueRef,
    disable = _ref.disable,
    margin = _ref.margin,
    _ref$stepperWidth = _ref.stepperWidth,
    stepperWidth = _ref$stepperWidth === undefined ? '60px' : _ref$stepperWidth;
  var add = function add() {
    if (value < max) {
      if (value + increment > max) {
        onChange(max);
      } else onChange(value + increment);
    }
  };
  var subtract = function subtract() {
    if (value > min) {
      if (value - increment < min) {
        onChange(min);
      } else onChange(value - increment);
    }
  };
  var handleInputChange = function handleInputChange(e) {
    var inputValue = Number(e.target.value);
    // if (inputValue === '') {
    //   onChange(min);
    //   return;
    // }
    // const newValue = Number(inputValue);
    // if (isNaN(newValue)) return;
    // if (newValue < min) {
    //   onChange(min);
    //   return;
    // }
    // if (newValue > max) {
    //   onChange(max);
    //   return;
    // }
    onChange(inputValue);
  };
  return /*#__PURE__*/React.createElement(StepperContainer, {
    isMobile: isMobile,
    margin: margin,
    stepperWidth: stepperWidth,
    disable: disable,
    color: color,
    bgColor: bgColor
  }, /*#__PURE__*/React.createElement(InlineLayout, {
    padding: "0 0 0 0"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    kind: "plain",
    // padding="0 11px 0 0"
    disabled: value === min,
    onClick: subtract
  }, /*#__PURE__*/React.createElement(Minus, {
    color: color ? "".concat(color, "80") : "#707070"
  }))), /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "stepper-value"
  }, /*#__PURE__*/React.createElement("input", {
    tabIndex: 0,
    ref: stepperValueRef,
    type: "number",
    // min={min}
    // max={max}
    value: value,
    onChange: handleInputChange,
    disabled: disable,
    style: {
      pointerEvents: disable ? 'none' : 'auto',
      width: isMobile ? '50px' : '60px'
    },
    onFocus: function onFocus(e) {
      e.target.style.border = '1px solid ' + (color ? "".concat(color, "33") : '#fefefe33');
      e.target.style.outline = 'none';
      e.target.style.boxShadow = 'none';
      e.target.style.borderRadius = '4px';
    },
    onBlur: function onBlur(e) {
      e.target.style.border = 'none';
      e.target.style.outline = 'none';
      e.target.style.boxShadow = 'none';
    }
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    kind: "plain",
    // padding="0 0 0 11px"
    disabled: value === max,
    onClick: add
  }, /*#__PURE__*/React.createElement(Plus, {
    color: color ? "".concat(color, "80") : "#707070"
  })))));
});

var img$6 = "data:image/svg+xml,%3csvg width='14' height='15' viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M6.9999 4.58372V7.30595M12.5999 7.50039C12.5999 10.5932 10.0927 13.1004 6.9999 13.1004C3.90711 13.1004 1.3999 10.5932 1.3999 7.50039C1.3999 4.4076 3.90711 1.90039 6.9999 1.90039C10.0927 1.90039 12.5999 4.4076 12.5999 7.50039ZM7.1999 10.3004C7.1999 10.4108 7.11036 10.5004 6.9999 10.5004C6.88945 10.5004 6.7999 10.4108 6.7999 10.3004C6.7999 10.1899 6.88945 10.1004 6.9999 10.1004C7.11036 10.1004 7.1999 10.1899 7.1999 10.3004ZM6.9974 10.2979H7.00207V10.3029H6.9974V10.2979Z' stroke='%23DD1D1D' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

var _templateObject$5;
var Container$1 = styled.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: inherit;\n  height: inherit;\n  background-color: ", ";\n  border-top: 1px solid #fdd8d8;\n  border-bottom: 1px solid #fdd8d8;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: start;\n  text-align: start;\n  padding: 8px 14px;\n  & img {\n    width: 14px;\n    height: 14px;\n    margin-right: 14px;\n  }\n  & div {\n    color: ", ";\n    font-family: ", ";\n    font-size: ", "px;\n  }\n"])), function (props) {
  return props.bgColor && props.bgColor;
}, function (props) {
  return props.contentColor && props.contentColor;
}, function (props) {
  return props.contentFontFamily && props.contentFontFamily;
}, function (props) {
  return props.contentFontSize && props.contentFontSize;
});
var InlineError = function InlineError(_ref) {
  var _ref$content = _ref.content,
    content = _ref$content === undefined ? 'Please add a minimum of 3 items' : _ref$content,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === undefined ? '#fef6f6' : _ref$bgColor,
    _ref$contentFontFamil = _ref.contentFontFamily,
    contentFontFamily = _ref$contentFontFamil === undefined ? 'inherit' : _ref$contentFontFamil,
    contentFontSize = _ref.contentFontSize,
    _ref$contentColor = _ref.contentColor,
    contentColor = _ref$contentColor === undefined ? '#640707' : _ref$contentColor,
    style = _ref.style;
  return /*#__PURE__*/React.createElement(Container$1, {
    bgColor: bgColor,
    contentFontFamily: contentFontFamily,
    contentFontSize: contentFontSize,
    contentColor: contentColor,
    style: style
  }, /*#__PURE__*/React.createElement("img", {
    src: img$6,
    alt: "error"
  }), /*#__PURE__*/React.createElement("div", null, content));
};

var TableHeader = function TableHeader(_ref) {
  var fontFamily = _ref.fontFamily,
    columnHeadings = _ref.columnHeadings,
    getCellStyles = _ref.getCellStyles,
    backgroundColor = _ref.backgroundColor;
  return /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: fontFamily,
      backgroundColor: backgroundColor
    }
  }, columnHeadings.map(function (heading) {
    return /*#__PURE__*/React.createElement("th", {
      key: heading,
      style: getCellStyles(heading),
      title: heading
    }, /*#__PURE__*/React.createElement(FlexDiv, {
      width: "max-content"
    }, /*#__PURE__*/React.createElement(MdText, {
      fontSize: 'inherit',
      alignment: "start",
      color: 'inherit',
      fontWeight: '',
      fontFamily: fontFamily,
      width: '100%'
    }, heading === "Actions" ? "" : heading)));
  })));
};

var TableRow = function TableRow(_ref) {
  var row = _ref.row,
    columnHeadings = _ref.columnHeadings,
    getCellStyles = _ref.getCellStyles,
    getTextContent = _ref.getTextContent;
  return /*#__PURE__*/React.createElement("tr", null, columnHeadings.map(function (heading) {
    return /*#__PURE__*/React.createElement("td", {
      key: heading,
      className: row['Is Error'] === 'true' ? 'error-row' : undefined,
      style: getCellStyles(heading),
      title: heading in columnHeadings ? row[heading] : undefined
    }, getTextContent(row[heading], heading));
  }));
};

var ErrorRow = function ErrorRow(_ref) {
  var row = _ref.row,
    columnHeadings = _ref.columnHeadings,
    themeProps = _ref.themeProps,
    getErrorText = _ref.getErrorText,
    incrementToken = _ref.incrementToken;
  return row['Is Error'] === 'true' && (/*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: themeProps.orderTableContentFontFamily
    }
  }, /*#__PURE__*/React.createElement("td", {
    className: "error-row",
    colSpan: columnHeadings.length + 1,
    style: {
      padding: '0'
    }
  }, /*#__PURE__*/React.createElement(InlineError, {
    content: getErrorText(row['Error'], Number(row[incrementToken])),
    contentColor: themeProps.lineItemErrorTextColor,
    contentFontFamily: themeProps.lineItemErrorFontFamily,
    contentFontSize: themeProps.lineItemErrorFontSize
  }))));
};

var FETCH_LOCATIONS_API = '/app/locations';
var FETCH_CSV_UPLOAD_URL_API = '/app/csvupload';
var FETCH_CSV_UPLOAD_STATUS_API = '/app/csvupload/status';
var FETCH_DOWNLOAD_CATALOGUE_API = '/app/catalog';
var FETCH_DOWNLOAD_CATALOGUE_STATUS_API = '/app/catalog/status';
var FETCH_APP_ORDER_API = '/app/order';
var CREATE_DRAFT_ORDER_API = '/app/csvupload/draftorder';
var FETCH_SEARCH_PRODUCTS_API = '/app/csvupload/search';
var rowsPerPage = 5;
var statusRequestInterval = 5000;
var maxPossibleItemQty = 999999;
var mrOrderIDAttributionKey = '_mrcaOrderID';

var _templateObject$4, _templateObject2$1, _templateObject3, _templateObject4;
var MobileTableText = styled.p(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  margin: 4px 0 !important;\n  font-size: 12px;\n  line-height: 18px;\n  color: inherit;\n  width: ", ";\n  & span {\n    color: ", ";\n  }\n"])), function (prop) {
  return prop.width || '100%';
}, function (prop) {
  return prop.color && prop.color;
});
var MobileTable = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  border: 1px solid #dfdfdf;\n  border-radius: 5px;\n  width: 100%;\n"])));
var StyledTable = styled.table(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-family: inherit, sans-serif;\n  box-sizing: border-box;\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  border: ", ";\n  border-radius: ", ";\n  & th {\n    padding: ", ";\n    border-bottom: ", ";\n    font-weight: 400;\n    font-size: ", "px;\n    color: ", ";\n    text-align: ", ";\n  }\n  & td {\n    white-space: nowrap;\n    padding: ", ";\n    border-bottom: ", ";\n    font-size: ", "px;\n    color: ", ";\n    text-align: ", ";\n  }\n  & td.error-row {\n    background-color: #fef6f6;\n    border-bottom: none;\n  }\n  & tbody tr:last-child td {\n    border-bottom: none;\n  }\n"])), function (prop) {
  return prop.border && prop.border;
}, function (prop) {
  return prop.cornerRadius ? prop.cornerRadius : '5px';
}, function (prop) {
  return prop.padding ? prop.padding : '8px';
}, function (prop) {
  return prop.border ? prop.border : '1px solid #E1E3E5';
}, function (prop) {
  return prop.headingFontSize ? prop.headingFontSize : '14';
}, function (prop) {
  return prop.headingColor ? prop.headingColor : '#707070';
}, function (prop) {
  return prop.headingAlign ? prop.headingAlign : 'center';
}, function (prop) {
  return prop.padding ? prop.padding : '8px';
}, function (prop) {
  return prop.border ? prop.border : '1px solid #E1E3E5';
}, function (prop) {
  return prop.contentFontSize ? prop.contentFontSize : '14';
}, function (prop) {
  return prop.contentColor ? prop.contentColor : '#000000';
}, function (prop) {
  return prop.contentAlign ? prop.contentAlign : 'center';
});
var StyledContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n  overflow: auto;\n  max-height: 40vh;\n  border: 1px solid #e1e3e5;\n  border-radius: 5px;\n"])));
var columnWidths = {
  'Product Name': '250px',
  Available: '150px',
  'Minimum Quantity': '150px',
  'Variant SKU': '150px'
};
var getCellStyles = function getCellStyles(heading) {
  var baseStyles = {
    maxWidth: columnWidths[heading] || 'auto',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  };
  return heading in columnWidths ? baseStyles : {};
};
var Table$1 = function Table(_ref) {
  var headingFontSize = _ref.headingFontSize,
    contentFontSize = _ref.contentFontSize,
    headingColor = _ref.headingColor,
    contentColor = _ref.contentColor,
    padding = _ref.padding,
    borderColor = _ref.borderColor,
    borderWidth = _ref.borderWidth,
    cornerRadius = _ref.cornerRadius,
    tableData = _ref.tableData,
    onTableRowQuantityChange = _ref.onTableRowQuantityChange,
    onTableRowDelete = _ref.onTableRowDelete,
    themeProps = _ref.themeProps;
    _ref.isShowAvailableStock;
    _ref.isShowBarcode;
    var incrementToken = _ref.incrementToken,
    minQtyToken = _ref.minQtyToken,
    maxQtyToken = _ref.maxQtyToken,
    availableQtyToken = _ref.availableQtyToken,
    inventoryPolicyToken = _ref.inventoryPolicyToken,
    columnTokens = _ref.columnTokens,
    tableHeadings = _ref.tableHeadings;
  var qtyToken = columnTokens === null || columnTokens === undefined ? undefined : columnTokens.qtyToken;
  var variantSkuToken = columnTokens === null || columnTokens === undefined ? undefined : columnTokens.variantSkuToken;
  var barcodeToken = columnTokens === null || columnTokens === undefined ? undefined : columnTokens.barcodeToken;
  var isMobile = window.innerWidth < 768;
  var getErrorText = function getErrorText(error, incrementValue) {
    if (error === 'errorIncrementQuantityText') {
      return themeProps.errorIncrementQuantityText.replace('{increment_qty}', String(incrementValue));
    }
    return themeProps[error];
  };
  var getMaxStepperVal = function getMaxStepperVal(row) {
    if (!row) return maxPossibleItemQty;
    var ignoreAvailableStock = row[inventoryPolicyToken] === 'CONTINUE';
    var maxQty = row[maxQtyToken] ? Number(row[maxQtyToken]) : maxPossibleItemQty;
    var availableStock = ignoreAvailableStock || row[availableQtyToken] === '' ? maxQty : Number(row[availableQtyToken]);
    return Math.min(maxQty, availableStock);
  };
  var getMinStepperVal = function getMinStepperVal(row) {
    if (row) {
      var minQty = Number(row[minQtyToken]) || 0;
      var min = Math.max(0, minQty);
      // as there is no stock min should be 0 so that the row can be ignored
      if (row && row[availableQtyToken] !== '' && Number(row[availableQtyToken]) <= 0) {
        return 0;
      }
      return min;
    }
  };
  var getTextContent = function getTextContent(data, columnHeading) {
    var showUppercaseFor = [variantSkuToken, barcodeToken].filter(Boolean);
    var convertToUppercase = showUppercaseFor.includes(columnHeading);
    if (!data) return '-';
    return convertToUppercase ? data.toUpperCase() : data;
  };
  var columnHeadings = tableHeadings || Object.keys(tableData[0]).filter(function (key) {
    return key !== 'Error' && key !== 'Is Error';
  });
  columnHeadings.push('Actions');
  var rowData = structuredClone(tableData).map(function (row, index) {
    row[qtyToken] = /*#__PURE__*/React.createElement(Stepper, {
      label: qtyToken,
      increment: +row[incrementToken] || 1,
      max: getMaxStepperVal(row),
      min: getMinStepperVal(row),
      onChange: function onChange(v) {
        return onTableRowQuantityChange(index, v);
      },
      value: +row[qtyToken],
      isMobile: isMobile,
      color: themeProps.orderTableContentTextColor,
      bgColor: row['Is Error'] === 'true' ? '#ffffff' : 'inherit'
    });
    row['Actions'] = /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return onTableRowDelete(index);
      },
      kind: "plain",
      padding: "6px"
    }, /*#__PURE__*/React.createElement(Delete, {
      color: "".concat(themeProps.orderTableContentTextColor, "80")
    }));
    return row;
  });
  if (isMobile) {
    return /*#__PURE__*/React.createElement(MobileTable, null, rowData.map(function (row, index) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BlockLayout, {
        gap: "14px",
        padding: "14px 7px"
      }, /*#__PURE__*/React.createElement(InlineLayout, {
        height: "auto",
        horizontalAlign: "between"
      }, /*#__PURE__*/React.createElement(MobileTableText, {
        width: "85%",
        color: themeProps.orderTableContentTextColor
      }, /*#__PURE__*/React.createElement("span", null, columnHeadings[0], " ", ' : '), /*#__PURE__*/React.createElement("span", null, row[columnHeadings[0]])), /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return onTableRowDelete(index);
        },
        kind: "plain",
        padding: "0"
      }, /*#__PURE__*/React.createElement(Delete, {
        color: "".concat(themeProps.orderTableContentTextColor, "80")
      }))), columnHeadings.slice(1, columnHeadings.length - 1).map(function (heading) {
        return /*#__PURE__*/React.createElement(InlineLayout, {
          key: heading,
          horizontalAlign: "start"
        }, /*#__PURE__*/React.createElement(MobileTableText, {
          color: themeProps.orderTableContentTextColor
        }, /*#__PURE__*/React.createElement("span", null, heading, " ", ' : '), /*#__PURE__*/React.createElement("span", null, getTextContent(row[heading], heading))));
      }), row['Is Error'] === 'true' && (/*#__PURE__*/React.createElement(InlineError, {
        content: getErrorText(row['Error'], Number(row.incrementToken)),
        contentColor: themeProps.lineItemErrorTextColor,
        contentFontFamily: themeProps.lineItemErrorFontFamily,
        contentFontSize: themeProps.lineItemErrorFontSize,
        style: {
          borderLeft: '1px solid #fdd8d8',
          borderRight: '1px solid #fdd8d8',
          borderRadius: '5px'
        }
      }))), index !== rowData.length - 1 && /*#__PURE__*/React.createElement(Divider, {
        color: "#E1E3E5"
      }));
    }));
  }
  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(StyledTable, {
    headingFontSize: headingFontSize,
    contentFontSize: contentFontSize,
    headingColor: headingColor,
    contentColor: contentColor,
    padding: padding,
    borderColor: borderColor,
    borderWidth: borderWidth,
    cornerRadius: cornerRadius,
    headingAlign: "start",
    contentAlign: "start"
  }, /*#__PURE__*/React.createElement(TableHeader, {
    fontFamily: themeProps.orderTableColumnNameFontFamily,
    columnHeadings: columnHeadings,
    getCellStyles: getCellStyles
  }), /*#__PURE__*/React.createElement("tbody", {
    style: {
      fontFamily: themeProps.orderTableContentFontFamily
    }
  }, rowData.map(function (row, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(TableRow, {
      row: row,
      columnHeadings: columnHeadings,
      getCellStyles: getCellStyles,
      getTextContent: getTextContent
    }), /*#__PURE__*/React.createElement(ErrorRow, {
      row: row,
      columnHeadings: columnHeadings,
      themeProps: themeProps,
      getErrorText: getErrorText,
      incrementToken: incrementToken
    }));
  }))));
};

var img$5 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M12.0001 7.00039L12.0001 11.6671M21.6001 12.0004C21.6001 17.3023 17.302 21.6004 12.0001 21.6004C6.69812 21.6004 2.40005 17.3023 2.40005 12.0004C2.40005 6.69846 6.69812 2.40039 12.0001 2.40039C17.302 2.40039 21.6001 6.69846 21.6001 12.0004ZM12.3429 16.8004C12.3429 16.9897 12.1894 17.1432 12.0001 17.1432C11.8107 17.1432 11.6572 16.9897 11.6572 16.8004C11.6572 16.611 11.8107 16.4575 12.0001 16.4575C12.1894 16.4575 12.3429 16.611 12.3429 16.8004ZM11.9958 16.7961H12.0038V16.8047H11.9958V16.7961Z' stroke='%23DD1D1D' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

var img$4 = "data:image/svg+xml,%3csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M9.99999 14.4444C9.53975 14.4444 9.16666 14.0713 9.16667 13.6111L9.16674 9.72221C9.16675 9.26197 9.53985 8.88888 10.0001 8.88889C10.4603 8.8889 10.8334 9.262 10.8334 9.72224L10.8333 13.6111C10.8333 14.0714 10.4602 14.4445 9.99999 14.4444Z' fill='%234A4A4A'/%3e %3cpath d='M8.8889 6.66667C8.8889 6.05302 9.38636 5.55555 10 5.55555C10.6137 5.55555 11.1111 6.05302 11.1111 6.66667C11.1111 7.28032 10.6137 7.77778 10 7.77778C9.38636 7.77778 8.8889 7.28032 8.8889 6.66667Z' fill='%234A4A4A'/%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M17.7778 10C17.7778 14.2955 14.2956 17.7778 10 17.7778C5.70446 17.7778 2.22223 14.2955 2.22223 10C2.22223 5.70445 5.70446 2.22222 10 2.22222C14.2956 2.22222 17.7778 5.70445 17.7778 10ZM16.1111 10C16.1111 13.3751 13.3751 16.1111 10 16.1111C6.62493 16.1111 3.8889 13.3751 3.8889 10C3.8889 6.62493 6.62493 3.88889 10 3.88889C13.3751 3.88889 16.1111 6.62493 16.1111 10Z' fill='%234A4A4A'/%3e%3c/svg%3e";

var img$3 = "data:image/svg+xml,%3csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.2143 6.6865L8.88918 11.6909C8.7092 11.9617 8.32614 11.9996 8.09657 11.7693L5.78576 9.45078M16.2 9.00078C16.2 12.9772 12.9765 16.2008 9.00005 16.2008C5.0236 16.2008 1.80005 12.9772 1.80005 9.00078C1.80005 5.02433 5.0236 1.80078 9.00005 1.80078C12.9765 1.80078 16.2 5.02433 16.2 9.00078Z' stroke='rgba(10%2c 130%2c 32%2c 1)' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

var img$2 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M12 9.60156L12 13.2016' stroke='%238F6900' stroke-width='1.4' stroke-linecap='round'/%3e %3ccircle cx='12.0001' cy='16.7999' r='0.342857' stroke='%238F6900' stroke-width='1.4'/%3e %3cpath d='M12.0038 16.7969H11.9958V16.8054H12.0038V16.7969Z' stroke='%238F6900' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M11.4669 3.39817C11.6944 2.97162 12.3058 2.97162 12.5333 3.39817L21.1261 19.5098C21.3408 19.9123 21.0491 20.3984 20.5929 20.3984H3.40723C2.95104 20.3984 2.65936 19.9123 2.87404 19.5098L11.4669 3.39817Z' stroke='%238F6900' stroke-width='1.4'/%3e%3c/svg%3e";

var List = function List(_ref) {
  var messages = _ref.messages,
    _ref$type = _ref.type,
    type = _ref$type === undefined ? 'unordered' : _ref$type,
    className = _ref.className,
    listStyleType = _ref.listStyleType,
    fontFamily = _ref.fontFamily,
    fontSize = _ref.fontSize;
  var ListElement = type === 'ordered' ? 'ol' : 'ul';
  return /*#__PURE__*/React.createElement(ListElement, {
    className: className,
    style: {
      listStyleType: listStyleType,
      fontFamily: fontFamily,
      fontSize: fontSize
    }
  }, messages.map(function (message, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, message);
  }));
};

var _templateObject$3;
var getVariantStyles = function getVariantStyles(variant) {
  switch (variant) {
    case 'critical':
      return {
        bgColor: 'rgba(254, 246, 246, 1)',
        titleColor: 'rgba(66, 0, 0, 1)',
        contentColor: 'rgba(100, 7, 7, 1)',
        borderColor: 'rgba(253, 216, 216, 1)',
        icon: img$5
      };
    case 'info':
      return {
        bgColor: 'rgba(245, 245, 245, 1)',
        titleColor: 'rgba(28, 28, 28, 1)',
        contentColor: 'rgba(28, 28, 28, 1)',
        borderColor: 'rgba(227, 227, 227, 1)',
        icon: img$4
      };
    case 'success':
      return {
        bgColor: 'rgba(234, 251, 234, 1)',
        titleColor: 'rgba(16, 30, 17, 1)',
        contentColor: 'rgba(82, 132, 86, 1)',
        borderColor: 'rgba(177, 242, 180, 1)',
        icon: img$3
      };
    case 'warning':
      return {
        bgColor: 'rgba(255, 245, 235, 1)',
        titleColor: '#241700',
        contentColor: '#423100',
        borderColor: 'rgba(255, 222, 178, 1)',
        icon: img$2
      };
    default:
      return {
        bgColor: '#fef6f6',
        titleColor: '#420000',
        contentColor: '#640707',
        icon: img$5
      };
  }
};
var Container = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  background-color: ", ";\n  border-radius: 5px;\n  border: 1px solid ", ";\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  text-align: start;\n  padding: 14px;\n  width: 100%;\n  & img {\n    width: 24px;\n    height: 24px;\n    margin-bottom: auto;\n    margin-right: 14px;\n  }\n  & .alert-title {\n    font-family: ", ";\n    font-size: ", "px;\n    color: ", ";\n    font-weight: 600;\n  }\n  & div ul {\n    margin: 7px 0 0 24px;\n    padding: 0;\n  }\n  & .alert-content {\n    overflow-wrap: anywhere;\n    white-space: pre-wrap;\n    color: ", ";\n    font-family: ", ";\n    font-size: ", "px;\n  }\n"])), function (props) {
  return props.bgColor || getVariantStyles(props.variant).bgColor;
}, function (props) {
  return getVariantStyles(props.variant).borderColor;
}, function (props) {
  return props.titleFontFamily && props.titleFontFamily;
}, function (props) {
  return props.titleFontSize && props.titleFontSize;
}, function (props) {
  return props.titleColor || getVariantStyles(props.variant).titleColor;
}, function (props) {
  return props.contentColor || getVariantStyles(props.variant).contentColor;
}, function (props) {
  return props.contentFontFamily && props.contentFontFamily;
}, function (props) {
  return props.contentFontSize && props.contentFontSize;
});
var AlertBanner = function AlertBanner(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === undefined ? 'Alert! Please take the necessary actions.' : _ref$title,
    _ref$messages = _ref.messages,
    messages = _ref$messages === undefined ? ['This is a default alert message.'] : _ref$messages,
    _ref$variant = _ref.variant,
    variant = _ref$variant === undefined ? 'critical' : _ref$variant,
    titleFontFamily = _ref.titleFontFamily,
    titleFontSize = _ref.titleFontSize,
    titleColor = _ref.titleColor,
    bgColor = _ref.bgColor,
    contentFontFamily = _ref.contentFontFamily,
    contentFontSize = _ref.contentFontSize,
    contentColor = _ref.contentColor,
    _ref$contentBullets = _ref.contentBullets,
    contentBullets = _ref$contentBullets === undefined ? true : _ref$contentBullets;
  var variantStyles = getVariantStyles(variant);
  var bannerContent = contentBullets ? (/*#__PURE__*/React.createElement(List, {
    className: "alert-content",
    messages: messages
  })) : messages.map(function (message, index) {
    return /*#__PURE__*/React.createElement("p", {
      className: "alert-content",
      key: index
    }, message);
  });
  return /*#__PURE__*/React.createElement(Container, {
    titleFontFamily: titleFontFamily,
    titleFontSize: titleFontSize,
    titleColor: titleColor,
    bgColor: bgColor || variantStyles.bgColor,
    contentFontFamily: contentFontFamily,
    contentFontSize: contentFontSize,
    contentColor: contentColor || variantStyles.contentColor,
    variant: variant
  }, /*#__PURE__*/React.createElement("img", {
    src: variantStyles.icon,
    alt: variant
  }), /*#__PURE__*/React.createElement(FlexDiv, {
    flexdir: "column"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert-title"
  }, title), bannerContent));
};

var ChevronDown = function ChevronDown(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? "#000000" : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === undefined ? "14" : _ref$size;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9 5.59961L7.31817 10.1814C7.14244 10.3571 6.85751 10.3571 6.68178 10.1814L2.09998 5.59961",
    stroke: color,
    "stroke-width": "1.4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }));
};

var UpArrow = function UpArrow(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? "#000000" : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === undefined ? "14" : _ref$size;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9001 8.90039L7.24759 4.24788C7.1109 4.11119 6.88929 4.11119 6.75261 4.24788L2.1001 8.90039",
    stroke: color,
    "stroke-width": "1.4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }));
};

var CollapsibleCard = function CollapsibleCard(_ref) {
  var isAdmin = _ref.isAdmin,
    _ref$heightAdmin = _ref.heightAdmin,
    heightAdmin = _ref$heightAdmin === undefined ? '40vh' : _ref$heightAdmin,
    _ref$heightDefault = _ref.heightDefault,
    heightDefault = _ref$heightDefault === undefined ? '100%' : _ref$heightDefault,
    _ref$gap = _ref.gap,
    gap = _ref$gap === undefined ? '10px' : _ref$gap,
    titleText = _ref.titleText,
    _ref$titleTextSize = _ref.titleTextSize,
    titleTextSize = _ref$titleTextSize === undefined ? '16px' : _ref$titleTextSize,
    _ref$titleFontWeight = _ref.titleFontWeight,
    titleFontWeight = _ref$titleFontWeight === undefined ? 500 : _ref$titleFontWeight,
    _ref$titleColor = _ref.titleColor,
    titleColor = _ref$titleColor === undefined ? '#000' : _ref$titleColor,
    _ref$titleFontFamily = _ref.titleFontFamily,
    titleFontFamily = _ref$titleFontFamily === undefined ? 'Arial, sans-serif' : _ref$titleFontFamily,
    _ref$buttonKind = _ref.buttonKind,
    buttonKind = _ref$buttonKind === undefined ? 'plain' : _ref$buttonKind,
    _ref$buttonTextSize = _ref.buttonTextSize,
    buttonTextSize = _ref$buttonTextSize === undefined ? '14px' : _ref$buttonTextSize,
    _ref$buttonTextColor = _ref.buttonTextColor,
    buttonTextColor = _ref$buttonTextColor === undefined ? 'rgba(25, 124, 189, 1)' : _ref$buttonTextColor,
    _ref$buttonPadding = _ref.buttonPadding,
    buttonPadding = _ref$buttonPadding === undefined ? '0' : _ref$buttonPadding,
    _ref$iconBeforeSize = _ref.iconBeforeSize,
    iconBeforeSize = _ref$iconBeforeSize === undefined ? 12 : _ref$iconBeforeSize,
    _ref$iconSpacing = _ref.iconSpacing,
    iconSpacing = _ref$iconSpacing === undefined ? 4 : _ref$iconSpacing,
    isContentVisible = _ref.isContentVisible,
    _ref$showText = _ref.showText,
    showText = _ref$showText === undefined ? 'Show' : _ref$showText,
    _ref$hideText = _ref.hideText,
    hideText = _ref$hideText === undefined ? 'Hide' : _ref$hideText,
    toggleContentVisibility = _ref.toggleContentVisibility,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(BlockLayout, {
    height: isAdmin ? heightAdmin : heightDefault,
    gap: gap
  }, /*#__PURE__*/React.createElement(InlineLayout, {
    height: 'auto',
    horizontalAlign: "between"
  }, /*#__PURE__*/React.createElement(MdText, {
    alignment: "start",
    fontSize: titleTextSize,
    fontWeight: titleFontWeight,
    color: titleColor,
    fontFamily: titleFontFamily,
    width: 'auto'
  }, titleText), /*#__PURE__*/React.createElement(Button, {
    kind: buttonKind,
    textSize: buttonTextSize,
    padding: buttonPadding,
    color: buttonTextColor,
    iconBefore: isContentVisible ? /*#__PURE__*/React.createElement(UpArrow, {
      color: buttonTextColor,
      size: buttonTextSize
    }) : /*#__PURE__*/React.createElement(ChevronDown, {
      color: buttonTextColor,
      size: buttonTextSize
    }),
    iconBeforeSize: iconBeforeSize,
    iconSpacing: iconSpacing,
    onClick: toggleContentVisibility
  }, isContentVisible ? hideText : showText)), isContentVisible && children);
};

var _templateObject$2;
var IconContainer = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  cursor: ", ";\n  transition: ", ";\n\n  &:hover {\n    transform: ", ";\n  }\n\n  img {\n    width: 100%;\n    height: 100%;\n  }\n"])), function (props) {
  return props.width || props.size || '24px';
}, function (props) {
  return props.height || props.size || '24px';
}, function (props) {
  return props.hoverEffect ? 'pointer' : 'default';
}, function (props) {
  return props.hoverEffect ? 'transform 0.2s ease-in-out' : 'none';
}, function (props) {
  return props.hoverEffect ? 'scale(1.1)' : 'none';
});
var Icon = function Icon(_ref) {
  var src = _ref.src,
    alt = _ref.alt,
    size = _ref.size,
    height = _ref.height,
    width = _ref.width,
    onClick = _ref.onClick,
    _ref$hoverEffect = _ref.hoverEffect,
    hoverEffect = _ref$hoverEffect === undefined ? false : _ref$hoverEffect,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(IconContainer, {
    size: size,
    height: height,
    width: width,
    hoverEffect: hoverEffect,
    onClick: onClick,
    className: className,
    role: onClick ? 'button' : 'img',
    "aria-label": onClick ? alt : undefined
  }, src && /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt
  }));
};

var img$1 = "data:image/svg+xml,%3csvg width='16' height='22' viewBox='0 0 16 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M14.6947 3.72195H13.0869V2.14975C13.0911 1.79771 12.9554 1.45839 12.7098 1.20623C12.4641 0.954066 12.1284 0.809658 11.7764 0.804688H5.28104C5.02739 0.806073 4.77668 0.859057 4.54415 0.960414C4.31163 1.06177 4.10216 1.20938 3.92849 1.39426L0.540182 4.98442C0.190702 5.3558 -0.00266099 5.8473 9.4122e-05 6.35725V16.9362C-0.00409253 17.2882 0.13154 17.6275 0.377234 17.8797C0.622927 18.1319 0.958616 18.2763 1.31065 18.2812H2.91917V19.8506C2.9139 20.2023 3.04828 20.5418 3.29287 20.7946C3.53746 21.0474 3.87231 21.1929 4.224 21.1992H14.6947C15.0464 21.1929 15.3813 21.0474 15.6259 20.7946C15.8706 20.5418 16.005 20.2023 15.9999 19.8506V5.06346C16.0042 4.71263 15.8692 4.37439 15.6246 4.12291C15.3799 3.87143 15.0455 3.72724 14.6947 3.72195ZM4.47928 2.93558V5.22367H2.31985L4.47928 2.93558ZM1.4584 6.68195H5.20842C5.30417 6.68197 5.399 6.66313 5.48747 6.6265C5.57595 6.58986 5.65634 6.53616 5.72405 6.46844C5.79176 6.40073 5.84547 6.32034 5.8821 6.23187C5.91874 6.14339 5.93758 6.04857 5.93755 5.95281C5.92481 5.89872 5.95752 2.31076 5.92865 2.26297H11.6286C11.6286 3.42995 11.6286 15.3202 11.6286 16.823H1.4584V6.68195ZM14.5416 19.7409H4.37745V18.2812H11.7764C12.1284 18.2762 12.4641 18.1318 12.7098 17.8797C12.9554 17.6275 13.0911 17.2882 13.0869 16.9361V5.18023H14.5416V19.7409Z' fill='%23707070'/%3e%3c/svg%3e";

var img = "data:image/svg+xml,%3csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M15.5579 3.60156L8.00145 14.9716C7.84397 15.2085 7.50885 15.2417 7.30798 15.0402L1.80078 9.51585' stroke='%23707070' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

var CopyLinkBox = function CopyLinkBox(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === undefined ? 'https://example.com/' : _ref$text,
    _ref$padding = _ref.padding,
    padding = _ref$padding === undefined ? '2px 14px' : _ref$padding,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === undefined ? '5px' : _ref$borderRadius,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === undefined ? 'blue' : _ref$textColor,
    handleCopy = _ref.handleCopy,
    copied = _ref.copied;
  return /*#__PURE__*/React.createElement(InlineLayout, {
    border: "1px solid #DEDEDE",
    horizontalAlign: "between",
    padding: padding,
    cornerRadius: borderRadius,
    wrap: false,
    gap: "10px"
  }, /*#__PURE__*/React.createElement(Text, {
    textSize: "14",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: textColor
  }, text), /*#__PURE__*/React.createElement(Icon, {
    src: copied ? img : img$1,
    alt: copied ? 'Copied' : 'Copy link',
    onClick: handleCopy,
    hoverEffect: true
  }));
};

var WatchTutorialButton = function WatchTutorialButton(_ref) {
  var isAdmin = _ref.isAdmin,
    watchTutorialLink = _ref.watchTutorialLink,
    themeProps = _ref.themeProps;
  var _themeProps$subtitle = themeProps.subtitle,
    watchTutorialText = _themeProps$subtitle.watchTutorialText,
    watchTutorialTextColor = _themeProps$subtitle.watchTutorialTextColor,
    watchTutorialFontSize = _themeProps$subtitle.watchTutorialFontSize,
    watchTutorialFontFamily = _themeProps$subtitle.watchTutorialFontFamily;
  return /*#__PURE__*/React.createElement("a", {
    href: isAdmin ? undefined : watchTutorialLink,
    target: "_blank",
    style: {
      cursor: "pointer",
      textDecoration: 'none',
      color: watchTutorialTextColor,
      fontFamily: watchTutorialFontFamily,
      fontSize: "".concat(watchTutorialFontSize, "px")
    }
  }, watchTutorialText);
};

var getButtonStyles = function getButtonStyles(style, textColor, backgroundColor) {
  var styles = {
    line: {
      kind: 'secondary',
      color: textColor,
      bgColor: 'inherit',
      borderColor: backgroundColor
    },
    fill: {
      kind: 'primary',
      color: textColor,
      bgColor: backgroundColor,
      borderColor: backgroundColor
    },
    text: {
      kind: 'plain',
      color: textColor,
      bgColor: 'transparent',
      borderColor: 'transparent'
    }
  };
  return styles[style];
};
var showTrigger = function showTrigger(isAdmin, isInternalDashboard, modal) {
  if (isAdmin && !modal) {
    return true;
  }
  if (isInternalDashboard && !modal) {
    return true;
  }
  if (!isAdmin && !isInternalDashboard) {
    return true;
  }
  return false;
};

var CreateOrderButton = function CreateOrderButton(_ref) {
  var isShowCreateOrderBtn = _ref.isShowCreateOrderBtn,
    createOrderLoading = _ref.createOrderLoading,
    onCreateOrderClick = _ref.onCreateOrderClick,
    themeProps = _ref.themeProps;
  var _themeProps$createOrd = themeProps.createOrderButton,
    createOrderText = _themeProps$createOrd.createOrderText,
    createOrderButtonFontFamily = _themeProps$createOrd.createOrderButtonFontFamily,
    createOrderButtonFontSize = _themeProps$createOrd.createOrderButtonFontSize,
    createOrderButtonBackgroundColor = _themeProps$createOrd.createOrderButtonBackgroundColor,
    createOrderButtonTextColor = _themeProps$createOrd.createOrderButtonTextColor,
    createOrderButtonStyle = _themeProps$createOrd.createOrderButtonStyle;
  var buttonStyles = getButtonStyles(createOrderButtonStyle, createOrderButtonTextColor, createOrderButtonBackgroundColor);
  return /*#__PURE__*/React.createElement(Button, {
    kind: buttonStyles.kind,
    color: buttonStyles.color,
    bgColor: buttonStyles.bgColor,
    borderColor: buttonStyles.borderColor,
    spinnerColor: buttonStyles.color,
    fontFamily: createOrderButtonFontFamily,
    textSize: "".concat(createOrderButtonFontSize, "px"),
    loading: createOrderLoading,
    disabled: !isShowCreateOrderBtn,
    alignSelf: 'end',
    onClick: onCreateOrderClick
  }, createOrderText);
};

var _templateObject$1, _templateObject2;
var Input = styled.input(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: 0;\n  opacity: 0;\n  cursor: pointer;\n  border: none;\n"])));
var Label = styled.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  overflow-wrap: break-word;\n  cursor: pointer;\n  padding: ", ";\n  margin-right: 1px;\n"])), function (props) {
  return props.padding;
});
var FileUpload = function FileUpload(_ref) {
  var _ref$content = _ref.content,
    content = _ref$content === undefined ? 'Upload' : _ref$content,
    handleFileUpload = _ref.handleFileUpload,
    _ref$isAdmin = _ref.isAdmin,
    isAdmin = _ref$isAdmin === undefined ? false : _ref$isAdmin,
    openModal = _ref.openModal,
    fileExists = _ref.fileExists,
    isModalOpen = _ref.isModalOpen,
    padding = _ref.padding;
  var handleClick = function handleClick(e) {
    if (fileExists && !isModalOpen) {
      e.preventDefault();
      openModal();
    }
  };
  var handleInput = function handleInput(e) {
    var _a;
    var inputEvent = e.currentTarget;
    var file = (_a = inputEvent.files) === null || _a === undefined ? undefined : _a[0];
    if (file) {
      openModal();
      handleFileUpload(file);
      inputEvent.value = '';
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input, {
    type: isAdmin ? "text" : "file",
    id: "mrca-upload-bulk-order",
    onClick: handleClick,
    onInput: handleInput,
    accept: ".csv, .xlsx"
  }), /*#__PURE__*/React.createElement(Label, {
    htmlFor: "mrca-upload-bulk-order",
    padding: padding
  }, content));
};

var UploadButton = function UploadButton(_ref) {
  var themeProps = _ref.themeProps,
    handleFileUpload = _ref.handleFileUpload,
    isAdmin = _ref.isAdmin,
    openModal = _ref.openModal,
    fileName = _ref.fileName,
    isModalOpen = _ref.isModalOpen,
    altStyle = _ref.altStyle;
  var _themeProps$uploadCSV = themeProps.uploadCSVButton,
    uploadButtonText = _themeProps$uploadCSV.uploadButtonText,
    uploadButtonFontSize = _themeProps$uploadCSV.uploadButtonFontSize,
    uploadCSVButtonFontFamily = _themeProps$uploadCSV.uploadCSVButtonFontFamily,
    uploadCSVButtonBackgroundColor = _themeProps$uploadCSV.uploadCSVButtonBackgroundColor,
    uploadCSVButtonTextColor = _themeProps$uploadCSV.uploadCSVButtonTextColor,
    uploadButtonStyle = _themeProps$uploadCSV.uploadButtonStyle,
    _themeProps$createOrd = themeProps.createOrderButton,
    createOrderButtonFontFamily = _themeProps$createOrd.createOrderButtonFontFamily,
    createOrderButtonFontSize = _themeProps$createOrd.createOrderButtonFontSize,
    createOrderButtonBackgroundColor = _themeProps$createOrd.createOrderButtonBackgroundColor,
    createOrderButtonTextColor = _themeProps$createOrd.createOrderButtonTextColor,
    createOrderButtonStyle = _themeProps$createOrd.createOrderButtonStyle;
  // used for upload modal when trigger type is banner
  var altButtonStyles = getButtonStyles(createOrderButtonStyle, createOrderButtonTextColor, createOrderButtonBackgroundColor);
  var uploadButtonStyles = getButtonStyles(uploadButtonStyle, uploadCSVButtonTextColor, uploadCSVButtonBackgroundColor);
  var styles = altStyle ? altButtonStyles : uploadButtonStyles;
  var padding = styles.kind === 'plain' ? '0' : '14px 22px';
  var buttonStyleProps = {
    kind: styles.kind,
    color: styles.color,
    bgColor: styles.bgColor,
    borderColor: styles.borderColor,
    fontFamily: altStyle ? createOrderButtonFontFamily : uploadCSVButtonFontFamily,
    textSize: altStyle ? "".concat(createOrderButtonFontSize, "px") : "".concat(uploadButtonFontSize, "px")
  };
  return /*#__PURE__*/React.createElement(Button, Object.assign({}, buttonStyleProps, {
    padding: '0'
  }), /*#__PURE__*/React.createElement(FileUpload, {
    content: uploadButtonText,
    handleFileUpload: handleFileUpload,
    isAdmin: isAdmin,
    openModal: openModal,
    fileExists: !!fileName,
    isModalOpen: isModalOpen,
    padding: padding
  }));
};

var DownloadButton = function DownloadButton(_ref) {
  var themeProps = _ref.themeProps,
    onDownloadButtonClick = _ref.onDownloadButtonClick,
    isAdmin = _ref.isAdmin,
    csvUploadFormat = _ref.csvUploadFormat,
    loading = _ref.loading;
  var _themeProps$downloadC = themeProps.downloadCatalogButton,
    downloadButtonText = _themeProps$downloadC.downloadButtonText,
    downloadCatalogButtonFontFamily = _themeProps$downloadC.downloadCatalogButtonFontFamily,
    downloadButtonFontSize = _themeProps$downloadC.downloadButtonFontSize,
    downloadCatalogButtonBackgroundColor = _themeProps$downloadC.downloadCatalogButtonBackgroundColor,
    downloadCatalogButtonTextColor = _themeProps$downloadC.downloadCatalogButtonTextColor,
    downloadButtonStyle = _themeProps$downloadC.downloadButtonStyle;
  var downloadButtonStyles = getButtonStyles(downloadButtonStyle, downloadCatalogButtonTextColor, downloadCatalogButtonBackgroundColor);
  return /*#__PURE__*/React.createElement(Button, {
    kind: downloadButtonStyles.kind,
    color: downloadButtonStyles.color,
    bgColor: downloadButtonStyles.bgColor,
    borderColor: downloadButtonStyles.borderColor,
    fontFamily: downloadCatalogButtonFontFamily,
    textSize: "".concat(downloadButtonFontSize, "px"),
    onClick: function onClick() {
      return !isAdmin && onDownloadButtonClick(true);
    }
  }, csvUploadFormat === 'button' && loading ? /*#__PURE__*/React.createElement(Spinner, null) : downloadButtonText);
};

var Tabs = function Tabs(_ref) {
  var tabs = _ref.tabs,
    tabsStyle = _ref.tabsStyle,
    activeTab = _ref.activeTab,
    setActiveTab = _ref.setActiveTab;
  var tabsBackgroundColor = tabsStyle.tabsBackgroundColor,
    tabsDefaultTextColor = tabsStyle.tabsDefaultTextColor,
    tabsActiveBackgroundColor = tabsStyle.tabsActiveBackgroundColor,
    tabsActiveTextColor = tabsStyle.tabsActiveTextColor,
    tabsFontFamily = tabsStyle.tabsFontFamily,
    tabsFontSize = tabsStyle.tabsFontSize;
  return /*#__PURE__*/React.createElement(InlineLayout, {
    horizontalAlign: "start",
    gap: "8px",
    width: "max-content",
    bgColor: tabsBackgroundColor,
    fontFamily: tabsFontFamily,
    padding: "6px",
    cornerRadius: "6px"
  }, tabs.map(function (_ref2) {
    var label = _ref2.label,
      value = _ref2.value;
    return /*#__PURE__*/React.createElement(Text, {
      textSize: "".concat(tabsFontSize, "px"),
      padding: "4px",
      fontFamily: tabsFontFamily,
      backgroundcolor: activeTab === value ? tabsActiveBackgroundColor : tabsBackgroundColor,
      borderRadius: "6px",
      color: activeTab === value ? tabsActiveTextColor : tabsDefaultTextColor,
      onClick: function onClick() {
        return setActiveTab(value);
      },
      cursor: "pointer",
      key: value
    }, label);
  }));
};

var TitleAndSubtitle = function TitleAndSubtitle(_ref) {
  var titleKeys = _ref.titleKeys,
    subtitleKeys = _ref.subtitleKeys;
  var titleText = titleKeys.titleText,
    titleFontSize = titleKeys.titleFontSize,
    titleFontFamily = titleKeys.titleFontFamily,
    titleTextColor = titleKeys.titleTextColor,
    titleFontWeight = titleKeys.titleFontWeight;
  var subtitleText = subtitleKeys.subtitleText,
    subtitleFontSize = subtitleKeys.subtitleFontSize,
    subtitleFontFamily = subtitleKeys.subtitleFontFamily,
    subtitleTextColor = subtitleKeys.subtitleTextColor,
    subtitleFontWeight = subtitleKeys.subtitleFontWeight;
  return /*#__PURE__*/React.createElement(FlexDiv, {
    flexdir: 'column'
  }, /*#__PURE__*/React.createElement(MdText, {
    fontSize: "".concat(titleFontSize, "px"),
    alignment: "start",
    color: titleTextColor,
    fontWeight: titleFontWeight,
    fontFamily: titleFontFamily,
    width: '100%'
  }, titleText), /*#__PURE__*/React.createElement(MdText, {
    fontSize: "".concat(subtitleFontSize, "px"),
    alignment: "start",
    color: subtitleTextColor,
    fontWeight: subtitleFontWeight,
    fontFamily: subtitleFontFamily,
    width: '100%'
  }, subtitleText));
};

var MagnifyIcon = function MagnifyIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? '#707070' : _ref$color,
    style = _ref.style,
    _ref$size = _ref.size,
    size = _ref$size === undefined ? 18 : _ref$size;
  return /*#__PURE__*/React.createElement("svg", {
    style: style,
    width: size,
    height: size,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7792 11.7747C12.7543 10.799 13.3574 9.45135 13.3574 7.96287C13.3574 4.98464 10.943 2.57031 7.96482 2.57031C4.98659 2.57031 2.57227 4.98464 2.57227 7.96287C2.57227 10.9411 4.98659 13.3554 7.96482 13.3554C9.45456 13.3554 10.8032 12.7513 11.7792 11.7747ZM11.7792 11.7747L16.2008 16.1989",
    stroke: color,
    "stroke-width": "1.4",
    "stroke-linecap": "round"
  }));
};

var AddButton = function AddButton(_ref) {
  var isDisabled = _ref.isDisabled,
    onAddButtonClick = _ref.onAddButtonClick,
    themeProps = _ref.themeProps,
    margin = _ref.margin;
  var quickSearchAddButtonText = themeProps.quickSearchAddButtonText,
    quickSearchAddButtonBackgroundColor = themeProps.quickSearchAddButtonBackgroundColor,
    quickSearchAddButtonTextColor = themeProps.quickSearchAddButtonTextColor,
    quickSearchAddButtonFontSize = themeProps.quickSearchAddButtonFontSize,
    quickSearchAddButtonFontFamily = themeProps.quickSearchAddButtonFontFamily,
    quickSearchAddButtonStyle = themeProps.quickSearchAddButtonStyle;
  var buttonStyles = getButtonStyles(quickSearchAddButtonStyle, quickSearchAddButtonTextColor, quickSearchAddButtonBackgroundColor);
  return /*#__PURE__*/React.createElement(Button, {
    kind: buttonStyles.kind,
    color: buttonStyles.color,
    bgColor: buttonStyles.bgColor,
    borderColor: buttonStyles.borderColor,
    spinnerColor: buttonStyles.color,
    fontFamily: quickSearchAddButtonFontFamily,
    textSize: "".concat(quickSearchAddButtonFontSize, "px"),
    disabled: isDisabled,
    onClick: onAddButtonClick,
    margin: margin
  }, quickSearchAddButtonText);
};

var SearchRow = function SearchRow(props) {
  var _a;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showSearchResults = _React$useState2[0],
    setShowSearchResults = _React$useState2[1];
  React.useRef(null);
  var stepperValueRef = React.useRef(null);
  var firstDropdownItemRef = React.useRef(null);
  var inputRef = React.useRef(null);
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    dropdownFocusedIndex = _React$useState4[0],
    setDropdownFocusedIndex = _React$useState4[1];
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    errorMessage = _React$useState6[0],
    setErrorMessage = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isInputFocused = _React$useState8[0],
    setIsInputFocused = _React$useState8[1];
  var searchRowKeys = props.searchRowKeys,
    searchedValue = props.searchedValue,
    quickSearchErrorKeys = props.quickSearchErrorKeys,
    setSearchedValue = props.setSearchedValue,
    fetchSearchedProducts = props.fetchSearchedProducts,
    searchedProducts = props.searchedProducts,
    setSearchedProducts = props.setSearchedProducts,
    quickSearchSelectedProduct = props.quickSearchSelectedProduct,
    setQuickSearchSelectedProduct = props.setQuickSearchSelectedProduct,
    onQuickSearchProductAdd = props.onQuickSearchProductAdd,
    onQuickSearchProductChangeForSearchRow = props.onQuickSearchProductChangeForSearchRow,
    searchedProductsLoading = props.searchedProductsLoading,
    getInlineError = props.getInlineError,
    color = props.color,
    isAdmin = props.isAdmin,
    isAvailableStockEnabledForQuickSearch = props.isAvailableStockEnabledForQuickSearch;
  var _ref = quickSearchSelectedProduct !== null && quickSearchSelectedProduct !== undefined ? quickSearchSelectedProduct : {},
    _ref$min = _ref.min,
    min = _ref$min === undefined ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === undefined ? 0 : _ref$max,
    _ref$availableStock = _ref.availableStock,
    availableStock = _ref$availableStock === undefined ? 0 : _ref$availableStock,
    _ref$quantity = _ref.quantity,
    quantity = _ref$quantity === undefined ? 0 : _ref$quantity,
    _ref$increment = _ref.increment,
    increment = _ref$increment === undefined ? 1 : _ref$increment,
    error = _ref.error,
    variantId = _ref.variantId;
  var quickSearchPlaceholderText = searchRowKeys.quickSearchPlaceholderText,
    quickSearchAddButtonText = searchRowKeys.quickSearchAddButtonText,
    quickSearchAddButtonBackgroundColor = searchRowKeys.quickSearchAddButtonBackgroundColor,
    quickSearchAddButtonTextColor = searchRowKeys.quickSearchAddButtonTextColor,
    quickSearchAddButtonFontSize = searchRowKeys.quickSearchAddButtonFontSize,
    quickSearchAddButtonFontFamily = searchRowKeys.quickSearchAddButtonFontFamily,
    quickSearchAddButtonStyle = searchRowKeys.quickSearchAddButtonStyle,
    lineItemErrorTextColor = searchRowKeys.lineItemErrorTextColor;
  var errorOutOfStockText = quickSearchErrorKeys.errorOutOfStockText,
    errorInvalidVariantText = quickSearchErrorKeys.errorInvalidVariantText;
  var shouldShowOutOfStock = min > availableStock;
  var disableAddButton = shouldShowOutOfStock || !variantId || !!error;
  var handleProductSelect = function handleProductSelect(item) {
    var label = getLabelValue(item);
    setSearchedValue(label);
    setQuickSearchSelectedProduct(item);
    setShowSearchResults(false);
    setTimeout(function () {
      var _a;
      (_a = stepperValueRef.current) === null || _a === undefined ? undefined : _a.focus();
    }, 0);
  };
  useEffect(function () {
    if (stepperValueRef.current && document.activeElement === stepperValueRef.current) {
      setIsInputFocused(false);
    }
  }, [document.activeElement]);
  useEffect(function () {
    if (error || shouldShowOutOfStock) {
      var _errorMessage = shouldShowOutOfStock && getInlineError({
        error: 'errorOutOfStockText',
        incrementValue: increment,
        themeProps: {
          errorOutOfStockText: errorOutOfStockText
        }
      }) || error;
      setErrorMessage(_errorMessage);
    } else {
      setErrorMessage('');
    }
  }, [error, shouldShowOutOfStock, errorOutOfStockText]);
  var getLabelValue = function getLabelValue(item) {
    var identifierUsed = item.identifierUsed || 'variantName';
    if (identifierUsed === 'variantName' || identifierUsed === 'productName') {
      return item.variantName.toLowerCase() === 'default title' ? "".concat(item.productName) : "".concat(item.productName, " ~ ").concat(item.variantName);
    }
    return "".concat(item.sku || item.barcode, " ~ ").concat(item.variantName.toLowerCase() === 'default title' ? item.productName : "".concat(item.productName, " / ").concat(item.variantName));
  };
  var createElementViaPortal = function createElementViaPortal(appendTo, positionedNearTo) {
    var portalElement = document.getElementById(appendTo);
    var positionedElement = document.getElementById(positionedNearTo);
    if (portalElement && positionedElement) {
      var positionedRect = positionedElement.getBoundingClientRect();
      var portalRect = portalElement.getBoundingClientRect();
      // Calculate position relative to the portal element
      var top = positionedRect.bottom - portalRect.top;
      var left = positionedRect.left - portalRect.left;
      // const width = positionedRect.width;
      // const d = Math.min(searchedProducts.length, 5) * 32.4;
      // const g = top - d - (searchedProducts.length ? 5 : 37);
      return /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          position: 'absolute',
          top: top,
          left: left,
          width: 45 + '%',
          backgroundColor: '#fff',
          border: '1px solid #E0E0E0',
          borderRadius: '4px',
          zIndex: 1000,
          maxHeight: '96px',
          overflowY: 'auto'
        }
      }, searchedProductsLoading ? (/*#__PURE__*/React.createElement(FlexDiv, {
        jc: 'center',
        ai: 'center',
        padding: "5px 0.5rem"
      }, /*#__PURE__*/React.createElement(Spinner, null))) : searchedProducts.length > 0 ? searchedProducts.map(function (product, idx) {
        return /*#__PURE__*/React.createElement("div", {
          key: product.variantId,
          id: "dropdown-item-".concat(idx),
          ref: idx === 0 ? firstDropdownItemRef : undefined,
          tabIndex: 0,
          onClick: function onClick() {
            return handleProductSelect(product);
          },
          onKeyDown: function onKeyDown(e) {
            return handleDropdownItemKeyDown(e, product, idx);
          },
          style: {
            padding: '1px 12px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            cursor: 'pointer',
            fontSize: '13px',
            backgroundColor: dropdownFocusedIndex === idx ? '#f0f0f0' : '#ffffff'
          },
          onMouseEnter: function onMouseEnter(e) {
            e.target.style.backgroundColor = '#f0f0f0';
            setDropdownFocusedIndex(idx);
          },
          onMouseLeave: function onMouseLeave(e) {
            e.target.style.backgroundColor = '#ffffff';
            setDropdownFocusedIndex(null);
          }
        }, /*#__PURE__*/React.createElement("img", {
          src: product.image || '',
          alt: product.productName,
          onError: function onError(e) {
            e.target.style.display = 'none';
          },
          style: {
            width: '18px',
            // height: '24px',
            borderRadius: '4px',
            marginRight: '8px'
          }
        }), getLabelValue(product));
      }) : (/*#__PURE__*/React.createElement(Text, {
        padding: "5px 0.5rem",
        textSize: '14px'
      }, errorInvalidVariantText))), portalElement);
    }
    return null;
  };
  var onInputFocus = function onInputFocus(e) {
    if (isAdmin) return;
    setErrorMessage('');
    setSearchedValue(e.target.value);
    setSearchedProducts([]);
    setShowSearchResults(true);
    fetchSearchedProducts(e.target.value);
  };
  var handleInputKeyDown = function handleInputKeyDown(e) {
    if (isAdmin) return;
    if (showSearchResults && (searchedProducts === null || searchedProducts === undefined ? undefined : searchedProducts.length) > 0) {
      if (e.key === 'Tab') {
        e.preventDefault();
        setDropdownFocusedIndex(0);
        setTimeout(function () {
          var _a;
          (_a = firstDropdownItemRef.current) === null || _a === undefined ? undefined : _a.focus();
        }, 0);
      }
    }
  };
  var handleDropdownItemKeyDown = function handleDropdownItemKeyDown(e, product, idx) {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      var nextIdx = idx + 1 < searchedProducts.length ? idx + 1 : 0;
      setDropdownFocusedIndex(nextIdx);
      setTimeout(function () {
        var _a;
        (_a = document.getElementById("dropdown-item-".concat(nextIdx))) === null || _a === undefined ? undefined : _a.focus();
      }, 0);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      var prevIdx = idx - 1 >= 0 ? idx - 1 : searchedProducts.length - 1;
      setDropdownFocusedIndex(prevIdx);
      setTimeout(function () {
        var _a;
        (_a = document.getElementById("dropdown-item-".concat(prevIdx))) === null || _a === undefined ? undefined : _a.focus();
      }, 0);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      handleProductSelect(product);
    } else if (e.key === 'Tab') {
      e.preventDefault();
      var _nextIdx = idx + 1;
      setDropdownFocusedIndex(_nextIdx);
      setTimeout(function () {
        var _a, _b;
        if (_nextIdx <= searchedProducts.length - 1) (_a = document.getElementById("dropdown-item-".concat(_nextIdx))) === null || _a === undefined ? undefined : _a.focus();else {
          setIsInputFocused(false);
          (_b = stepperValueRef.current) === null || _b === undefined ? undefined : _b.focus();
        }
      }, 0);
    }
  };
  var displayAvailableStock = variantId ? availableStock : '-';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: errorMessage ? 'error-row' : ''
  }, /*#__PURE__*/React.createElement("td", {
    colSpan: 2
  }, /*#__PURE__*/React.createElement(FlexDiv, {
    id: "mrca-quick-search-input",
    padding: '0.7rem',
    border: "1px solid ".concat(color, "33"),
    borderradius: "4px",
    ai: "center",
    position: "relative",
    margin: errorMessage ? '0 0 1rem 0' : '0',
    backgroundcolor: "white",
    style: {
      display: 'block'
    }
  }, /*#__PURE__*/React.createElement(MagnifyIcon, {
    size: 14,
    style: {
      position: 'absolute',
      left: '8px',
      top: '47%',
      transform: 'translateY(-50%)'
    }
  }), /*#__PURE__*/React.createElement("input", {
    type: "text",
    placeholder: quickSearchPlaceholderText,
    style: {
      border: 'none',
      outline: 'none',
      boxShadow: 'none',
      width: '-webkit-fill-available',
      marginLeft: '18px',
      fontSize: '14px',
      MozUserFocus: 'none'
    },
    value: searchedValue,
    onChange: onInputFocus,
    onKeyDown: handleInputKeyDown,
    ref: inputRef,
    onFocus: function onFocus(e) {
      setIsInputFocused(true);
      e.target.style.border = 'none';
      e.target.style.outline = 'none';
      e.target.style.boxShadow = 'none';
    },
    onKeyDownCapture: function onKeyDownCapture(e) {
      if (e.key === 'Tab') {
        if ((searchedProducts === null || searchedProducts === undefined ? undefined : searchedProducts.length) > 0) {
          e.preventDefault();
          setIsInputFocused(true);
          setDropdownFocusedIndex(0);
          setTimeout(function () {
            var _a;
            (_a = firstDropdownItemRef.current) === null || _a === undefined ? undefined : _a.focus();
          }, 0);
        }
      }
    }
  }), errorMessage && (/*#__PURE__*/React.createElement(FlexDiv, {
    color: lineItemErrorTextColor,
    position: "absolute",
    top: "100%"
  }, errorMessage)), !!(searchedValue === null || searchedValue === undefined ? undefined : searchedValue.length) && showSearchResults && isInputFocused && createElementViaPortal('mrca-dialog', 'mrca-quick-search-input'))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Stepper, {
    label: "",
    increment: (_a = quickSearchSelectedProduct === null || quickSearchSelectedProduct === undefined ? undefined : quickSearchSelectedProduct.increment) !== null && _a !== undefined ? _a : 1,
    value: quantity,
    min: Math.max(0, Math.min(min !== null && min !== undefined ? min : 0, quantity)),
    max: Math.min(max !== null && max !== undefined ? max : 0, availableStock !== null && availableStock !== undefined ? availableStock : 0),
    id: "quantity-stepper",
    isMobile: false,
    onChange: function onChange(value) {
      onQuickSearchProductChangeForSearchRow(value);
    },
    color: color,
    margin: errorMessage ? '0 0 1rem 0' : '0',
    stepperValueRef: stepperValueRef,
    disable: !searchedValue
  })), isAvailableStockEnabledForQuickSearch && (/*#__PURE__*/React.createElement("td", null, displayAvailableStock)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AddButton, {
    isDisabled: disableAddButton,
    onAddButtonClick: function onAddButtonClick() {
      onQuickSearchProductAdd(quickSearchSelectedProduct);
      setQuickSearchSelectedProduct({
        variantId: '',
        variantName: '',
        productName: '',
        image: '',
        min: 0,
        max: 0,
        availableStock: 0,
        increment: 1,
        quantity: 0,
        error: ''
      });
      setSearchedValue('');
      setSearchedProducts([]);
      setTimeout(function () {
        var _a;
        (_a = inputRef.current) === null || _a === undefined ? undefined : _a.focus();
      }, 0);
    },
    themeProps: {
      quickSearchAddButtonText: quickSearchAddButtonText,
      quickSearchAddButtonBackgroundColor: quickSearchAddButtonBackgroundColor,
      quickSearchAddButtonTextColor: quickSearchAddButtonTextColor,
      quickSearchAddButtonFontSize: Number(quickSearchAddButtonFontSize),
      quickSearchAddButtonFontFamily: quickSearchAddButtonFontFamily,
      quickSearchAddButtonStyle: quickSearchAddButtonStyle
    },
    margin: errorMessage ? '0 0 1rem 0' : '0'
  }))), error && (/*#__PURE__*/React.createElement("tr", {
    className: "error-row"
  }, /*#__PURE__*/React.createElement("td", {
    colSpan: 7,
    className: "error-row"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "inherit"
  }, error)))));
};

var Row = function Row(props) {
  var row = props.row,
    errorKeys = props.errorKeys,
    setData = props.setData,
    onDelete = props.onDelete,
    index = props.index,
    closestMultiples = props.closestMultiples,
    color = props.color,
    isAvailableStockEnabledForQuickSearch = props.isAvailableStockEnabledForQuickSearch;
  var min = row.min,
    max = row.max,
    availableStock = row.availableStock,
    quantity = row.quantity,
    increment = row.increment,
    image = row.image,
    variantName = row.variantName,
    productName = row.productName,
    error = row.error,
    variantId = row.variantId;
  function getLabel(productName, variantName) {
    if (variantName && variantName.toLowerCase() !== 'default title') {
      return "".concat(productName, " - ").concat(variantName);
    }
    return productName;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: error ? 'error-row' : ''
  }, /*#__PURE__*/React.createElement("td", {
    style: {
      textAlign: 'center',
      padding: '14px 0 14px 14px' // Adjust padding for the first column
    }
  }, image ? (/*#__PURE__*/React.createElement(Icon, {
    height: "48px",
    width: "auto",
    src: image,
    alt: "Product Image"
  })) : (/*#__PURE__*/React.createElement(Icon, {
    width: "26px",
    alt: "No Image"
  }))), /*#__PURE__*/React.createElement("td", {
    className: error ? 'error-row' : ''
  }, /*#__PURE__*/React.createElement(FlexDiv, {
    color: error ? errorKeys.lineItemErrorTextColor : 'inherit',
    ai: "center"
  }, getLabel(productName, variantName))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Stepper, {
    label: "",
    increment: increment,
    min: Math.min(min, availableStock, closestMultiples(increment, min)[0], 0),
    max: Math.min(max, availableStock, closestMultiples(increment, max)[0]),
    id: "quantity-stepper",
    isMobile: false,
    onChange: function onChange(value) {
      setData(variantId, index, value !== null && value !== undefined ? value : 0);
    },
    value: quantity,
    color: error ? errorKeys.lineItemErrorTextColor : color
  })), isAvailableStockEnabledForQuickSearch && /*#__PURE__*/React.createElement("td", null, availableStock), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Button, {
    margin: "auto",
    kind: "plain",
    onClick: function onClick() {
      return onDelete(index);
    }
  }, /*#__PURE__*/React.createElement(Delete, null)))), error && (/*#__PURE__*/React.createElement("tr", {
    className: "error-row"
  }, /*#__PURE__*/React.createElement("td", {
    colSpan: 7,
    className: "error-row"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "inherit"
  }, error)))));
};

var ProductRow = function ProductRow(props) {
  var rowData = props.rowData,
    errorKeys = props.errorKeys,
    setData = props.setData,
    onDelete = props.onDelete,
    closestMultiples = props.closestMultiples,
    color = props.color,
    isAvailableStockEnabledForQuickSearch = props.isAvailableStockEnabledForQuickSearch;
  return rowData === null || rowData === undefined ? undefined : rowData.map(function (row, index) {
    return /*#__PURE__*/React.createElement(Row, {
      key: index,
      row: row,
      errorKeys: errorKeys,
      color: color,
      setData: setData,
      onDelete: onDelete,
      index: index,
      closestMultiples: closestMultiples,
      isAvailableStockEnabledForQuickSearch: isAvailableStockEnabledForQuickSearch
    });
  });
};

var keyMaps = {
  actions: 'Actions'
};
var Table = function Table(props) {
  var quickSearchTableAndOtherKeys = props.quickSearchTableAndOtherKeys,
    quickSearchErrorKeys = props.quickSearchErrorKeys,
    searchedValue = props.searchedValue,
    setSearchedValue = props.setSearchedValue,
    fetchSearchedProducts = props.fetchSearchedProducts,
    searchedProducts = props.searchedProducts,
    setSearchedProducts = props.setSearchedProducts,
    quickSearchSelectedProduct = props.quickSearchSelectedProduct,
    setQuickSearchSelectedProduct = props.setQuickSearchSelectedProduct,
    quickSearchedTableData = props.quickSearchedTableData,
    setQuickSearchedTableData = props.setQuickSearchedTableData,
    onQuickSearchProductAdd = props.onQuickSearchProductAdd,
    onQuickSearchProductChange = props.onQuickSearchProductChange,
    onQuickSearchProductChangeForSearchRow = props.onQuickSearchProductChangeForSearchRow,
    searchedProductsLoading = props.searchedProductsLoading,
    getInlineError = props.getInlineError,
    closestMultiples = props.closestMultiples,
    isValueMultipleOfIncrement = props.isValueMultipleOfIncrement,
    isAdmin = props.isAdmin,
    isAvailableStockEnabledForQuickSearch = props.isAvailableStockEnabledForQuickSearch;
  var quickSearchProductColumnText = quickSearchTableAndOtherKeys.quickSearchProductColumnText,
    quickSearchQuantityText = quickSearchTableAndOtherKeys.quickSearchQuantityText,
    quickSearchPlaceholderText = quickSearchTableAndOtherKeys.quickSearchPlaceholderText,
    orderTableColumnNameFontFamily = quickSearchTableAndOtherKeys.orderTableColumnNameFontFamily,
    orderTableColumnNameFontSize = quickSearchTableAndOtherKeys.orderTableColumnNameFontSize,
    orderTableColumnNameTextColor = quickSearchTableAndOtherKeys.orderTableColumnNameTextColor,
    orderTableHeaderBackgroundColor = quickSearchTableAndOtherKeys.orderTableHeaderBackgroundColor,
    orderTableContentFontSize = quickSearchTableAndOtherKeys.orderTableContentFontSize,
    orderTableContentTextColor = quickSearchTableAndOtherKeys.orderTableContentTextColor,
    quickSearchAddButtonText = quickSearchTableAndOtherKeys.quickSearchAddButtonText,
    quickSearchAddButtonBackgroundColor = quickSearchTableAndOtherKeys.quickSearchAddButtonBackgroundColor,
    quickSearchAddButtonTextColor = quickSearchTableAndOtherKeys.quickSearchAddButtonTextColor,
    quickSearchAddButtonFontSize = quickSearchTableAndOtherKeys.quickSearchAddButtonFontSize,
    quickSearchAddButtonFontFamily = quickSearchTableAndOtherKeys.quickSearchAddButtonFontFamily,
    quickSearchAddButtonStyle = quickSearchTableAndOtherKeys.quickSearchAddButtonStyle;
    quickSearchTableAndOtherKeys.env;
  var searchRowKeys = {
    quickSearchPlaceholderText: String(quickSearchPlaceholderText),
    quickSearchAddButtonText: String(quickSearchAddButtonText),
    quickSearchAddButtonBackgroundColor: String(quickSearchAddButtonBackgroundColor),
    quickSearchAddButtonTextColor: String(quickSearchAddButtonTextColor),
    quickSearchAddButtonFontSize: String(quickSearchAddButtonFontSize),
    quickSearchAddButtonFontFamily: String(quickSearchAddButtonFontFamily),
    quickSearchAddButtonStyle: String(quickSearchAddButtonStyle),
    lineItemErrorTextColor: quickSearchErrorKeys.lineItemErrorTextColor
    // isAdmin: quickSearchTableAndOtherKeys.isAdmin as boolean,
    // env: env as string,
  };
  var getCellStyles = function getCellStyles(heading) {
    var width = '10%'; // Default width
    var padding = '14px'; // Default padding
    var textAlign = 'left';
    switch (heading) {
      case "":
        width = '70%';
        padding = '14px 0 14px 14px'; // Adjust padding for the first column
        textAlign = 'center';
        break;
      case quickSearchQuantityText:
        width = '20%';
        break;
    }
    return {
      textAlign: textAlign,
      padding: padding,
      width: width
    };
  };
  var onProductDelete = function onProductDelete(index) {
    // Remove the product from the quickSearchedTableData state
    var newData = _toConsumableArray(quickSearchedTableData);
    newData.splice(index, 1);
    setQuickSearchedTableData(newData);
  };
  return /*#__PURE__*/React.createElement(StyledContainer$1, null, /*#__PURE__*/React.createElement(StyledTable$1, {
    headingFontSize: orderTableColumnNameFontSize,
    headerBackgroundColor: orderTableHeaderBackgroundColor,
    padding: '14px',
    headingColor: orderTableColumnNameTextColor,
    contentFontSize: orderTableContentFontSize,
    contentColor: orderTableContentTextColor,
    errorBgColor: quickSearchErrorKeys.errorSummaryBackgroundColor,
    errorContentColor: quickSearchErrorKeys.lineItemErrorTextColor
  }, /*#__PURE__*/React.createElement(TableHeader, {
    fontFamily: orderTableColumnNameFontFamily,
    columnHeadings: [quickSearchProductColumnText, "", quickSearchQuantityText].concat(_toConsumableArray(isAvailableStockEnabledForQuickSearch ? [quickSearchTableAndOtherKeys.quickSearchAvailableStockText] : []), [keyMaps.actions]),
    getCellStyles: getCellStyles,
    backgroundColor: orderTableHeaderBackgroundColor
  }), /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement(ProductRow, {
    rowData: quickSearchedTableData,
    errorKeys: quickSearchErrorKeys,
    setData: onQuickSearchProductChange,
    onDelete: onProductDelete,
    closestMultiples: closestMultiples,
    color: orderTableContentTextColor,
    isAvailableStockEnabledForQuickSearch: isAvailableStockEnabledForQuickSearch
  }), /*#__PURE__*/React.createElement(SearchRow, {
    searchRowKeys: searchRowKeys,
    searchedValue: searchedValue,
    setSearchedValue: setSearchedValue,
    fetchSearchedProducts: fetchSearchedProducts,
    searchedProducts: searchedProducts,
    setSearchedProducts: setSearchedProducts,
    quickSearchSelectedProduct: quickSearchSelectedProduct,
    setQuickSearchSelectedProduct: setQuickSearchSelectedProduct,
    quickSearchedTableData: quickSearchedTableData,
    setQuickSearchedTableData: setQuickSearchedTableData,
    onQuickSearchProductAdd: onQuickSearchProductAdd,
    onQuickSearchProductChange: onQuickSearchProductChange,
    onQuickSearchProductChangeForSearchRow: onQuickSearchProductChangeForSearchRow,
    searchedProductsLoading: searchedProductsLoading,
    quickSearchErrorKeys: quickSearchErrorKeys,
    getInlineError: getInlineError,
    closestMultiples: closestMultiples,
    isValueMultipleOfIncrement: isValueMultipleOfIncrement,
    color: orderTableContentTextColor,
    isAdmin: isAdmin,
    isAvailableStockEnabledForQuickSearch: isAvailableStockEnabledForQuickSearch
  }))));
};

var QuickSearch = function QuickSearch(props) {
  var quickSearchTitleKeyss = props.titleKeys,
    quickSearchSubtitleKeyss = props.subtitleKeys,
    quickSearchTableAndOtherKeys = props.quickSearchTableAndOtherKeys,
    quickSearchErrorKeys = props.quickSearchErrorKeys,
    searchedValue = props.searchedValue,
    createOrderButton = props.createOrderButton,
    setSearchedValue = props.setSearchedValue,
    fetchSearchedProducts = props.fetchSearchedProducts,
    searchedProducts = props.searchedProducts,
    setSearchedProducts = props.setSearchedProducts,
    quickSearchSelectedProduct = props.quickSearchSelectedProduct,
    setQuickSearchSelectedProduct = props.setQuickSearchSelectedProduct,
    quickSearchedTableData = props.quickSearchedTableData,
    setQuickSearchedTableData = props.setQuickSearchedTableData,
    onQuickSearchProductAdd = props.onQuickSearchProductAdd,
    onQuickSearchProductChange = props.onQuickSearchProductChange,
    onClickCreateOrder = props.onClickCreateOrder,
    orderUrl = props.orderUrl,
    createOrderButtonLoading = props.createOrderButtonLoading,
    setCreateOrderButtonLoading = props.setCreateOrderButtonLoading,
    onQuickSearchProductChangeForSearchRow = props.onQuickSearchProductChangeForSearchRow,
    searchedProductsLoading = props.searchedProductsLoading,
    getInlineError = props.getInlineError,
    closestMultiples = props.closestMultiples,
    isValueMultipleOfIncrement = props.isValueMultipleOfIncrement,
    isAdmin = props.isAdmin,
    isAvailableStockEnabledForQuickSearch = props.isAvailableStockEnabledForQuickSearch;
  var isShowCreateOrderBtn = quickSearchedTableData.some(function (product) {
    return product.error;
  });
  return /*#__PURE__*/React.createElement(BlockLayout, {
    width: "100%",
    horizontalAlign: "start",
    gap: '21px'
  }, /*#__PURE__*/React.createElement(TitleAndSubtitle, {
    titleKeys: quickSearchTitleKeyss,
    subtitleKeys: quickSearchSubtitleKeyss
  }), /*#__PURE__*/React.createElement(FlexDiv, {
    border: "1px solid #E0E0E0",
    borderradius: "8px",
    width: "100%",
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(Table, {
    quickSearchTableAndOtherKeys: quickSearchTableAndOtherKeys,
    quickSearchErrorKeys: quickSearchErrorKeys,
    searchedValue: searchedValue,
    setSearchedValue: setSearchedValue,
    fetchSearchedProducts: fetchSearchedProducts,
    searchedProducts: searchedProducts,
    setSearchedProducts: setSearchedProducts,
    quickSearchSelectedProduct: quickSearchSelectedProduct,
    setQuickSearchSelectedProduct: setQuickSearchSelectedProduct,
    quickSearchedTableData: quickSearchedTableData,
    setQuickSearchedTableData: setQuickSearchedTableData,
    onQuickSearchProductAdd: onQuickSearchProductAdd,
    onQuickSearchProductChange: onQuickSearchProductChange,
    onClickCreateOrder: onClickCreateOrder,
    orderUrl: orderUrl,
    createOrderButtonLoading: createOrderButtonLoading,
    setCreateOrderButtonLoading: setCreateOrderButtonLoading,
    onQuickSearchProductChangeForSearchRow: onQuickSearchProductChangeForSearchRow,
    searchedProductsLoading: searchedProductsLoading,
    getInlineError: getInlineError,
    closestMultiples: closestMultiples,
    isValueMultipleOfIncrement: isValueMultipleOfIncrement,
    isAdmin: isAdmin,
    isAvailableStockEnabledForQuickSearch: isAvailableStockEnabledForQuickSearch
  })), /*#__PURE__*/React.createElement(CreateOrderButton, {
    isShowCreateOrderBtn: !isShowCreateOrderBtn && !!quickSearchedTableData.length,
    createOrderLoading: createOrderButtonLoading,
    onCreateOrderClick: onClickCreateOrder,
    themeProps: createOrderButton
  }));
};

var UploadModal = function UploadModal(_ref) {
  var themeProps = _ref.themeProps,
    watchTutorialLink = _ref.watchTutorialLink,
    isShowWatchTutorial = _ref.isShowWatchTutorial,
    handleFileUpload = _ref.handleFileUpload,
    isHideDownloadButton = _ref.isHideDownloadButton,
    onDownloadButtonClick = _ref.onDownloadButtonClick,
    downloadBtnLoading = _ref.downloadBtnLoading,
    isShowProgressBar = _ref.isShowProgressBar,
    progressValue = _ref.progressValue,
    processingText = _ref.processingText,
    fileName = _ref.fileName,
    tableData = _ref.tableData,
    isShowOrderTable = _ref.isShowOrderTable,
    onDeleteFile = _ref.onDeleteFile,
    errorList = _ref.errorList,
    onTableRowQuantityChange = _ref.onTableRowQuantityChange,
    createOrderLoading = _ref.createOrderLoading,
    isShowCreateOrderBtn = _ref.isShowCreateOrderBtn,
    showOrderURL = _ref.showOrderURL,
    createOrderUrl = _ref.createOrderUrl,
    onCreateOrderClick = _ref.onCreateOrderClick,
    fileUploadError = _ref.fileUploadError,
    onTableRowDelete = _ref.onTableRowDelete,
    isAdmin = _ref.isAdmin,
    setIsShowOrderTable = _ref.setIsShowOrderTable,
    isShowAvailableStock = _ref.isShowAvailableStock,
    isShowBarcode = _ref.isShowBarcode,
    handleCopy = _ref.handleCopy,
    copied = _ref.copied,
    incrementToken = _ref.incrementToken,
    minQtyToken = _ref.minQtyToken,
    maxQtyToken = _ref.maxQtyToken,
    availableQtyToken = _ref.availableQtyToken,
    inventoryPolicyToken = _ref.inventoryPolicyToken,
    columnTokens = _ref.columnTokens,
    tableHeadings = _ref.tableHeadings,
    csvUploadFormat = _ref.csvUploadFormat,
    closeModal = _ref.closeModal,
    isModalOpen = _ref.isModalOpen,
    tabsShouldBeVisible = _ref.tabsShouldBeVisible,
    activeTab = _ref.activeTab,
    setActiveTab = _ref.setActiveTab,
    searchedValue = _ref.searchedValue,
    setSearchedValue = _ref.setSearchedValue,
    fetchSearchedProducts = _ref.fetchSearchedProducts,
    searchedProducts = _ref.searchedProducts,
    setSearchedProducts = _ref.setSearchedProducts,
    quickSearchSelectedProduct = _ref.quickSearchSelectedProduct,
    setQuickSearchSelectedProduct = _ref.setQuickSearchSelectedProduct,
    quickSearchedTableData = _ref.quickSearchedTableData,
    setQuickSearchedTableData = _ref.setQuickSearchedTableData,
    onQuickSearchProductAdd = _ref.onQuickSearchProductAdd,
    onQuickSearchProductChange = _ref.onQuickSearchProductChange,
    onClickCreateOrder = _ref.onClickCreateOrder,
    orderUrl = _ref.orderUrl,
    createOrderButtonLoading = _ref.createOrderButtonLoading,
    setCreateOrderButtonLoading = _ref.setCreateOrderButtonLoading,
    onQuickSearchProductChangeForSearchRow = _ref.onQuickSearchProductChangeForSearchRow,
    searchedProductsLoading = _ref.searchedProductsLoading,
    getInlineError = _ref.getInlineError,
    closestMultiples = _ref.closestMultiples,
    isValueMultipleOfIncrement = _ref.isValueMultipleOfIncrement,
    env = _ref.env,
    isAvailableStockEnabledForQuickSearch = _ref.isAvailableStockEnabledForQuickSearch;
  var isEmptyState = tableData.length === 0 && errorList.length === 0 && !fileName;
  var isUploadErrorState = tableData.length === 0 && errorList.length > 0;
  var isShowUploadAndDownloadButtons = isEmptyState || isUploadErrorState;
  var tableThemeProps = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, themeProps.title), themeProps.subtitle), themeProps.orderTableHeader), themeProps.errorText), themeProps.orderTableColumnName), themeProps.orderTableContent), themeProps.errorSummaryTitle), themeProps.lineItemError);
  var deleteFile = function deleteFile() {
    if (isAdmin) return;
    onDeleteFile();
    if (csvUploadFormat === 'banner') {
      closeModal();
    }
  };
  var bulkOrderTitleKeys = useMemo(function () {
    return {
      titleText: themeProps.title.titleText,
      titleFontSize: themeProps.title.titleFontSize,
      titleFontFamily: themeProps.title.titleFontFamily,
      titleTextColor: themeProps.title.titleTextColor,
      titleFontWeight: themeProps.title.titleFontWeight
    };
  }, [themeProps.title]);
  var bulkOrderSubtitleKeys = useMemo(function () {
    return {
      subtitleText: themeProps.subtitle.subtitleText,
      subtitleFontSize: themeProps.subtitle.subtitleFontSize,
      subtitleFontFamily: themeProps.subtitle.subtitleFontFamily,
      subtitleTextColor: themeProps.subtitle.subtitleTextColor,
      subtitleFontWeight: themeProps.subtitle.subtitleFontWeight
    };
  }, [themeProps.subtitle]);
  var quickSearchTitleKeys = useMemo(function () {
    return {
      titleText: themeProps.title.quickSearchTitleText,
      titleFontSize: themeProps.title.titleFontSize,
      titleFontFamily: themeProps.title.titleFontFamily,
      titleTextColor: themeProps.title.titleTextColor,
      titleFontWeight: themeProps.title.titleFontWeight
    };
  }, [themeProps.title]);
  var quickSearchSubtitleKeys = useMemo(function () {
    return {
      subtitleText: themeProps.subtitle.quickSearchSubtitleText,
      subtitleFontSize: themeProps.subtitle.subtitleFontSize,
      subtitleFontFamily: themeProps.subtitle.subtitleFontFamily,
      subtitleTextColor: themeProps.subtitle.subtitleTextColor,
      subtitleFontWeight: themeProps.subtitle.subtitleFontWeight
    };
  }, [themeProps.subtitle]);
  var tabsStyle = useMemo(function () {
    return {
      tabsBackgroundColor: themeProps.tabsStyle.tabsBackgroundColor,
      tabsDefaultTextColor: themeProps.tabsStyle.tabsDefaultTextColor,
      tabsActiveBackgroundColor: themeProps.tabsStyle.tabsActiveBackgroundColor,
      tabsActiveTextColor: themeProps.tabsStyle.tabsActiveTextColor,
      tabsFontFamily: themeProps.tabsStyle.tabsFontFamily,
      tabsFontSize: themeProps.tabsStyle.tabsFontSize
    };
  }, [themeProps.tabsStyle]);
  var quickSearchTableAndOtherKeys = useMemo(function () {
    return {
      quickSearchProductColumnText: themeProps.orderTableColumnName.quickSearchProductColumnText,
      quickSearchQuantityText: themeProps.orderTableColumnName.quickSearchQuantityText,
      quickSearchAvailableStockText: columnTokens.availableQtyToken,
      quickSearchPlaceholderText: themeProps.quickSearchButtonAndPlaceholder.quickSearchPlaceholderText,
      orderTableColumnNameFontFamily: themeProps.orderTableColumnName.orderTableColumnNameFontFamily,
      orderTableColumnNameFontSize: themeProps.orderTableColumnName.orderTableColumnNameFontSize,
      orderTableColumnNameTextColor: themeProps.orderTableColumnName.orderTableColumnNameTextColor,
      orderTableHeaderBackgroundColor: themeProps.orderTableHeader.orderTableHeaderBackgroundColor,
      orderTableContentFontFamily: themeProps.orderTableContent.orderTableContentFontFamily,
      orderTableContentFontSize: themeProps.orderTableContent.orderTableContentFontSize,
      orderTableContentTextColor: themeProps.orderTableContent.orderTableContentTextColor,
      quickSearchAddButtonText: themeProps.quickSearchButtonAndPlaceholder.quickSearchAddButtonText,
      quickSearchAddButtonBackgroundColor: themeProps.quickSearchButtonAndPlaceholder.quickSearchAddButtonBackgroundColor,
      quickSearchAddButtonTextColor: themeProps.quickSearchButtonAndPlaceholder.quickSearchAddButtonTextColor,
      quickSearchAddButtonFontSize: themeProps.quickSearchButtonAndPlaceholder.quickSearchAddButtonFontSize,
      quickSearchAddButtonFontFamily: themeProps.quickSearchButtonAndPlaceholder.quickSearchAddButtonFontFamily,
      quickSearchAddButtonStyle: themeProps.quickSearchButtonAndPlaceholder.quickSearchAddButtonStyle,
      createOrderButtontext: themeProps.createOrderButton.createOrderButtonText,
      createOrderButtonBackgroundColor: themeProps.createOrderButton.createOrderButtonBackgroundColor,
      createOrderButtonTextColor: themeProps.createOrderButton.createOrderButtonTextColor,
      createOrderButtonFontSize: themeProps.createOrderButton.createOrderButtonFontSize,
      createOrderButtonFontFamily: themeProps.createOrderButton.createOrderButtonFontFamily,
      createOrderButtonStyle: themeProps.createOrderButton.createOrderButtonStyle,
      lineItemErrorTextColor: themeProps.lineItemError.lineItemErrorTextColor,
      isAdmin: isAdmin,
      env: env
    };
  }, [themeProps, isAdmin, env]);
  var quickSearchErrorKeys = useMemo(function () {
    return {
      errorOutOfStockText: themeProps.errorText.errorOutOfStockText,
      errorMinOrderQuantityText: themeProps.errorText.errorMinOrderQuantityText,
      errorMaxOrderQuantityText: themeProps.errorText.errorMaxOrderQuantityText,
      errorAvailableQuantityText: themeProps.errorText.errorAvailableQuantityText,
      errorIncrementQuantityText: themeProps.errorText.errorIncrementQuantityText,
      errorInvalidVariantText: themeProps.errorText.errorInvalidVariantText,
      errorSummaryBackgroundColor: themeProps.errorSummaryTitle.errorSummaryBackgroundColor,
      lineItemErrorTextColor: themeProps.lineItemError.lineItemErrorTextColor
    };
  }, [themeProps.errorText, themeProps.errorSummaryTitle, themeProps.lineItemError]);
  var tabs = useMemo(function () {
    return [{
      label: themeProps.tabs.bulkOrderTabText,
      value: 'by_download_upload'
    }, {
      label: themeProps.tabs.quickSearchTabText,
      value: 'by_search'
    }];
  }, [themeProps.tabs]);
  return /*#__PURE__*/React.createElement(BlockLayout, {
    horizontalAlign: "start",
    padding: "21px 14px",
    gap: "21px",
    textAlign: "start",
    textSize: "".concat(themeProps.subtitle.subtitleFontSize, "px")
  }, csvUploadFormat === 'button' && tabsShouldBeVisible && (/*#__PURE__*/React.createElement(Tabs, {
    tabs: tabs,
    tabsStyle: tabsStyle,
    activeTab: activeTab,
    setActiveTab: setActiveTab
  })), activeTab === 'by_download_upload' && (/*#__PURE__*/React.createElement(React.Fragment, null, csvUploadFormat === 'button' && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TitleAndSubtitle, {
    titleKeys: bulkOrderTitleKeys,
    subtitleKeys: bulkOrderSubtitleKeys
  }))), tableData.length > 0 && (/*#__PURE__*/React.createElement(InlineLayout, {
    horizontalAlign: "start"
  }, /*#__PURE__*/React.createElement(Badge, {
    kind: "plain",
    icon: /*#__PURE__*/React.createElement(NoteIcon, {
      size: themeProps.fileName.fileNameFontSize,
      color: themeProps.fileName.fileNameTextColor
    }),
    fontFamily: themeProps.fileName.fileNameFontFamily,
    textSize: "".concat(themeProps.fileName.fileNameFontSize, "px"),
    color: themeProps.fileName.fileNameTextColor,
    borderColor: "".concat(themeProps.fileName.fileNameTextColor, "33")
  }, fileName), /*#__PURE__*/React.createElement(Button, {
    onClick: deleteFile,
    kind: "plain",
    padding: "6px"
  }, /*#__PURE__*/React.createElement(Delete, {
    color: "".concat(themeProps.fileName.fileNameTextColor, "b3")
  })))), csvUploadFormat === 'button' && /*#__PURE__*/React.createElement(Divider, null), isShowProgressBar && progressValue !== 100 && (/*#__PURE__*/React.createElement(ProgressBar, {
    title: processingText,
    titleTextSize: "12px",
    titleFontFamily: "inherit",
    titleColor: themeProps.orderTableContent.orderTableContentTextColor,
    helperText: fileName,
    helperTextSize: "12px",
    helperFontFamily: "inherit",
    progress: progressValue
  })), errorList.length > 0 && (/*#__PURE__*/React.createElement(AlertBanner, {
    title: tableThemeProps.errorTitleText,
    messages: errorList,
    variant: "critical",
    titleFontFamily: themeProps.errorSummaryTitle.errorSummaryTitleFontFamily,
    titleFontSize: themeProps.errorSummaryTitle.errorSummaryTitleFontSize,
    titleColor: themeProps.errorSummaryTitle.errorCardTitleTextColor,
    bgColor: themeProps.errorSummaryTitle.errorSummaryBackgroundColor,
    contentFontFamily: themeProps.errorSummaryContent.errorSummaryContentFontFamily,
    contentFontSize: themeProps.errorSummaryContent.errorSummaryContentFontSize,
    contentColor: themeProps.errorSummaryContent.errorCardContentTextColor
  })), isShowUploadAndDownloadButtons && !isShowProgressBar && (/*#__PURE__*/React.createElement(BlockLayout, {
    horizontalAlign: "start",
    gap: "12px"
  }, /*#__PURE__*/React.createElement(InlineLayout, {
    horizontalAlign: isShowWatchTutorial ? 'between' : 'end',
    horizontalGap: "4px",
    wrap: false
  }, isShowWatchTutorial && csvUploadFormat !== 'banner' && (/*#__PURE__*/React.createElement(WatchTutorialButton, {
    isAdmin: isAdmin,
    watchTutorialLink: watchTutorialLink,
    themeProps: themeProps
  })), /*#__PURE__*/React.createElement(InlineLayout, {
    width: "auto",
    horizontalAlign: 'end',
    gap: "10px"
  }, /*#__PURE__*/React.createElement(UploadButton, {
    themeProps: themeProps,
    handleFileUpload: handleFileUpload,
    isAdmin: isAdmin,
    openModal: function openModal() {},
    fileName: fileName,
    isModalOpen: isModalOpen,
    altStyle: csvUploadFormat === 'banner'
  }), !isHideDownloadButton && csvUploadFormat !== 'banner' && (/*#__PURE__*/React.createElement(DownloadButton, {
    themeProps: themeProps,
    onDownloadButtonClick: onDownloadButtonClick,
    isAdmin: isAdmin,
    csvUploadFormat: csvUploadFormat,
    loading: downloadBtnLoading
  })))), fileUploadError && /*#__PURE__*/React.createElement("p", null, fileUploadError))), tableData.length > 0 && (/*#__PURE__*/React.createElement(BlockLayout, {
    height: isAdmin ? 'auto' : '100%',
    gap: "10px"
  }, /*#__PURE__*/React.createElement(CollapsibleCard, {
    children: /*#__PURE__*/React.createElement(OrderTableSection, {
      tableData: tableData,
      themeProps: themeProps,
      tableThemeProps: tableThemeProps,
      onTableRowQuantityChange: onTableRowQuantityChange,
      onTableRowDelete: onTableRowDelete,
      isShowAvailableStock: isShowAvailableStock,
      isShowBarcode: isShowBarcode,
      createOrderUrl: createOrderUrl,
      showOrderURL: showOrderURL,
      isShowOrderTable: isShowOrderTable,
      handleCopy: handleCopy,
      copied: copied,
      incrementToken: incrementToken,
      minQtyToken: minQtyToken,
      maxQtyToken: maxQtyToken,
      availableQtyToken: availableQtyToken,
      inventoryPolicyToken: inventoryPolicyToken,
      columnTokens: columnTokens,
      tableHeadings: tableHeadings
    }),
    titleTextSize: "".concat(themeProps.orderTableHeader.orderTableHeaderFontSize, "px"),
    titleFontWeight: 500,
    titleColor: themeProps.orderTableHeader.orderTableHeaderTextColor,
    titleFontFamily: themeProps.orderTableHeader.orderTableHeaderFontFamily,
    titleText: themeProps.orderTableHeader.orderSummaryTableTitleText,
    buttonTextSize: '14px',
    buttonPadding: '0px',
    buttonTextColor: themeProps.orderTableHeader.orderTableHeaderTextColor,
    iconBeforeSize: 12,
    iconSpacing: 4,
    showText: themeProps.orderTableHeader.orderSummaryTableShowSummaryText,
    hideText: themeProps.orderTableHeader.orderSummaryTableHideSummaryText,
    isContentVisible: isShowOrderTable,
    toggleContentVisibility: function toggleContentVisibility() {
      return setIsShowOrderTable(!isShowOrderTable);
    }
  }), /*#__PURE__*/React.createElement(InlineLayout, {
    height: "auto",
    horizontalAlign: isShowWatchTutorial ? 'between' : 'end',
    wrap: false
  }, isShowWatchTutorial && (/*#__PURE__*/React.createElement(WatchTutorialButton, {
    isAdmin: isAdmin,
    watchTutorialLink: watchTutorialLink,
    themeProps: themeProps
  })), /*#__PURE__*/React.createElement(CreateOrderButton, {
    isShowCreateOrderBtn: isShowCreateOrderBtn,
    createOrderLoading: createOrderLoading,
    onCreateOrderClick: onCreateOrderClick,
    themeProps: themeProps
  })))))), activeTab === 'by_search' && (/*#__PURE__*/React.createElement(QuickSearch, {
    titleKeys: quickSearchTitleKeys,
    subtitleKeys: quickSearchSubtitleKeys,
    quickSearchTableAndOtherKeys: quickSearchTableAndOtherKeys,
    quickSearchErrorKeys: quickSearchErrorKeys,
    searchedValue: searchedValue,
    setSearchedValue: setSearchedValue,
    fetchSearchedProducts: fetchSearchedProducts,
    searchedProducts: searchedProducts,
    setSearchedProducts: setSearchedProducts,
    quickSearchSelectedProduct: quickSearchSelectedProduct,
    setQuickSearchSelectedProduct: setQuickSearchSelectedProduct,
    quickSearchedTableData: quickSearchedTableData,
    setQuickSearchedTableData: setQuickSearchedTableData,
    onQuickSearchProductAdd: onQuickSearchProductAdd,
    onQuickSearchProductChange: onQuickSearchProductChange,
    onClickCreateOrder: onClickCreateOrder,
    orderUrl: orderUrl,
    createOrderButton: themeProps,
    isAdmin: isAdmin,
    createOrderButtonLoading: createOrderButtonLoading,
    setCreateOrderButtonLoading: setCreateOrderButtonLoading,
    onQuickSearchProductChangeForSearchRow: onQuickSearchProductChangeForSearchRow,
    searchedProductsLoading: searchedProductsLoading,
    getInlineError: getInlineError,
    closestMultiples: closestMultiples,
    isValueMultipleOfIncrement: isValueMultipleOfIncrement,
    isAvailableStockEnabledForQuickSearch: isAvailableStockEnabledForQuickSearch
  })));
};
var OrderTableSection = function OrderTableSection(_ref2) {
  var tableData = _ref2.tableData,
    themeProps = _ref2.themeProps,
    tableThemeProps = _ref2.tableThemeProps,
    onTableRowQuantityChange = _ref2.onTableRowQuantityChange,
    onTableRowDelete = _ref2.onTableRowDelete,
    isShowAvailableStock = _ref2.isShowAvailableStock,
    isShowBarcode = _ref2.isShowBarcode,
    createOrderUrl = _ref2.createOrderUrl,
    showOrderURL = _ref2.showOrderURL,
    isShowOrderTable = _ref2.isShowOrderTable,
    handleCopy = _ref2.handleCopy,
    copied = _ref2.copied,
    incrementToken = _ref2.incrementToken,
    minQtyToken = _ref2.minQtyToken,
    maxQtyToken = _ref2.maxQtyToken,
    availableQtyToken = _ref2.availableQtyToken,
    inventoryPolicyToken = _ref2.inventoryPolicyToken,
    columnTokens = _ref2.columnTokens,
    tableHeadings = _ref2.tableHeadings;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isShowOrderTable && (/*#__PURE__*/React.createElement(Table$1, {
    tableData: structuredClone(tableData),
    headingFontSize: themeProps.orderTableColumnName.orderTableColumnNameFontSize,
    contentFontSize: themeProps.orderTableContent.orderTableContentFontSize,
    headingColor: themeProps.orderTableColumnName.orderTableColumnNameTextColor,
    contentColor: themeProps.orderTableContent.orderTableContentTextColor,
    onTableRowQuantityChange: onTableRowQuantityChange,
    onTableRowDelete: onTableRowDelete,
    themeProps: tableThemeProps,
    isShowAvailableStock: isShowAvailableStock,
    isShowBarcode: isShowBarcode,
    incrementToken: incrementToken,
    minQtyToken: minQtyToken,
    maxQtyToken: maxQtyToken,
    availableQtyToken: availableQtyToken,
    inventoryPolicyToken: inventoryPolicyToken,
    columnTokens: columnTokens,
    tableHeadings: tableHeadings,
    padding: "18px"
  })), showOrderURL && (/*#__PURE__*/React.createElement(CopyLinkBox, {
    text: createOrderUrl,
    handleCopy: handleCopy,
    copied: copied
  })));
};
var NoteIcon = function NoteIcon(_ref3) {
  var _ref3$size = _ref3.size,
    size = _ref3$size === undefined ? 14 : _ref3$size,
    _ref3$color = _ref3.color,
    color = _ref3$color === undefined ? '#707070' : _ref3$color;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.60005 9.10039H7.70005M5.60005 7.00039H8.40005M5.60005 4.90039H7.00005M8.53771 1.53805L11.0624 4.06273C11.1505 4.15087 11.2 4.27042 11.2 4.39507V12.1304C11.2 12.39 10.9896 12.6004 10.73 12.6004H3.27005C3.01048 12.6004 2.80005 12.39 2.80005 12.1304V1.87039C2.80005 1.61082 3.01047 1.40039 3.27005 1.40039H8.20537C8.33002 1.40039 8.44957 1.44991 8.53771 1.53805Z",
    stroke: color,
    "stroke-width": "1.4",
    "stroke-linecap": "round"
  }));
};

var updateWindowUpro$1 = function updateWindowUpro(config) {
  if (window.upro) {
    /* If upro already exists, append the keys/values from the config object */
    Object.assign(window.upro, config);
  } else {
    /* If upro doesn't exist, initialize it with the config values */
    window.upro = Object.assign(Object.assign({}, config), {
      name: 'upro'
    });
  }
};

var CSVUploadIcon = function CSVUploadIcon(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      color: color,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "13",
    height: "14",
    viewBox: "0 0 13 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9277 2.96898L10.0312 0.0724306C10.0096 0.0492402 9.98348 0.030817 9.95438 0.0183457C9.92528 0.00587439 9.89389 -0.000369067 9.86224 1.68599e-05H2.82845C2.58173 0.00128535 2.34548 0.0998561 2.17103 0.274314C1.99657 0.448772 1.898 0.685023 1.89673 0.93174V5.55173C1.89673 5.61575 1.92216 5.67715 1.96743 5.72242C2.01269 5.76768 2.07409 5.79311 2.13811 5.79311C2.20213 5.79311 2.26352 5.76768 2.30879 5.72242C2.35406 5.67715 2.37949 5.61575 2.37949 5.55173V0.93174C2.37949 0.812667 2.42679 0.698471 2.51099 0.614274C2.59518 0.530076 2.70938 0.482775 2.82845 0.482775H9.62086V3.13794C9.62086 3.20196 9.64629 3.26336 9.69156 3.30862C9.73682 3.35389 9.79822 3.37932 9.86224 3.37932H12.5174V13.0683C12.5174 13.1873 12.4701 13.3015 12.3859 13.3857C12.3017 13.4699 12.1875 13.5172 12.0684 13.5172H2.82845C2.70938 13.5172 2.59518 13.4699 2.51099 13.3857C2.42679 13.3015 2.37949 13.1873 2.37949 13.0683V11.8276C2.37949 11.7636 2.35406 11.7022 2.30879 11.6569C2.26352 11.6116 2.20213 11.5862 2.13811 11.5862C2.07409 11.5862 2.01269 11.6116 1.96743 11.6569C1.92216 11.7022 1.89673 11.7636 1.89673 11.8276V13.0683C1.898 13.315 1.99657 13.5512 2.17103 13.7257C2.34548 13.9002 2.58173 13.9987 2.82845 14H12.0684C12.3152 13.9987 12.5514 13.9002 12.7259 13.7257C12.9003 13.5512 12.9989 13.315 13.0002 13.0683V3.13794C13.0005 3.10629 12.9943 3.0749 12.9818 3.0458C12.9694 3.0167 12.9509 2.99053 12.9277 2.96898ZM10.1036 0.825533L12.1746 2.89656H10.1036V0.825533Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0691 10.3229V7.05943C11.0697 6.95655 11.0499 6.85456 11.0109 6.75939C10.9718 6.66421 10.9142 6.57774 10.8415 6.50499C10.7687 6.43224 10.6822 6.37466 10.5871 6.33558C10.4919 6.29651 10.3899 6.27672 10.287 6.27736H1.71324C1.61035 6.27672 1.50837 6.29651 1.41319 6.33558C1.31802 6.37466 1.23155 6.43224 1.1588 6.50499C1.08605 6.57774 1.02847 6.66421 0.989393 6.75939C0.950318 6.85456 0.930526 6.95655 0.931167 7.05943V10.3229C0.930526 10.4258 0.950318 10.5277 0.989393 10.6229C1.02847 10.7181 1.08605 10.8046 1.1588 10.8773C1.23155 10.9501 1.31802 11.0076 1.41319 11.0467C1.50837 11.0858 1.61035 11.1056 1.71324 11.1049H10.287C10.3899 11.1056 10.4919 11.0858 10.5871 11.0467C10.6822 11.0076 10.7687 10.9501 10.8415 10.8773C10.9142 10.8046 10.9718 10.7181 11.0109 10.6229C11.0499 10.5277 11.0697 10.4258 11.0691 10.3229ZM3.10358 9.32356C3.1821 9.40552 3.27659 9.47051 3.38121 9.51451C3.48583 9.55852 3.59836 9.58061 3.71185 9.57942C3.83459 9.57956 3.9561 9.55493 4.0691 9.50701C4.19033 9.446 4.30113 9.36616 4.39737 9.27046L4.67254 9.55046C4.55368 9.69036 4.40568 9.80259 4.2389 9.87931C4.07213 9.95602 3.8906 9.99537 3.70703 9.9946C3.52952 10.003 3.35218 9.9748 3.18607 9.91168C3.01995 9.84855 2.86862 9.75188 2.74151 9.6277C2.49909 9.37813 2.36349 9.0439 2.36349 8.69598C2.36349 8.34805 2.49909 8.01382 2.74151 7.76425C2.86897 7.63995 3.02014 7.54256 3.18601 7.47787C3.35188 7.41318 3.52906 7.38252 3.70703 7.3877C3.8899 7.38541 4.07106 7.42311 4.23784 7.49816C4.40462 7.57321 4.55298 7.6838 4.67254 7.82218L4.4022 8.11667C4.30621 8.01513 4.19145 7.93316 4.06427 7.87529C3.94502 7.82612 3.81662 7.80307 3.68772 7.8077C3.46955 7.81603 3.26188 7.90355 3.10358 8.05391C3.01783 8.13383 2.95019 8.2312 2.90522 8.33945C2.86026 8.44771 2.839 8.56434 2.84289 8.68149C2.83997 8.80067 2.86161 8.91918 2.90646 9.02964C2.95131 9.1401 3.01841 9.24015 3.10358 9.32356ZM6.69047 9.80632C6.50395 9.94867 6.27311 10.0205 6.03875 10.0091C5.65086 10.0111 5.27659 9.86623 4.99116 9.60356L5.25668 9.28011C5.47056 9.48486 5.75248 9.60348 6.0484 9.61322C6.16425 9.61958 6.27915 9.58917 6.37668 9.52632C6.41512 9.50028 6.44635 9.46493 6.46745 9.42357C6.48855 9.38221 6.49884 9.33618 6.49737 9.28977C6.49908 9.2452 6.48933 9.20093 6.46904 9.1612C6.44876 9.12148 6.41862 9.08762 6.38151 9.06287C6.26113 8.99105 6.12859 8.94196 5.99047 8.91805C5.84829 8.88389 5.70808 8.84199 5.57047 8.79253C5.47729 8.75976 5.39066 8.71073 5.31461 8.6477C5.23845 8.58609 5.17843 8.50687 5.13974 8.41687C5.10105 8.32687 5.08485 8.22881 5.09254 8.13115C5.08638 8.02679 5.10659 7.92257 5.15131 7.82807C5.19602 7.73358 5.2638 7.65187 5.3484 7.59046C5.53115 7.4603 5.75177 7.39411 5.97599 7.40219C6.14005 7.40138 6.30313 7.42748 6.45875 7.47943C6.60861 7.5285 6.74784 7.60549 6.86909 7.70632L6.6422 8.02494C6.55362 7.94926 6.44994 7.89331 6.33806 7.86081C6.2172 7.81739 6.08992 7.79455 5.96151 7.79322C5.85504 7.79123 5.74999 7.81791 5.65737 7.87046C5.61957 7.8945 5.58889 7.92822 5.56852 7.96812C5.54814 8.00802 5.53882 8.05264 5.54151 8.09736C5.53905 8.14339 5.5484 8.18929 5.56868 8.2307C5.58896 8.2721 5.61949 8.30763 5.65737 8.33391C5.81744 8.41512 5.98804 8.47361 6.16427 8.5077C6.37643 8.54852 6.57633 8.63773 6.7484 8.76839C6.81384 8.83015 6.86534 8.90516 6.89947 8.98841C6.93361 9.07166 6.94958 9.16123 6.94633 9.25115C6.94747 9.35526 6.92453 9.45823 6.87931 9.55202C6.83409 9.64581 6.76781 9.72788 6.68564 9.79184L6.69047 9.80632ZM8.6215 9.98011H8.13875L7.12978 7.46494H7.61254L8.38978 9.34287L9.16219 7.46494H9.64495L8.6215 9.98011Z",
    fill: "currentColor"
  })));
};

var TriggerButton = function TriggerButton(_ref) {
  var open = _ref.open,
    theme = _ref.theme,
    isMobile = _ref.isMobile;
  var triggerButtonTextColor = theme.triggerButtonTextColor,
    triggerButtonBackgroundColor = theme.triggerButtonBackgroundColor,
    triggerButtonFontSize = theme.triggerButtonFontSize,
    triggerButtonText = theme.triggerButtonText,
    triggerButtonStyle = theme.triggerButtonStyle;
  var buttonStyles = getButtonStyles(triggerButtonStyle, triggerButtonTextColor, triggerButtonBackgroundColor);
  return /*#__PURE__*/React.createElement(Button, {
    kind: buttonStyles === null || buttonStyles === undefined ? undefined : buttonStyles.kind,
    color: buttonStyles === null || buttonStyles === undefined ? undefined : buttonStyles.color,
    bgColor: isMobile ? 'transparent' : buttonStyles === null || buttonStyles === undefined ? undefined : buttonStyles.bgColor,
    borderColor: isMobile ? 'transparent' : buttonStyles === null || buttonStyles === undefined ? undefined : buttonStyles.borderColor,
    iconBefore: /*#__PURE__*/React.createElement(CSVUploadIcon, {
      color: buttonStyles === null || buttonStyles === undefined ? undefined : buttonStyles.color
    }),
    onClick: open,
    iconSpacing: isMobile ? 0 : 6,
    textSize: "".concat(triggerButtonFontSize, "px"),
    padding: isMobile ? '0' : '9px',
    whitespace: "nowrap"
  }, !isMobile && triggerButtonText);
};

var BannerWrapper = function BannerWrapper(_ref) {
  var isMobile = _ref.isMobile,
    bgColor = _ref.bgColor,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isMobile ? (/*#__PURE__*/React.createElement(BlockLayout, {
    horizontalAlign: 'start',
    verticalAlign: 'start',
    bgColor: bgColor,
    width: '100%',
    padding: '21px',
    margin: '2rem 0',
    gap: '21px',
    cornerRadius: '5px'
  }, children)) : (/*#__PURE__*/React.createElement(InlineLayout, {
    wrap: false,
    horizontalAlign: 'between',
    verticalAlign: 'between',
    bgColor: bgColor,
    width: '100%',
    height: 'auto',
    padding: '21px',
    margin: '2rem 0',
    gap: '21px',
    cornerRadius: '5px'
  }, children)));
};
var BannerContent = function BannerContent(_ref2) {
  var theme = _ref2.theme,
    title = _ref2.title,
    subtitle = _ref2.subtitle;
  var _theme$bannerLayout = theme.bannerLayout,
    uploadBannerTitleFontFamily = _theme$bannerLayout.uploadBannerTitleFontFamily,
    uploadBannerSubtitleFontFamily = _theme$bannerLayout.uploadBannerSubtitleFontFamily,
    uploadBannerTitleFontSize = _theme$bannerLayout.uploadBannerTitleFontSize,
    uploadBannerSubtitleFontSize = _theme$bannerLayout.uploadBannerSubtitleFontSize,
    uploadBannerTitleTextColor = _theme$bannerLayout.uploadBannerTitleTextColor,
    uploadBannerSubtitleTextColor = _theme$bannerLayout.uploadBannerSubtitleTextColor;
  return /*#__PURE__*/React.createElement(BlockLayout, null, /*#__PURE__*/React.createElement(MdText, {
    alignment: "start",
    fontFamily: uploadBannerTitleFontFamily,
    fontSize: "".concat(uploadBannerTitleFontSize, "px"),
    fontWeight: '',
    color: uploadBannerTitleTextColor,
    width: '100%'
  }, title), /*#__PURE__*/React.createElement(MdText, {
    alignment: "start",
    fontFamily: uploadBannerSubtitleFontFamily,
    fontSize: "".concat(uploadBannerSubtitleFontSize, "px"),
    fontWeight: '',
    color: uploadBannerSubtitleTextColor,
    width: '100%'
  }, subtitle));
};
var BannerLayout = function BannerLayout(_ref3) {
  var theme = _ref3.theme,
    isShowWatchTutorial = _ref3.isShowWatchTutorial,
    watchTutorialLink = _ref3.watchTutorialLink,
    isHideDownloadButton = _ref3.isHideDownloadButton;
    _ref3.isShowProgressBar;
    var downloadBtnLoading = _ref3.downloadBtnLoading,
    progressValue = _ref3.progressValue,
    fileName = _ref3.fileName,
    onDownloadButtonClick = _ref3.onDownloadButtonClick,
    isAdmin = _ref3.isAdmin,
    open = _ref3.open,
    isMobile = _ref3.isMobile,
    handleFileUpload = _ref3.handleFileUpload,
    isModalOpen = _ref3.isModalOpen;
  var _theme$bannerLayout2 = theme.bannerLayout,
    uploadBannerBackgroundColor = _theme$bannerLayout2.uploadBannerBackgroundColor,
    uploadBannerImportTitleText = _theme$bannerLayout2.uploadBannerImportTitleText,
    uploadBannerImportSubtitleText = _theme$bannerLayout2.uploadBannerImportSubtitleText,
    uploadBannerCatalogTitleText = _theme$bannerLayout2.uploadBannerCatalogTitleText,
    uploadBannerCatalogSubtitleText = _theme$bannerLayout2.uploadBannerCatalogSubtitleText,
    uploadBannerTitleTextColor = _theme$bannerLayout2.uploadBannerTitleTextColor,
    fetchingCatalogueText = theme.otherText.fetchingCatalogueText;
  var dividerSpacing = isHideDownloadButton ? '0' : isMobile ? '21px 0 0' : '0 0 0 21px';
  var dividerWidth = isHideDownloadButton ? '0' : isMobile ? '1px 0 0' : '0 0 0 1px';
  return /*#__PURE__*/React.createElement(BannerWrapper, {
    isMobile: isMobile,
    bgColor: uploadBannerBackgroundColor
  }, !isHideDownloadButton && (/*#__PURE__*/React.createElement(BlockLayout, {
    verticalAlign: 'between',
    horizontalAlign: 'start',
    width: '100%',
    gap: '14px'
  }, /*#__PURE__*/React.createElement(BannerContent, {
    theme: theme,
    title: uploadBannerCatalogTitleText,
    subtitle: uploadBannerCatalogSubtitleText
  }), !downloadBtnLoading && (/*#__PURE__*/React.createElement(InlineLayout, {
    gap: '14px',
    wrap: false,
    horizontalAlign: 'start',
    verticalAlign: 'center',
    height: 'auto'
  }, /*#__PURE__*/React.createElement(DownloadButton, {
    themeProps: theme,
    onDownloadButtonClick: onDownloadButtonClick,
    isAdmin: isAdmin,
    csvUploadFormat: 'banner',
    loading: downloadBtnLoading
  }), isShowWatchTutorial && (/*#__PURE__*/React.createElement(WatchTutorialButton, {
    isAdmin: isAdmin,
    watchTutorialLink: watchTutorialLink,
    themeProps: theme
  })))), downloadBtnLoading && progressValue !== 100 && (/*#__PURE__*/React.createElement(ProgressBar, {
    title: fetchingCatalogueText,
    titleTextSize: "12px",
    titleFontFamily: "inherit",
    titleColor: uploadBannerTitleTextColor,
    helperText: fileName,
    helperTextSize: "12px",
    helperFontFamily: "inherit",
    progress: progressValue
  })))), /*#__PURE__*/React.createElement(BlockLayout, {
    verticalAlign: 'between',
    horizontalAlign: 'start',
    width: '100%',
    padding: dividerSpacing,
    gap: '14px',
    borderWidth: dividerWidth,
    borderStyle: 'solid',
    borderColor: '#DEDEDE'
  }, /*#__PURE__*/React.createElement(BannerContent, {
    theme: theme,
    title: uploadBannerImportTitleText,
    subtitle: uploadBannerImportSubtitleText
  }), /*#__PURE__*/React.createElement(InlineLayout, {
    gap: '14px',
    wrap: false,
    horizontalAlign: 'start',
    verticalAlign: 'center',
    height: 'auto'
  }, /*#__PURE__*/React.createElement(UploadButton, {
    themeProps: theme,
    handleFileUpload: handleFileUpload,
    isAdmin: isAdmin,
    openModal: open,
    fileName: fileName,
    isModalOpen: isModalOpen
  }), isHideDownloadButton && isShowWatchTutorial && (/*#__PURE__*/React.createElement(WatchTutorialButton, {
    isAdmin: isAdmin,
    watchTutorialLink: watchTutorialLink,
    themeProps: theme
  })))));
};

function CSVUpload$1(_ref) {
  var _this = this;
  var themeProps = _ref.themeProps,
    watchTutorialLink = _ref.watchTutorialLink,
    isShowWatchTutorial = _ref.isShowWatchTutorial,
    locationOptions = _ref.locationOptions,
    selectedLocation = _ref.selectedLocation;
    _ref.setSelectedLocation;
    var onDownloadButtonClick = _ref.onDownloadButtonClick,
    downloadBtnLoading = _ref.downloadBtnLoading,
    progressValue = _ref.progressValue,
    tableData = _ref.tableData,
    onTableRowQuantityChange = _ref.onTableRowQuantityChange,
    onTableRowDelete = _ref.onTableRowDelete,
    onDeleteFile = _ref.onDeleteFile,
    fileName = _ref.fileName,
    isShowOrderTable = _ref.isShowOrderTable,
    setIsShowOrderTable = _ref.setIsShowOrderTable,
    createOrderUrl = _ref.createOrderUrl,
    showOrderURL = _ref.showOrderURL,
    errorList = _ref.errorList,
    isHideDownloadButton = _ref.isHideDownloadButton,
    createOrderLoading = _ref.createOrderLoading,
    onCreateOrderClick = _ref.onCreateOrderClick,
    isShowCreateOrderBtn = _ref.isShowCreateOrderBtn,
    handleFileUpload = _ref.handleFileUpload,
    fileUploadError = _ref.fileUploadError,
    isShowProgressBar = _ref.isShowProgressBar,
    _ref$isShowBackBtn = _ref.isShowBackBtn,
    isShowBackBtn = _ref$isShowBackBtn === undefined ? true : _ref$isShowBackBtn,
    _ref$isShowLocationOp = _ref.isShowLocationOptions,
    isShowLocationOptions = _ref$isShowLocationOp === undefined ? true : _ref$isShowLocationOp,
    isShowAvailableStock = _ref.isShowAvailableStock,
    isShowBarcode = _ref.isShowBarcode,
    incrementToken = _ref.incrementToken,
    minQtyToken = _ref.minQtyToken,
    maxQtyToken = _ref.maxQtyToken,
    availableQtyToken = _ref.availableQtyToken,
    inventoryPolicyToken = _ref.inventoryPolicyToken,
    columnTokens = _ref.columnTokens,
    tableHeadings = _ref.tableHeadings,
    csvUploadFormat = _ref.csvUploadFormat,
    tabsShouldBeVisible = _ref.tabsShouldBeVisible,
    activeTab = _ref.activeTab,
    setActiveTab = _ref.setActiveTab,
    searchedValue = _ref.searchedValue,
    setSearchedValue = _ref.setSearchedValue,
    fetchSearchedProducts = _ref.fetchSearchedProducts,
    searchedProducts = _ref.searchedProducts,
    setSearchedProducts = _ref.setSearchedProducts,
    quickSearchSelectedProduct = _ref.quickSearchSelectedProduct,
    setQuickSearchSelectedProduct = _ref.setQuickSearchSelectedProduct,
    quickSearchedTableData = _ref.quickSearchedTableData,
    setQuickSearchedTableData = _ref.setQuickSearchedTableData,
    onQuickSearchProductAdd = _ref.onQuickSearchProductAdd,
    onQuickSearchProductChange = _ref.onQuickSearchProductChange,
    onClickCreateOrder = _ref.onClickCreateOrder,
    orderUrl = _ref.orderUrl,
    createOrderButtonLoading = _ref.createOrderButtonLoading,
    setCreateOrderButtonLoading = _ref.setCreateOrderButtonLoading,
    onQuickSearchProductChangeForSearchRow = _ref.onQuickSearchProductChangeForSearchRow,
    searchedProductsLoading = _ref.searchedProductsLoading,
    getInlineError = _ref.getInlineError,
    closestMultiples = _ref.closestMultiples,
    isValueMultipleOfIncrement = _ref.isValueMultipleOfIncrement,
    env = _ref.env,
    isAdmin = _ref.isAdmin,
    isInternalDashboard = _ref.isInternalDashboard,
    isShowModal = _ref.isShowModal,
    showMobileLayout = _ref.showMobileLayout,
    isAvailableStockEnabledForQuickSearch = _ref.isAvailableStockEnabledForQuickSearch;
  var _a, _b, _c, _d, _e;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modal = _useState2[0],
    setModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    copied = _useState4[0],
    setCopied = _useState4[1];
  var open = function open() {
    return !isAdmin && setModal(true);
  };
  var close = function close() {
    return !isAdmin && setModal(false);
  };
  var isMobile = window.innerWidth < 768 || isAdmin && showMobileLayout;
  var _useState5 = useState(isShowModal),
    _useState6 = _slicedToArray(_useState5, 2),
    showModal = _useState6[0],
    setShowModal = _useState6[1];
  updateWindowUpro$1({
    openCsvUploadModal: open,
    initiateCatalogDownload: onDownloadButtonClick
  });
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    stage = _useState8[0],
    setStage = _useState8[1];
  useEffect(function () {
    if (locationOptions.length <= 1) {
      setStage(1);
    } else {
      setStage(0);
    }
    !isShowLocationOptions && setStage(1);
  }, [locationOptions, isShowLocationOptions]);
  useEffect(function () {
    if (isShowModal) {
      setStage(1);
      setModal(true);
    } else {
      setStage(0);
      setModal(false);
    }
  }, [isShowModal]);
  useEffect(function () {
    setShowModal(modal);
  }, [modal]);
  var isTriggerVisible = showTrigger(isAdmin, isInternalDashboard, modal);
  // todo this won't be called since everywhere this component is used, isShowBackBtn is set to false
  var goBack = function goBack() {
    if (!isShowLocationOptions && stage === 1) {
      setStage(1);
      return;
    }
    if (stage === 0) {
      close();
    } else {
      setStage(stage - 1);
    }
  };
  var handleCopy = function handleCopy() {
    return __awaiter(_this, undefined, undefined, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return navigator.clipboard.writeText(createOrderUrl);
          case 3:
            setCopied(true);
            setTimeout(function () {
              return setCopied(false);
            }, 1500);
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.error('Failed to copy text:', _context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
  };
  var hideLocationOptions = locationOptions.length === 0;
  var headerTitleKeys = {
    headerTitleText: csvUploadFormat === 'button' ? (_a = themeProps.title) === null || _a === undefined ? undefined : _a.headerTitleText : (_b = themeProps.title) === null || _b === undefined ? undefined : _b.uploadBannerImportHeaderTitleText,
    headerTitleFontSize: (_c = themeProps.title) === null || _c === undefined ? undefined : _c.headerTitleFontSize,
    headerTitleFontFamily: (_d = themeProps.title) === null || _d === undefined ? undefined : _d.headerTitleFontFamily,
    headerTitleTextColor: (_e = themeProps.title) === null || _e === undefined ? undefined : _e.headerTitleTextColor
  };
  var content = [/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center h-full"
  })), /*#__PURE__*/React.createElement(UploadModal, {
    themeProps: themeProps,
    watchTutorialLink: watchTutorialLink,
    isShowWatchTutorial: isShowWatchTutorial,
    handleFileUpload: handleFileUpload,
    isHideDownloadButton: isHideDownloadButton,
    downloadBtnLoading: downloadBtnLoading,
    onDownloadButtonClick: onDownloadButtonClick,
    isShowProgressBar: isShowProgressBar,
    progressValue: progressValue,
    processingText: themeProps.otherText.processingText,
    fileName: fileName,
    tableData: tableData,
    isShowOrderTable: isShowOrderTable,
    onDeleteFile: onDeleteFile,
    errorList: errorList,
    onTableRowQuantityChange: onTableRowQuantityChange,
    createOrderLoading: createOrderLoading,
    isShowCreateOrderBtn: isShowCreateOrderBtn,
    createOrderUrl: createOrderUrl,
    showOrderURL: showOrderURL,
    onCreateOrderClick: onCreateOrderClick,
    fileUploadError: fileUploadError,
    onTableRowDelete: onTableRowDelete,
    isAdmin: isAdmin,
    setIsShowOrderTable: setIsShowOrderTable,
    isShowAvailableStock: isShowAvailableStock,
    isShowBarcode: isShowBarcode,
    handleCopy: handleCopy,
    copied: copied,
    incrementToken: incrementToken,
    minQtyToken: minQtyToken,
    maxQtyToken: maxQtyToken,
    availableQtyToken: availableQtyToken,
    inventoryPolicyToken: inventoryPolicyToken,
    columnTokens: columnTokens,
    tableHeadings: tableHeadings,
    csvUploadFormat: csvUploadFormat !== null && csvUploadFormat !== undefined ? csvUploadFormat : 'button',
    closeModal: close,
    isModalOpen: modal,
    tabsShouldBeVisible: tabsShouldBeVisible,
    activeTab: activeTab,
    setActiveTab: setActiveTab,
    searchedValue: searchedValue,
    setSearchedValue: setSearchedValue,
    fetchSearchedProducts: fetchSearchedProducts,
    searchedProducts: searchedProducts,
    setSearchedProducts: setSearchedProducts,
    quickSearchSelectedProduct: quickSearchSelectedProduct,
    setQuickSearchSelectedProduct: setQuickSearchSelectedProduct,
    quickSearchedTableData: quickSearchedTableData,
    setQuickSearchedTableData: setQuickSearchedTableData,
    onQuickSearchProductAdd: onQuickSearchProductAdd,
    onQuickSearchProductChange: onQuickSearchProductChange,
    onClickCreateOrder: onClickCreateOrder,
    orderUrl: orderUrl,
    createOrderButtonLoading: createOrderButtonLoading,
    setCreateOrderButtonLoading: setCreateOrderButtonLoading,
    onQuickSearchProductChangeForSearchRow: onQuickSearchProductChangeForSearchRow,
    searchedProductsLoading: searchedProductsLoading,
    getInlineError: getInlineError,
    closestMultiples: closestMultiples,
    isValueMultipleOfIncrement: isValueMultipleOfIncrement,
    env: env,
    isAvailableStockEnabledForQuickSearch: isAvailableStockEnabledForQuickSearch
  })];
  return /*#__PURE__*/React.createElement(React.Fragment, null, isTriggerVisible && csvUploadFormat === 'button' && (/*#__PURE__*/React.createElement(TriggerButton, {
    open: open,
    theme: themeProps.triggerButton,
    isMobile: !!isMobile
  })), isTriggerVisible && csvUploadFormat === 'banner' && (/*#__PURE__*/React.createElement(BannerLayout, {
    theme: themeProps,
    isShowWatchTutorial: isShowWatchTutorial,
    watchTutorialLink: watchTutorialLink,
    isHideDownloadButton: isHideDownloadButton,
    isShowProgressBar: isShowProgressBar,
    downloadBtnLoading: downloadBtnLoading,
    progressValue: progressValue,
    fileName: fileName,
    onDownloadButtonClick: onDownloadButtonClick,
    isAdmin: isAdmin,
    open: open,
    isMobile: !!isMobile,
    handleFileUpload: handleFileUpload,
    isModalOpen: modal
  })), showModal && modal && (/*#__PURE__*/React.createElement(ModalContainer, {
    goBack: goBack,
    isOpen: modal,
    exit: close,
    isAdmin: isAdmin,
    isInternalDashboard: isInternalDashboard,
    stage: stage,
    titleStyles: themeProps.title,
    locationStyles: themeProps.location,
    hideBackButton: locationOptions.length <= 1,
    isShowBackBtn: isShowBackBtn,
    selectedLocationDisplayName: (selectedLocation === null || selectedLocation === undefined ? undefined : selectedLocation.name) || '',
    hideLocationOptions: hideLocationOptions,
    headerTitleKeys: headerTitleKeys,
    csvUploadFormat: csvUploadFormat
  }, content[stage])));
}

var CreditLimit = function CreditLimit(_ref) {
  var bannerType = _ref.bannerType,
    titleText = _ref.titleText,
    bodyText = _ref.bodyText,
    availableCreditLimitText = _ref.availableCreditLimitText,
    totalCreditLimitText = _ref.totalCreditLimitText;
  var creditStatus = [(availableCreditLimitText === null || availableCreditLimitText === undefined ? undefined : availableCreditLimitText.trim()) ? "\n".concat(availableCreditLimitText.trim()) : (totalCreditLimitText === null || totalCreditLimitText === undefined ? undefined : totalCreditLimitText.trim()) ? "\n".concat(totalCreditLimitText.trim()) : null, (availableCreditLimitText === null || availableCreditLimitText === undefined ? undefined : availableCreditLimitText.trim()) ? totalCreditLimitText === null || totalCreditLimitText === undefined ? undefined : totalCreditLimitText.trim() : null].filter(Boolean);
  var bannerContent = [bodyText].concat(_toConsumableArray(creditStatus)).filter(function (content) {
    return content !== null;
  });
  return /*#__PURE__*/React.createElement(AlertBanner, {
    variant: bannerType,
    title: titleText,
    messages: bannerContent,
    titleFontSize: "14",
    contentBullets: false,
    contentFontSize: "13"
  });
};

var _templateObject;
var Dialog = styled.dialog(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 10px;\n  z-index: 555;\n  width: 90%;\n  max-width: 700px;\n  border: none;\n  border-radius: 5px;\n  outline: none;\n  padding: 21px;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: space-between;\n  gap: 14px;\n  font-family: inherit, sans-serif;\n\n  & .mrca-heading {\n    font-size: 16px;\n    font-weight: bold;\n  }\n\n  & .mrca-message {\n    font-size: 14px;\n  }\n\n  box-shadow:\n    0 32px 32px 0 #00000014,\n    0 12px 12px 0 #0000000e,\n    0 6px 6px 0 #0000000b,\n    0 3px 3px 0 #00000009,\n    0 1px 1px 0 #00000007,\n    0 -2px 4px 0 #00000014;\n"])));
var Toast = function Toast(_ref) {
  var showToast = _ref.showToast,
    heading = _ref.heading,
    message = _ref.message;
  var toastRef = useRef(null);
  useEffect(function () {
    var _a, _b;
    showToast ? (_a = toastRef.current) === null || _a === undefined ? undefined : _a.show() : (_b = toastRef.current) === null || _b === undefined ? undefined : _b.close();
  }, [showToast]);
  return /*#__PURE__*/React.createElement(Dialog, {
    ref: toastRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "mrca-heading"
  }, heading), /*#__PURE__*/React.createElement(InlineLayout, {
    gap: "14px",
    wrap: false,
    horizontalAlign: 'start'
  }, /*#__PURE__*/React.createElement(Spinner, {
    color: "#197CBD"
  }), /*#__PURE__*/React.createElement("div", {
    className: "mrca-message"
  }, message)));
};

var getDefaultUploadState = function getDefaultUploadState(uploadButtonText) {
  return {
    uploadID: 0,
    uploadPageUrl: '',
    uploadCsvButtonText: uploadButtonText,
    uploadModalLoading: false,
    isRequestForUploadStatus: false,
    uploadedDataForTable: [],
    uploadFileName: '',
    uploadError: '',
    fileToUpload: null,
    submitButtonLoading: false
  };
};
var ErrorSummryVariableToBeConsider = ['variant_name', 'variant_sku', 'barcode', 'variant_id'];
var defaultSingleProduct = {
  variantId: '',
  variantName: '',
  productName: '',
  image: undefined,
  min: undefined,
  max: undefined,
  availableStock: undefined,
  increment: undefined,
  quantity: 1,
  error: undefined
};
var columnsTokens = {
  variant_id: 'variantId',
  quantity: 'quantity'
};
var errorVariables = ['errorMinOrderQuantityText', 'errorMaxOrderQuantityText', 'errorIncrementQuantityText', 'errorInvalidVariantText', 'errorAvailableQuantityText'];
var quantityErrors = ['errorMinOrderQuantityText', 'errorMaxOrderQuantityText', 'errorAvailableQuantityText'];
var errorKeyMap = {
  maxRowLimitReachedError: 'errorMaxRowsLimitReachedText',
  emptyCSVError: 'errorEmptyCSVText',
  invalidVariantsError: 'errorIncorrectVariantText',
  // not to be confused with 'errorInvalidVariantText', this map is only used when csv is empty
  invalidQuantityError: 'errorInvalidQuantityText'
};
var ShopExcludedForClearingCart = ['mrcatest2.myshopify.com', 'everythhingisfree.myshopify.com', 'kbrise-preprod.myshopify.com', 'lr-eshop.myshopify.com', 'kbd-b2b-portal.myshopify.com'];

var formattedIDs = function formattedIDs(id, type) {
  return "gid://shopify/".concat(type, "/").concat(id);
};
var closestMultiples = function closestMultiples(increment, value) {
  var lowerMultiple = value - value % increment;
  var upperMultiple = lowerMultiple + increment * (value % increment === 0 ? 0 : 1);
  return [lowerMultiple, upperMultiple];
};
var getProductNoteColumnIDs = function getProductNoteColumnIDs(columns) {
  return columns.filter(function (column) {
    return column.identifier === 'metafield' && column.showAsProductNote;
  }).map(function (column) {
    return {
      columnName: column.columnName,
      productNoteKey: column.productNoteKey
    };
  });
};
var getColumnHeadings = function getColumnHeadings(tableData, columns) {
  if (!tableData.length) return [];
  var columnMap = new Map(columns.map(function (col) {
    return [col.columnName, col];
  }));
  var b = Object.keys(tableData[0]).filter(function (key) {
    var _a, _b;
    return (_b = (_a = columnMap.get(key)) === null || _a === undefined ? undefined : _a.isShowInOrderSummary) !== null && _b !== undefined ? _b : key !== 'Is Error' && key !== 'Error';
  }).sort(function (a, b) {
    var _a, _b, _c, _d;
    return ((_b = (_a = columnMap.get(a)) === null || _a === undefined ? undefined : _a.priority) !== null && _b !== undefined ? _b : Infinity) - ((_d = (_c = columnMap.get(b)) === null || _c === undefined ? undefined : _c.priority) !== null && _d !== undefined ? _d : Infinity);
  });
  return b;
};
var getColumnNameByIdentifier = function getColumnNameByIdentifier(identifier, columnsList) {
  var _a;
  var columnMap = new Map(columnsList.map(function (col) {
    return [col.identifier, col.columnName];
  }));
  return (_a = columnMap.get(identifier)) !== null && _a !== undefined ? _a : '';
};
var getErrorSummaryVariable = function getErrorSummaryVariable(columns) {
  var _a, _b;
  if (!columns) return '';
  var columnMap = new Map(columns.map(function (col) {
    return [col.identifier, col];
  }));
  var _iterator = _createForOfIteratorHelper(ErrorSummryVariableToBeConsider),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (columnMap.has(key) && ((_a = columnMap.get(key)) === null || _a === void 0 ? void 0 : _a.isShowInOrderSummary)) {
        return (_b = columnMap.get(key)) === null || _b === void 0 ? void 0 : _b.columnName;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return '';
};
var getProgressValueByStatus = function getProgressValueByStatus(status) {
  switch (status) {
    case 'pending':
      return 50;
    case 'uploaded':
      return 75;
    case 'completed':
      return 100;
    default:
      return 0;
  }
};
var getSafeNumber = function getSafeNumber(obj, key, defaultValue) {
  return (obj === null || obj === undefined ? undefined : obj[key]) !== undefined && (obj === null || obj === undefined ? undefined : obj[key]) !== '' ? Number(obj[key]) : defaultValue;
};
var getValidUrl = function getValidUrl(url) {
  // if path is relative, return as is
  if (url.startsWith('/')) {
    return url;
  }
  // return valid urls as is
  if (/^https?:\/?/i.test(url)) {
    return url;
  }
  // in all other cases
  return "https://".concat(url);
};
var isValueMultipleOfIncrement = function isValueMultipleOfIncrement(value, incrementValue) {
  return value % incrementValue === 0;
};
var orderSummaryDataTransformation = function orderSummaryDataTransformation(columns, tabledata) {
  var columnMap = new Map(columns.map(function (_ref) {
    var identifierID = _ref.identifierID,
      columnName = _ref.columnName;
    return [identifierID, columnName];
  }));
  var transformedData = tabledata.map(function (row) {
    return Object.fromEntries(Object.entries(row).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      var _a;
      return [(_a = columnMap.get(key)) !== null && _a !== undefined ? _a : key, value];
    }));
  });
  return transformedData;
};
var getInlineErrorToDisplay = function getInlineErrorToDisplay(error) {
  return error.replace("{{product_name}}:", '');
};
var getInlineError = function getInlineError(_ref4) {
  var error = _ref4.error,
    incrementValue = _ref4.incrementValue,
    themeProps = _ref4.themeProps;
  if (error === "errorIncrementQuantityText") {
    var errorMessage = String(themeProps.errorIncrementQuantityText);
    var updatedError = errorMessage.replace("{{increment_qty}}", String(incrementValue));
    return getInlineErrorToDisplay(updatedError);
  }
  return getInlineErrorToDisplay(themeProps[error]);
};

var useDebounce = function useDebounce(callback, delay) {
  var timeoutRef = useRef(null);
  return useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(function () {
      callback.apply(undefined, args);
    }, delay);
  }, [callback, delay]);
};

var getCustomerId = function getCustomerId() {
  var curr = null;
  try {
    curr = window['ShopifyAnalytics'].meta.page.customerId;
  } catch (e) {}
  try {
    curr = window['meta'].page.customerId;
  } catch (e) {}
  try {
    curr = window['__st'].cid;
  } catch (e) {}
  if (curr !== undefined && curr !== null && curr !== '') {
    return curr;
  }
  return null;
};
function getLocale() {
  if (window['Shopify']) {
    var locale = window['Shopify'].locale;
    return locale;
  }
  return '';
}
function getShop() {
  return window['Shopify'].shop || '';
}
function getCountryCode() {
  if (window['Shopify']) {
    var country = window['Shopify'].country;
    return country;
  }
  return '';
}
var getCountry = function getCountry(countryCode) {
  if (countryCode) return countryCode;
  return getCountryCode();
};
function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}
var updateWindowUpro = function updateWindowUpro(config) {
  if (window.upro) {
    /* If upro already exists, append the keys/values from the config object */
    Object.assign(window.upro, config);
  } else {
    /* If upro doesn't exist, initialize it with the config values */
    window.upro = Object.assign(Object.assign({}, config), {
      name: 'upro'
    });
  }
};

var getParamsFromArray = function getParamsFromArray(arr, addSpecifier) {
  return arr.reduce(function (acc, _ref, i) {
    var key = _ref.key,
      value = _ref.value;
    if (!value) return acc;
    if (value && i < arr.length - 1) {
      return "".concat(acc).concat(key, "=").concat(value, "&");
    }
    return "".concat(acc).concat(key, "=").concat(value);
  }, addSpecifier ? '?' : '');
};
var getURLWithParamsFromArray = function getURLWithParamsFromArray(url, params, addSpecifier) {
  return "".concat(url).concat(getParamsFromArray(params, addSpecifier));
};
var getParamsFromWindow = function getParamsFromWindow(url) {
  var addSpecifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var customerID = getCustomerId();
  var params = [{
    key: 'customerID',
    value: customerID ? formattedIDs(customerID, 'Customer') : false
  }, {
    key: 'shopURL',
    value: getShop()
  }, {
    key: 'locale',
    value: getLocale()
  }].filter(function (param) {
    return param.value;
  });
  return getURLWithParamsFromArray(url, params, addSpecifier);
};
var getURLFromParams = function getURLFromParams(_ref2) {
  var api = _ref2.api,
    customerID = _ref2.customerID,
    shopURL = _ref2.shopURL,
    locale = _ref2.locale,
    locationID = _ref2.locationID,
    countryCode = _ref2.countryCode;
  var params = [customerID && "customerID=".concat(customerID), shopURL && "shopURL=".concat(shopURL), locale && "locale=".concat(locale), locationID && "locationID=".concat(locationID), countryCode && "countryCode=".concat(countryCode)].filter(Boolean).join('&');
  return [api, params].filter(Boolean).join('?');
};

var authenticatedFetch = function authenticatedFetch(_a) {
  return __awaiter(undefined, [_a], undefined, function (_ref) {
    var api = _ref.api,
      _ref$isRequestBodyPre = _ref.isRequestBodyPresent,
      isRequestBodyPresent = _ref$isRequestBodyPre === undefined ? false : _ref$isRequestBodyPre,
      _ref$requestBody = _ref.requestBody,
      requestBody = _ref$requestBody === undefined ? null : _ref$requestBody,
      _ref$method = _ref.method,
      method = _ref$method === undefined ? 'GET' : _ref$method,
      _ref$token = _ref.token,
      token = _ref$token === undefined ? null : _ref$token,
      _ref$useBasicParams = _ref.useBasicParams,
      useBasicParams = _ref$useBasicParams === undefined ? false : _ref$useBasicParams;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var body, headers, res, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            body = isRequestBodyPresent ? JSON.stringify(requestBody) : null;
            headers = {
              'Content-Type': 'application/json'
            };
            if (token) headers['Authorization'] = "Bearer ".concat(token);
            _context.prev = 3;
            _context.next = 6;
            return fetch(useBasicParams ? getParamsFromWindow(api) : api, {
              method: method,
              headers: headers,
              body: body
            });
          case 6:
            res = _context.sent;
            if (!res.ok) {
              _context.next = 12;
              break;
            }
            _context.next = 10;
            return res.json();
          case 10:
            data = _context.sent;
            return _context.abrupt("return", data);
          case 12:
            throw new Error('Failed to fetch data');
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](3);
            console.error(_context.t0);
            return _context.abrupt("return", null);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 15]]);
    })();
  });
};

var clearCart = function clearCart() {
  return __awaiter(undefined, undefined, undefined, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var clearCartUrl, shopUrl, shouldClearCart;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          clearCartUrl = "/cart/clear.js";
          shopUrl = getShop();
          shouldClearCart = shopUrl && !ShopExcludedForClearingCart.includes(shopUrl);
          if (shouldClearCart) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return");
        case 5:
          _context.next = 7;
          return fetch(clearCartUrl, {
            method: 'GET'
          });
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};
var addItemsToCart = function addItemsToCart(items) {
  return __awaiter(undefined, undefined, undefined, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var chunkSize, chunkedItems, i, error, _i, res, data;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          // add maximum of 100 items in one api call
          chunkSize = 100;
          chunkedItems = [];
          for (i = 0; i < items.length; i += chunkSize) {
            chunkedItems.push(items.slice(i, i + chunkSize));
          }
          error = '';
          _i = 0;
        case 5:
          if (!(_i < chunkedItems.length)) {
            _context2.next = 19;
            break;
          }
          _context2.next = 8;
          return fetch("/cart/add.js", {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: chunkedItems[_i]
            })
          });
        case 8:
          res = _context2.sent;
          if (res.ok) {
            _context2.next = 14;
            break;
          }
          _context2.next = 12;
          return res.json();
        case 12:
          data = _context2.sent;
          error = data.message === 'Cart Error' ? 'Total SKUs cannot exceed 500' : 'Maximum quantity of some products in cart reached.';
        case 14:
          _context2.next = 16;
          return sleep(800);
        case 16:
          _i++;
          _context2.next = 5;
          break;
        case 19:
          return _context2.abrupt("return", error && error);
        case 20:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
};
var createCart = function createCart(product, columnTokens, columns) {
  return __awaiter(undefined, undefined, undefined, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var items, data;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return clearCart();
        case 2:
          // create items for cart
          items = product.filter(function (item) {
            return Number(item[columnTokens.quantity]) > 0;
          }) /* Filter out items with Quantity <= 0 */.map(function (item) {
            var productNoteColumns = getProductNoteColumnIDs(columns);
            // populating line item properties
            var properties = Object.fromEntries(productNoteColumns.map(function (col) {
              return [col.productNoteKey, item[col.columnName]];
            }).filter(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2);
                _ref2[0];
                var value = _ref2[1];
              return value;
            }));
            // for test cases, refer LargeCartPopUp/index.tsx
            return Object.assign({
              id: Number(item[columnTokens.variant_id]),
              quantity: Number(item[columnTokens.quantity])
            }, Object.keys(properties).length > 0 && {
              properties: properties
            });
          });
          _context3.next = 5;
          return addItemsToCart(items);
        case 5:
          data = _context3.sent;
          return _context3.abrupt("return", data ? data : null);
        case 7:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
};
var getIdsAndQty = function getIdsAndQty(_ref3) {
  var products = _ref3.products,
    columnsTokens = _ref3.columnsTokens;
  if (products.length > 0) {
    var idsAndQty = products.filter(function (elem) {
      return Number(elem[columnsTokens.quantity]) > 0;
    }) /* Filter out elements with Quantity <= 0 */.map(function (elem) {
      return "".concat(elem[columnsTokens.variant_id], ":").concat(elem[columnsTokens.quantity]);
    }); /* Map to "variantId:quantity" format */
    return idsAndQty.join(',');
  }
  return null;
};
// url to redirect when we click on create order button
var getCreateOrderUrl = function getCreateOrderUrl(shopURL, products, columnsTokens, mrOrderID, isGoToCheckout) {
  return "http://".concat(shopURL, "/cart/").concat(getIdsAndQty({
    products: products,
    columnsTokens: columnsTokens
  }), "?attributes[").concat(mrOrderIDAttributionKey, "]=").concat(mrOrderID).concat(!isGoToCheckout ? '&storefront=true' : '');
};
var addAttributesToCart = function addAttributesToCart(mrOrderID) {
  return __awaiter(undefined, undefined, undefined, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var attributes;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          attributes = {
            attributes: _defineProperty({}, mrOrderIDAttributionKey, mrOrderID)
          };
          _context4.next = 3;
          return fetch("/cart/update.js", {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(attributes)
          });
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
};

function useQuickSearchState(offerdata, selectedLocation, columns, isGoToCheckout, baseUrl, customerID, preSelectedLocation, isInternalDashboard) {
  var _this = this;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchedValue = _useState2[0],
    setSearchedValue = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    searchedProducts = _useState4[0],
    setSearchedProducts = _useState4[1];
  var _useState5 = useState(defaultSingleProduct),
    _useState6 = _slicedToArray(_useState5, 2),
    quickSearchSelectedProduct = _useState6[0],
    setQuickSearchSelectedProduct = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    quickSearchedTableData = _useState8[0],
    setQuickSearchedTableData = _useState8[1];
  var _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    mrOrderId = _useState0[0],
    setMrOrderId = _useState0[1];
  var _useState1 = useState(''),
    _useState10 = _slicedToArray(_useState1, 2),
    orderUrl = _useState10[0],
    setOrderUrl = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    createOrderButtonLoading = _useState12[0],
    setCreateOrderButtonLoading = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    searchedProductsLoading = _useState14[0],
    setSearchedProductsLoading = _useState14[1];
  useEffect(function () {
    setOrderUrl('');
    if (quickSearchedTableData.length === 0) {
      setMrOrderId('');
    }
  }, [quickSearchedTableData]);
  var commonFunctionForValidation = function commonFunctionForValidation(sp, value) {
    sp.error = undefined;
    var min = sp.min || 1;
    var max = Math.min(sp.max || maxPossibleItemQty, sp.availableStock || maxPossibleItemQty);
    var availableStock = sp.availableStock || maxPossibleItemQty;
    var increment = sp.increment || 1;
    var maxQtyThatCanBeAdded = Math.min(max, availableStock, closestMultiples(increment, max)[0]);
    var minQtyToBeAdded = Math.max(0, Math.min(min, availableStock));
    sp.quantity = value;
    if (value > maxQtyThatCanBeAdded) {
      var error = getInlineError({
        error: 'errorMaxOrderQuantityText',
        incrementValue: increment,
        themeProps: offerdata.theme
      });
      sp.error = "".concat(error, " (").concat(maxQtyThatCanBeAdded, ")");
    } else if (value < minQtyToBeAdded) {
      var _error = getInlineError({
        error: 'errorMinOrderQuantityText',
        incrementValue: increment,
        themeProps: offerdata.theme
      });
      sp.error = "".concat(_error, " (").concat(minQtyToBeAdded, ")");
    } else {
      var isChangedValuedMultipleOfIncrement = isValueMultipleOfIncrement(value, increment);
      if (!isChangedValuedMultipleOfIncrement) {
        // const [lowerClosest, higherClosest] = closestMultiples(
        //     increment,
        //     value,
        // );
        // const nearestValue =
        //     value - lowerClosest <= higherClosest - value
        //         ? lowerClosest
        //         : higherClosest;
        var _error2 = getInlineError({
          error: 'errorIncrementQuantityText',
          incrementValue: increment,
          themeProps: offerdata.theme
        });
        sp.error = _error2;
      }
    }
    return sp;
  };
  var onQuickSearchProductChangeForSearchRow = function onQuickSearchProductChangeForSearchRow(value) {
    var changedProduct = structuredClone(quickSearchSelectedProduct);
    var validatedProduct = commonFunctionForValidation(changedProduct, value);
    setQuickSearchSelectedProduct(validatedProduct);
  };
  var onQuickSearchProductAdd = function onQuickSearchProductAdd(d) {
    setQuickSearchedTableData(function (prev) {
      var existingProductIndex = prev.findIndex(function (product) {
        return product.variantId === d.variantId;
      });
      var min = d.min || 1;
      var max = Math.min(d.max || maxPossibleItemQty, d.availableStock || maxPossibleItemQty);
      var availableStock = d.availableStock || maxPossibleItemQty;
      var increment = d.increment || 1;
      var maxQtyThatCanBeAdded = Math.min(max, availableStock, closestMultiples(increment, max)[0]);
      var minQtyToBeAdded = Math.min(min, availableStock, closestMultiples(increment, min)[0], 0);
      if (existingProductIndex !== -1) {
        var updatedProduct = Object.assign({}, prev[existingProductIndex]);
        var newQuantity = (updatedProduct.quantity || 0) + (d.quantity || 0);
        if (newQuantity > maxQtyThatCanBeAdded) {
          newQuantity = maxQtyThatCanBeAdded;
        } else if (newQuantity < minQtyToBeAdded) {
          newQuantity = minQtyToBeAdded;
        } else {
          var isNewQuantityMultipleOfIncrement = isValueMultipleOfIncrement(newQuantity, increment);
          if (!isNewQuantityMultipleOfIncrement) {
            var _closestMultiples = closestMultiples(increment, newQuantity),
              _closestMultiples2 = _slicedToArray(_closestMultiples, 2),
              lowerClosest = _closestMultiples2[0],
              higherClosest = _closestMultiples2[1];
            newQuantity = newQuantity - lowerClosest <= higherClosest - newQuantity ? lowerClosest : higherClosest;
          }
        }
        updatedProduct.quantity = newQuantity;
        updatedProduct.error = '';
        var newData = _toConsumableArray(prev);
        newData[existingProductIndex] = updatedProduct;
        return newData;
      }
      var initialQuantity = d.quantity || min;
      if (initialQuantity > maxQtyThatCanBeAdded) {
        initialQuantity = maxQtyThatCanBeAdded;
      } else if (initialQuantity < minQtyToBeAdded) {
        initialQuantity = minQtyToBeAdded;
      } else {
        var isInitialQuantityMultipleOfIncrement = isValueMultipleOfIncrement(initialQuantity, increment);
        if (!isInitialQuantityMultipleOfIncrement) {
          var _closestMultiples3 = closestMultiples(increment, initialQuantity),
            _closestMultiples4 = _slicedToArray(_closestMultiples3, 2),
            _lowerClosest = _closestMultiples4[0],
            _higherClosest = _closestMultiples4[1];
          initialQuantity = initialQuantity - _lowerClosest <= _higherClosest - initialQuantity ? _lowerClosest : _higherClosest;
        }
      }
      return [].concat(_toConsumableArray(prev), [Object.assign(Object.assign({}, d), {
        quantity: initialQuantity
      })]);
    });
  };
  var onQuickSearchProductChange = function onQuickSearchProductChange(variantId, index, value) {
    var existingProductIndex = quickSearchedTableData.findIndex(function (product) {
      return product.variantId === variantId;
    });
    if (existingProductIndex === -1) {
      console.error("Product with variantId ".concat(variantId, " does not exist."));
      return;
    }
    var changedProduct = structuredClone(quickSearchedTableData[existingProductIndex]);
    var validatedProduct = commonFunctionForValidation(changedProduct, value);
    setQuickSearchedTableData(function (prev) {
      var newData = _toConsumableArray(prev);
      newData[existingProductIndex] = validatedProduct;
      return newData;
    });
  };
  var onClickCreateOrder = function onClickCreateOrder() {
    return __awaiter(_this, undefined, undefined, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var orderApi, updatedApi, requestBody, data, shopURL, _orderUrl, _data, redirectPath, toastParam;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isInternalDashboard) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            if (orderUrl) {
              _context.next = 26;
              break;
            }
            setCreateOrderButtonLoading(true);
            orderApi = "".concat(baseUrl).concat(FETCH_APP_ORDER_API);
            updatedApi = isInternalDashboard ? getURLFromParams({
              api: orderApi,
              customerID: customerID,
              shopURL: offerdata.shopURL,
              locale: (preSelectedLocation === null || preSelectedLocation === undefined ? undefined : preSelectedLocation.locale) || 'en'
            }) : "".concat(getParamsFromWindow(orderApi));
            requestBody = {
              locationID: (selectedLocation === null || selectedLocation === undefined ? undefined : selectedLocation.id) || null,
              countryCode: getCountry(selectedLocation === null || selectedLocation === undefined ? undefined : selectedLocation.countryCode),
              mrOrderID: mrOrderId,
              source: 'quick_search'
            }; // we redirect the user to cart or checkout based on the extension setup where they can purchase the items
            _context.next = 9;
            return authenticatedFetch({
              api: updatedApi,
              method: 'POST',
              isRequestBodyPresent: true,
              requestBody: requestBody
            });
          case 9:
            data = _context.sent;
            if (!data) {
              _context.next = 26;
              break;
            }
            shopURL = offerdata.shopURL;
            _orderUrl = getCreateOrderUrl(shopURL, quickSearchedTableData, columnsTokens, mrOrderId, isGoToCheckout);
            if (!(_orderUrl.length < 2000)) {
              _context.next = 18;
              break;
            }
            window.location.href = _orderUrl;
            setCreateOrderButtonLoading(false);
            _context.next = 26;
            break;
          case 18:
            _context.next = 20;
            return createCart(quickSearchedTableData, columnsTokens, columns);
          case 20:
            _data = _context.sent;
            _context.next = 23;
            return addAttributesToCart(mrOrderId);
          case 23:
            redirectPath = isGoToCheckout ? '/checkout' : '/cart';
            toastParam = _data ? "?toast=".concat(_data) : '';
            window.location.href = "".concat(redirectPath).concat(toastParam);
          case 26:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  };
  var fetchSearchedProducts = useDebounce(function (searchValue) {
    return __awaiter(_this, undefined, undefined, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _a, _b, params, quickSearchApi, updatedApi, d, matchedProduct;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            params = [{
              key: 'identifier',
              value: searchValue
            }, {
              key: 'locationID',
              value: (_a = selectedLocation === null || selectedLocation === undefined ? undefined : selectedLocation.id) === null || _a === undefined ? undefined : _a.toString()
            },
            // {
            //   key: 'companyID',
            //   value: formattedIDs('2046984437', 'Company'),
            // },
            {
              key: 'countryCode',
              value: (selectedLocation === null || selectedLocation === undefined ? undefined : selectedLocation.countryCode) || 'US'
            }];
            if (mrOrderId) {
              params.push({
                key: 'mrOrderID',
                value: mrOrderId
              });
            }
            setSearchedProducts([]);
            setSearchedProductsLoading(true);
            quickSearchApi = "".concat(baseUrl).concat(FETCH_SEARCH_PRODUCTS_API);
            updatedApi = isInternalDashboard ? getURLFromParams({
              api: quickSearchApi,
              customerID: customerID,
              shopURL: offerdata.shopURL,
              locale: (preSelectedLocation === null || preSelectedLocation === undefined ? undefined : preSelectedLocation.locale) || 'en'
            }) : "".concat(getParamsFromWindow(quickSearchApi));
            _context2.next = 8;
            return authenticatedFetch({
              api: "".concat(getURLWithParamsFromArray("".concat(updatedApi, "&"), params, false))
            });
          case 8:
            d = _context2.sent;
            if (d) {
              if ((_b = d[0]) === null || _b === undefined ? undefined : _b.mrOrderId) {
                setMrOrderId(d[0].mrOrderId);
              }
              setSearchedProducts(d);
              matchedProduct = d.find(function (product) {
                var _a, _b, _c, _d, _e;
                return ((_a = product.sku) === null || _a === undefined ? undefined : _a.toLowerCase()) === searchValue.toLowerCase() || ((_b = product.barcode) === null || _b === undefined ? undefined : _b.toLowerCase()) === searchValue.toLowerCase() || ((_c = product.variantName) === null || _c === undefined ? undefined : _c.toLowerCase()) === searchValue.toLowerCase() || ((_d = product.productName) === null || _d === undefined ? undefined : _d.toLowerCase()) + '~' + ((_e = product.variantName) === null || _e === undefined ? undefined : _e.toLowerCase()) === searchValue.toLowerCase();
              });
              if (matchedProduct) {
                setQuickSearchSelectedProduct(function (prev) {
                  var q = prev.quantity || matchedProduct.quantity;
                  return commonFunctionForValidation(matchedProduct, q);
                });
              }
            }
            setSearchedProductsLoading(false);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  }, 300);
  return {
    searchedValue: searchedValue,
    setSearchedValue: setSearchedValue,
    searchedProducts: searchedProducts,
    setSearchedProducts: setSearchedProducts,
    quickSearchedTableData: quickSearchedTableData,
    setQuickSearchedTableData: setQuickSearchedTableData,
    quickSearchSelectedProduct: quickSearchSelectedProduct,
    setQuickSearchSelectedProduct: setQuickSearchSelectedProduct,
    // mrOrderId,
    // setMrOrderId,
    orderUrl: orderUrl,
    // setOrderUrl,
    createOrderButtonLoading: createOrderButtonLoading,
    setCreateOrderButtonLoading: setCreateOrderButtonLoading,
    searchedProductsLoading: searchedProductsLoading,
    // setSearchedProductsLoading,
    // utlities
    fetchSearchedProducts: fetchSearchedProducts,
    onQuickSearchProductAdd: onQuickSearchProductAdd,
    onQuickSearchProductChange: onQuickSearchProductChange,
    onClickCreateOrder: onClickCreateOrder,
    // commonFunctionForValidation,
    onQuickSearchProductChangeForSearchRow: onQuickSearchProductChangeForSearchRow
  };
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var papaparse = {exports: {}};

/* @license
Papa Parse
v5.5.3
https://github.com/mholt/PapaParse
License: MIT
*/

(function (module, exports) {
	(function(root, factory)
	{
		/* globals define */
		{
			// Node. Does not work with strict CommonJS, but
			// only CommonJS-like environments that support module.exports,
			// like Node.
			module.exports = factory();
		}
		// in strict mode we cannot access arguments.callee, so we need a named reference to
		// stringify the factory method for the blob worker
		// eslint-disable-next-line func-name
	}(commonjsGlobal, function moduleFactory()
	{

		var global = (function() {
			// alternative method, similar to `Function('return this')()`
			// but without using `eval` (which is disabled when
			// using Content Security Policy).

			if (typeof self !== 'undefined') { return self; }
			if (typeof window !== 'undefined') { return window; }
			if (typeof global !== 'undefined') { return global; }

			// When running tests none of the above have been defined
			return {};
		})();


		function getWorkerBlob() {
			var URL = global.URL || global.webkitURL || null;
			var code = moduleFactory.toString();
			return Papa.BLOB_URL || (Papa.BLOB_URL = URL.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", '(', code, ')();'], {type: 'text/javascript'})));
		}

		var IS_WORKER = !global.document && !!global.postMessage,
			IS_PAPA_WORKER = global.IS_PAPA_WORKER || false;

		var workers = {}, workerIdCounter = 0;

		var Papa = {};

		Papa.parse = CsvToJson;
		Papa.unparse = JsonToCsv;

		Papa.RECORD_SEP = String.fromCharCode(30);
		Papa.UNIT_SEP = String.fromCharCode(31);
		Papa.BYTE_ORDER_MARK = '\ufeff';
		Papa.BAD_DELIMITERS = ['\r', '\n', '"', Papa.BYTE_ORDER_MARK];
		Papa.WORKERS_SUPPORTED = !IS_WORKER && !!global.Worker;
		Papa.NODE_STREAM_INPUT = 1;

		// Configurable chunk sizes for local and remote files, respectively
		Papa.LocalChunkSize = 1024 * 1024 * 10;	// 10 MB
		Papa.RemoteChunkSize = 1024 * 1024 * 5;	// 5 MB
		Papa.DefaultDelimiter = ',';			// Used if not specified and detection fails

		// Exposed for testing and development only
		Papa.Parser = Parser;
		Papa.ParserHandle = ParserHandle;
		Papa.NetworkStreamer = NetworkStreamer;
		Papa.FileStreamer = FileStreamer;
		Papa.StringStreamer = StringStreamer;
		Papa.ReadableStreamStreamer = ReadableStreamStreamer;
		if (typeof PAPA_BROWSER_CONTEXT === 'undefined') {
			Papa.DuplexStreamStreamer = DuplexStreamStreamer;
		}

		if (global.jQuery)
		{
			var $ = global.jQuery;
			$.fn.parse = function(options)
			{
				var config = options.config || {};
				var queue = [];

				this.each(function(idx)
				{
					var supported = $(this).prop('tagName').toUpperCase() === 'INPUT'
									&& $(this).attr('type').toLowerCase() === 'file'
									&& global.FileReader;

					if (!supported || !this.files || this.files.length === 0)
						return true;	// continue to next input element

					for (var i = 0; i < this.files.length; i++)
					{
						queue.push({
							file: this.files[i],
							inputElem: this,
							instanceConfig: $.extend({}, config)
						});
					}
				});

				parseNextFile();	// begin parsing
				return this;		// maintains chainability


				function parseNextFile()
				{
					if (queue.length === 0)
					{
						if (isFunction(options.complete))
							options.complete();
						return;
					}

					var f = queue[0];

					if (isFunction(options.before))
					{
						var returned = options.before(f.file, f.inputElem);

						if (typeof returned === 'object')
						{
							if (returned.action === 'abort')
							{
								error('AbortError', f.file, f.inputElem, returned.reason);
								return;	// Aborts all queued files immediately
							}
							else if (returned.action === 'skip')
							{
								fileComplete();	// parse the next file in the queue, if any
								return;
							}
							else if (typeof returned.config === 'object')
								f.instanceConfig = $.extend(f.instanceConfig, returned.config);
						}
						else if (returned === 'skip')
						{
							fileComplete();	// parse the next file in the queue, if any
							return;
						}
					}

					// Wrap up the user's complete callback, if any, so that ours also gets executed
					var userCompleteFunc = f.instanceConfig.complete;
					f.instanceConfig.complete = function(results)
					{
						if (isFunction(userCompleteFunc))
							userCompleteFunc(results, f.file, f.inputElem);
						fileComplete();
					};

					Papa.parse(f.file, f.instanceConfig);
				}

				function error(name, file, elem, reason)
				{
					if (isFunction(options.error))
						options.error({name: name}, file, elem, reason);
				}

				function fileComplete()
				{
					queue.splice(0, 1);
					parseNextFile();
				}
			};
		}


		if (IS_PAPA_WORKER)
		{
			global.onmessage = workerThreadReceivedMessage;
		}




		function CsvToJson(_input, _config)
		{
			_config = _config || {};
			var dynamicTyping = _config.dynamicTyping || false;
			if (isFunction(dynamicTyping)) {
				_config.dynamicTypingFunction = dynamicTyping;
				// Will be filled on first row call
				dynamicTyping = {};
			}
			_config.dynamicTyping = dynamicTyping;

			_config.transform = isFunction(_config.transform) ? _config.transform : false;

			if (_config.worker && Papa.WORKERS_SUPPORTED)
			{
				var w = newWorker();

				w.userStep = _config.step;
				w.userChunk = _config.chunk;
				w.userComplete = _config.complete;
				w.userError = _config.error;

				_config.step = isFunction(_config.step);
				_config.chunk = isFunction(_config.chunk);
				_config.complete = isFunction(_config.complete);
				_config.error = isFunction(_config.error);
				delete _config.worker;	// prevent infinite loop

				w.postMessage({
					input: _input,
					config: _config,
					workerId: w.id
				});

				return;
			}

			var streamer = null;
			if (_input === Papa.NODE_STREAM_INPUT && typeof PAPA_BROWSER_CONTEXT === 'undefined')
			{
				// create a node Duplex stream for use
				// with .pipe
				streamer = new DuplexStreamStreamer(_config);
				return streamer.getStream();
			}
			else if (typeof _input === 'string')
			{
				_input = stripBom(_input);
				if (_config.download)
					streamer = new NetworkStreamer(_config);
				else
					streamer = new StringStreamer(_config);
			}
			else if (_input.readable === true && isFunction(_input.read) && isFunction(_input.on))
			{
				streamer = new ReadableStreamStreamer(_config);
			}
			else if ((global.File && _input instanceof File) || _input instanceof Object)	// ...Safari. (see issue #106)
				streamer = new FileStreamer(_config);

			return streamer.stream(_input);

			// Strip character from UTF-8 BOM encoded files that cause issue parsing the file
			function stripBom(string) {
				if (string.charCodeAt(0) === 0xfeff) {
					return string.slice(1);
				}
				return string;
			}
		}






		function JsonToCsv(_input, _config)
		{
			// Default configuration

			/** whether to surround every datum with quotes */
			var _quotes = false;

			/** whether to write headers */
			var _writeHeader = true;

			/** delimiting character(s) */
			var _delimiter = ',';

			/** newline character(s) */
			var _newline = '\r\n';

			/** quote character */
			var _quoteChar = '"';

			/** escaped quote character, either "" or <config.escapeChar>" */
			var _escapedQuote = _quoteChar + _quoteChar;

			/** whether to skip empty lines */
			var _skipEmptyLines = false;

			/** the columns (keys) we expect when we unparse objects */
			var _columns = null;

			/** whether to prevent outputting cells that can be parsed as formulae by spreadsheet software (Excel and LibreOffice) */
			var _escapeFormulae = false;

			unpackConfig();

			var quoteCharRegex = new RegExp(escapeRegExp(_quoteChar), 'g');

			if (typeof _input === 'string')
				_input = JSON.parse(_input);

			if (Array.isArray(_input))
			{
				if (!_input.length || Array.isArray(_input[0]))
					return serialize(null, _input, _skipEmptyLines);
				else if (typeof _input[0] === 'object')
					return serialize(_columns || Object.keys(_input[0]), _input, _skipEmptyLines);
			}
			else if (typeof _input === 'object')
			{
				if (typeof _input.data === 'string')
					_input.data = JSON.parse(_input.data);

				if (Array.isArray(_input.data))
				{
					if (!_input.fields)
						_input.fields = _input.meta && _input.meta.fields || _columns;

					if (!_input.fields)
						_input.fields =  Array.isArray(_input.data[0])
							? _input.fields
							: typeof _input.data[0] === 'object'
								? Object.keys(_input.data[0])
								: [];

					if (!(Array.isArray(_input.data[0])) && typeof _input.data[0] !== 'object')
						_input.data = [_input.data];	// handles input like [1,2,3] or ['asdf']
				}

				return serialize(_input.fields || [], _input.data || [], _skipEmptyLines);
			}

			// Default (any valid paths should return before this)
			throw new Error('Unable to serialize unrecognized input');


			function unpackConfig()
			{
				if (typeof _config !== 'object')
					return;

				if (typeof _config.delimiter === 'string'
	                && !Papa.BAD_DELIMITERS.filter(function(value) { return _config.delimiter.indexOf(value) !== -1; }).length)
				{
					_delimiter = _config.delimiter;
				}

				if (typeof _config.quotes === 'boolean'
					|| typeof _config.quotes === 'function'
					|| Array.isArray(_config.quotes))
					_quotes = _config.quotes;

				if (typeof _config.skipEmptyLines === 'boolean'
					|| typeof _config.skipEmptyLines === 'string')
					_skipEmptyLines = _config.skipEmptyLines;

				if (typeof _config.newline === 'string')
					_newline = _config.newline;

				if (typeof _config.quoteChar === 'string')
					_quoteChar = _config.quoteChar;

				if (typeof _config.header === 'boolean')
					_writeHeader = _config.header;

				if (Array.isArray(_config.columns)) {

					if (_config.columns.length === 0) throw new Error('Option columns is empty');

					_columns = _config.columns;
				}

				if (_config.escapeChar !== undefined) {
					_escapedQuote = _config.escapeChar + _quoteChar;
				}

				if (_config.escapeFormulae instanceof RegExp) {
					_escapeFormulae = _config.escapeFormulae;
				} else if (typeof _config.escapeFormulae === 'boolean' && _config.escapeFormulae) {
					_escapeFormulae =  /^[=+\-@\t\r].*$/;
				}
			}

			/** The double for loop that iterates the data and writes out a CSV string including header row */
			function serialize(fields, data, skipEmptyLines)
			{
				var csv = '';

				if (typeof fields === 'string')
					fields = JSON.parse(fields);
				if (typeof data === 'string')
					data = JSON.parse(data);

				var hasHeader = Array.isArray(fields) && fields.length > 0;
				var dataKeyedByField = !(Array.isArray(data[0]));

				// If there a header row, write it first
				if (hasHeader && _writeHeader)
				{
					for (var i = 0; i < fields.length; i++)
					{
						if (i > 0)
							csv += _delimiter;
						csv += safe(fields[i], i);
					}
					if (data.length > 0)
						csv += _newline;
				}

				// Then write out the data
				for (var row = 0; row < data.length; row++)
				{
					var maxCol = hasHeader ? fields.length : data[row].length;

					var emptyLine = false;
					var nullLine = hasHeader ? Object.keys(data[row]).length === 0 : data[row].length === 0;
					if (skipEmptyLines && !hasHeader)
					{
						emptyLine = skipEmptyLines === 'greedy' ? data[row].join('').trim() === '' : data[row].length === 1 && data[row][0].length === 0;
					}
					if (skipEmptyLines === 'greedy' && hasHeader) {
						var line = [];
						for (var c = 0; c < maxCol; c++) {
							var cx = dataKeyedByField ? fields[c] : c;
							line.push(data[row][cx]);
						}
						emptyLine = line.join('').trim() === '';
					}
					if (!emptyLine)
					{
						for (var col = 0; col < maxCol; col++)
						{
							if (col > 0 && !nullLine)
								csv += _delimiter;
							var colIdx = hasHeader && dataKeyedByField ? fields[col] : col;
							csv += safe(data[row][colIdx], col);
						}
						if (row < data.length - 1 && (!skipEmptyLines || (maxCol > 0 && !nullLine)))
						{
							csv += _newline;
						}
					}
				}
				return csv;
			}

			/** Encloses a value around quotes if needed (makes a value safe for CSV insertion) */
			function safe(str, col)
			{
				if (typeof str === 'undefined' || str === null)
					return '';

				if (str.constructor === Date)
					return JSON.stringify(str).slice(1, 25);

				var needsQuotes = false;

				if (_escapeFormulae && typeof str === "string" && _escapeFormulae.test(str)) {
					str = "'" + str;
					needsQuotes = true;
				}

				var escapedQuoteStr = str.toString().replace(quoteCharRegex, _escapedQuote);

				needsQuotes = needsQuotes
								|| _quotes === true
								|| (typeof _quotes === 'function' && _quotes(str, col))
								|| (Array.isArray(_quotes) && _quotes[col])
								|| hasAny(escapedQuoteStr, Papa.BAD_DELIMITERS)
								|| escapedQuoteStr.indexOf(_delimiter) > -1
								|| escapedQuoteStr.charAt(0) === ' '
								|| escapedQuoteStr.charAt(escapedQuoteStr.length - 1) === ' ';

				return needsQuotes ? _quoteChar + escapedQuoteStr + _quoteChar : escapedQuoteStr;
			}

			function hasAny(str, substrings)
			{
				for (var i = 0; i < substrings.length; i++)
					if (str.indexOf(substrings[i]) > -1)
						return true;
				return false;
			}
		}


		/** ChunkStreamer is the base prototype for various streamer implementations. */
		function ChunkStreamer(config)
		{
			this._handle = null;
			this._finished = false;
			this._completed = false;
			this._halted = false;
			this._input = null;
			this._baseIndex = 0;
			this._partialLine = '';
			this._rowCount = 0;
			this._start = 0;
			this._nextChunk = null;
			this.isFirstChunk = true;
			this._completeResults = {
				data: [],
				errors: [],
				meta: {}
			};
			replaceConfig.call(this, config);

			this.parseChunk = function(chunk, isFakeChunk)
			{
				// First chunk pre-processing
				const skipFirstNLines = parseInt(this._config.skipFirstNLines) || 0;
				if (this.isFirstChunk && skipFirstNLines > 0) {
					let _newline = this._config.newline;
					if (!_newline) {
						const quoteChar = this._config.quoteChar || '"';
						_newline = this._handle.guessLineEndings(chunk, quoteChar);
					}
					const splitChunk = chunk.split(_newline);
					chunk = [...splitChunk.slice(skipFirstNLines)].join(_newline);
				}
				if (this.isFirstChunk && isFunction(this._config.beforeFirstChunk))
				{
					var modifiedChunk = this._config.beforeFirstChunk(chunk);
					if (modifiedChunk !== undefined)
						chunk = modifiedChunk;
				}
				this.isFirstChunk = false;
				this._halted = false;

				// Rejoin the line we likely just split in two by chunking the file
				var aggregate = this._partialLine + chunk;
				this._partialLine = '';
				var results = this._handle.parse(aggregate, this._baseIndex, !this._finished);

				if (this._handle.paused() || this._handle.aborted()) {
					this._halted = true;
					return;
				}

				var lastIndex = results.meta.cursor;

				if (!this._finished)
				{
					this._partialLine = aggregate.substring(lastIndex - this._baseIndex);
					this._baseIndex = lastIndex;
				}

				if (results && results.data)
					this._rowCount += results.data.length;

				var finishedIncludingPreview = this._finished || (this._config.preview && this._rowCount >= this._config.preview);

				if (IS_PAPA_WORKER)
				{
					global.postMessage({
						results: results,
						workerId: Papa.WORKER_ID,
						finished: finishedIncludingPreview
					});
				}
				else if (isFunction(this._config.chunk) && !isFakeChunk)
				{
					this._config.chunk(results, this._handle);
					if (this._handle.paused() || this._handle.aborted()) {
						this._halted = true;
						return;
					}
					results = undefined;
					this._completeResults = undefined;
				}

				if (!this._config.step && !this._config.chunk) {
					this._completeResults.data = this._completeResults.data.concat(results.data);
					this._completeResults.errors = this._completeResults.errors.concat(results.errors);
					this._completeResults.meta = results.meta;
				}

				if (!this._completed && finishedIncludingPreview && isFunction(this._config.complete) && (!results || !results.meta.aborted)) {
					this._config.complete(this._completeResults, this._input);
					this._completed = true;
				}

				if (!finishedIncludingPreview && (!results || !results.meta.paused))
					this._nextChunk();

				return results;
			};

			this._sendError = function(error)
			{
				if (isFunction(this._config.error))
					this._config.error(error);
				else if (IS_PAPA_WORKER && this._config.error)
				{
					global.postMessage({
						workerId: Papa.WORKER_ID,
						error: error,
						finished: false
					});
				}
			};

			function replaceConfig(config)
			{
				// Deep-copy the config so we can edit it
				var configCopy = copy(config);
				configCopy.chunkSize = parseInt(configCopy.chunkSize);	// parseInt VERY important so we don't concatenate strings!
				if (!config.step && !config.chunk)
					configCopy.chunkSize = null;  // disable Range header if not streaming; bad values break IIS - see issue #196
				this._handle = new ParserHandle(configCopy);
				this._handle.streamer = this;
				this._config = configCopy;	// persist the copy to the caller
			}
		}


		function NetworkStreamer(config)
		{
			config = config || {};
			if (!config.chunkSize)
				config.chunkSize = Papa.RemoteChunkSize;
			ChunkStreamer.call(this, config);

			var xhr;

			if (IS_WORKER)
			{
				this._nextChunk = function()
				{
					this._readChunk();
					this._chunkLoaded();
				};
			}
			else
			{
				this._nextChunk = function()
				{
					this._readChunk();
				};
			}

			this.stream = function(url)
			{
				this._input = url;
				this._nextChunk();	// Starts streaming
			};

			this._readChunk = function()
			{
				if (this._finished)
				{
					this._chunkLoaded();
					return;
				}

				xhr = new XMLHttpRequest();

				if (this._config.withCredentials)
				{
					xhr.withCredentials = this._config.withCredentials;
				}

				if (!IS_WORKER)
				{
					xhr.onload = bindFunction(this._chunkLoaded, this);
					xhr.onerror = bindFunction(this._chunkError, this);
				}

				xhr.open(this._config.downloadRequestBody ? 'POST' : 'GET', this._input, !IS_WORKER);
				// Headers can only be set when once the request state is OPENED
				if (this._config.downloadRequestHeaders)
				{
					var headers = this._config.downloadRequestHeaders;

					for (var headerName in headers)
					{
						xhr.setRequestHeader(headerName, headers[headerName]);
					}
				}

				if (this._config.chunkSize)
				{
					var end = this._start + this._config.chunkSize - 1;	// minus one because byte range is inclusive
					xhr.setRequestHeader('Range', 'bytes=' + this._start + '-' + end);
				}

				try {
					xhr.send(this._config.downloadRequestBody);
				}
				catch (err) {
					this._chunkError(err.message);
				}

				if (IS_WORKER && xhr.status === 0)
					this._chunkError();
			};

			this._chunkLoaded = function()
			{
				if (xhr.readyState !== 4)
					return;

				if (xhr.status < 200 || xhr.status >= 400)
				{
					this._chunkError();
					return;
				}

				// Use chunckSize as it may be a diference on reponse lentgh due to characters with more than 1 byte
				this._start += this._config.chunkSize ? this._config.chunkSize : xhr.responseText.length;
				this._finished = !this._config.chunkSize || this._start >= getFileSize(xhr);
				this.parseChunk(xhr.responseText);
			};

			this._chunkError = function(errorMessage)
			{
				var errorText = xhr.statusText || errorMessage;
				this._sendError(new Error(errorText));
			};

			function getFileSize(xhr)
			{
				var contentRange = xhr.getResponseHeader('Content-Range');
				if (contentRange === null) { // no content range, then finish!
					return -1;
				}
				return parseInt(contentRange.substring(contentRange.lastIndexOf('/') + 1));
			}
		}
		NetworkStreamer.prototype = Object.create(ChunkStreamer.prototype);
		NetworkStreamer.prototype.constructor = NetworkStreamer;


		function FileStreamer(config)
		{
			config = config || {};
			if (!config.chunkSize)
				config.chunkSize = Papa.LocalChunkSize;
			ChunkStreamer.call(this, config);

			var reader, slice;

			// FileReader is better than FileReaderSync (even in worker) - see http://stackoverflow.com/q/24708649/1048862
			// But Firefox is a pill, too - see issue #76: https://github.com/mholt/PapaParse/issues/76
			var usingAsyncReader = typeof FileReader !== 'undefined';	// Safari doesn't consider it a function - see issue #105

			this.stream = function(file)
			{
				this._input = file;
				slice = file.slice || file.webkitSlice || file.mozSlice;

				if (usingAsyncReader)
				{
					reader = new FileReader();		// Preferred method of reading files, even in workers
					reader.onload = bindFunction(this._chunkLoaded, this);
					reader.onerror = bindFunction(this._chunkError, this);
				}
				else
					reader = new FileReaderSync();	// Hack for running in a web worker in Firefox

				this._nextChunk();	// Starts streaming
			};

			this._nextChunk = function()
			{
				if (!this._finished && (!this._config.preview || this._rowCount < this._config.preview))
					this._readChunk();
			};

			this._readChunk = function()
			{
				var input = this._input;
				if (this._config.chunkSize)
				{
					var end = Math.min(this._start + this._config.chunkSize, this._input.size);
					input = slice.call(input, this._start, end);
				}
				var txt = reader.readAsText(input, this._config.encoding);
				if (!usingAsyncReader)
					this._chunkLoaded({ target: { result: txt } });	// mimic the async signature
			};

			this._chunkLoaded = function(event)
			{
				// Very important to increment start each time before handling results
				this._start += this._config.chunkSize;
				this._finished = !this._config.chunkSize || this._start >= this._input.size;
				this.parseChunk(event.target.result);
			};

			this._chunkError = function()
			{
				this._sendError(reader.error);
			};

		}
		FileStreamer.prototype = Object.create(ChunkStreamer.prototype);
		FileStreamer.prototype.constructor = FileStreamer;


		function StringStreamer(config)
		{
			config = config || {};
			ChunkStreamer.call(this, config);

			var remaining;
			this.stream = function(s)
			{
				remaining = s;
				return this._nextChunk();
			};
			this._nextChunk = function()
			{
				if (this._finished) return;
				var size = this._config.chunkSize;
				var chunk;
				if(size) {
					chunk = remaining.substring(0, size);
					remaining = remaining.substring(size);
				} else {
					chunk = remaining;
					remaining = '';
				}
				this._finished = !remaining;
				return this.parseChunk(chunk);
			};
		}
		StringStreamer.prototype = Object.create(StringStreamer.prototype);
		StringStreamer.prototype.constructor = StringStreamer;


		function ReadableStreamStreamer(config)
		{
			config = config || {};

			ChunkStreamer.call(this, config);

			var queue = [];
			var parseOnData = true;
			var streamHasEnded = false;

			this.pause = function()
			{
				ChunkStreamer.prototype.pause.apply(this, arguments);
				this._input.pause();
			};

			this.resume = function()
			{
				ChunkStreamer.prototype.resume.apply(this, arguments);
				this._input.resume();
			};

			this.stream = function(stream)
			{
				this._input = stream;

				this._input.on('data', this._streamData);
				this._input.on('end', this._streamEnd);
				this._input.on('error', this._streamError);
			};

			this._checkIsFinished = function()
			{
				if (streamHasEnded && queue.length === 1) {
					this._finished = true;
				}
			};

			this._nextChunk = function()
			{
				this._checkIsFinished();
				if (queue.length)
				{
					this.parseChunk(queue.shift());
				}
				else
				{
					parseOnData = true;
				}
			};

			this._streamData = bindFunction(function(chunk)
			{
				try
				{
					queue.push(typeof chunk === 'string' ? chunk : chunk.toString(this._config.encoding));

					if (parseOnData)
					{
						parseOnData = false;
						this._checkIsFinished();
						this.parseChunk(queue.shift());
					}
				}
				catch (error)
				{
					this._streamError(error);
				}
			}, this);

			this._streamError = bindFunction(function(error)
			{
				this._streamCleanUp();
				this._sendError(error);
			}, this);

			this._streamEnd = bindFunction(function()
			{
				this._streamCleanUp();
				streamHasEnded = true;
				this._streamData('');
			}, this);

			this._streamCleanUp = bindFunction(function()
			{
				this._input.removeListener('data', this._streamData);
				this._input.removeListener('end', this._streamEnd);
				this._input.removeListener('error', this._streamError);
			}, this);
		}
		ReadableStreamStreamer.prototype = Object.create(ChunkStreamer.prototype);
		ReadableStreamStreamer.prototype.constructor = ReadableStreamStreamer;


		function DuplexStreamStreamer(_config) {
			var Duplex = require$$0.Duplex;
			var config = copy(_config);
			var parseOnWrite = true;
			var writeStreamHasFinished = false;
			var parseCallbackQueue = [];
			var stream = null;

			this._onCsvData = function(results)
			{
				var data = results.data;
				if (!stream.push(data) && !this._handle.paused()) {
					// the writeable consumer buffer has filled up
					// so we need to pause until more items
					// can be processed
					this._handle.pause();
				}
			};

			this._onCsvComplete = function()
			{
				// node will finish the read stream when
				// null is pushed
				stream.push(null);
			};

			config.step = bindFunction(this._onCsvData, this);
			config.complete = bindFunction(this._onCsvComplete, this);
			ChunkStreamer.call(this, config);

			this._nextChunk = function()
			{
				if (writeStreamHasFinished && parseCallbackQueue.length === 1) {
					this._finished = true;
				}
				if (parseCallbackQueue.length) {
					parseCallbackQueue.shift()();
				} else {
					parseOnWrite = true;
				}
			};

			this._addToParseQueue = function(chunk, callback)
			{
				// add to queue so that we can indicate
				// completion via callback
				// node will automatically pause the incoming stream
				// when too many items have been added without their
				// callback being invoked
				parseCallbackQueue.push(bindFunction(function() {
					this.parseChunk(typeof chunk === 'string' ? chunk : chunk.toString(config.encoding));
					if (isFunction(callback)) {
						return callback();
					}
				}, this));
				if (parseOnWrite) {
					parseOnWrite = false;
					this._nextChunk();
				}
			};

			this._onRead = function()
			{
				if (this._handle.paused()) {
					// the writeable consumer can handle more data
					// so resume the chunk parsing
					this._handle.resume();
				}
			};

			this._onWrite = function(chunk, encoding, callback)
			{
				this._addToParseQueue(chunk, callback);
			};

			this._onWriteComplete = function()
			{
				writeStreamHasFinished = true;
				// have to write empty string
				// so parser knows its done
				this._addToParseQueue('');
			};

			this.getStream = function()
			{
				return stream;
			};
			stream = new Duplex({
				readableObjectMode: true,
				decodeStrings: false,
				read: bindFunction(this._onRead, this),
				write: bindFunction(this._onWrite, this)
			});
			stream.once('finish', bindFunction(this._onWriteComplete, this));
		}
		if (typeof PAPA_BROWSER_CONTEXT === 'undefined') {
			DuplexStreamStreamer.prototype = Object.create(ChunkStreamer.prototype);
			DuplexStreamStreamer.prototype.constructor = DuplexStreamStreamer;
		}


		// Use one ParserHandle per entire CSV file or string
		function ParserHandle(_config)
		{
			// One goal is to minimize the use of regular expressions...
			var MAX_FLOAT = Math.pow(2, 53);
			var MIN_FLOAT = -MAX_FLOAT;
			var FLOAT = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/;
			var ISO_DATE = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/;
			var self = this;
			var _stepCounter = 0;	// Number of times step was called (number of rows parsed)
			var _rowCounter = 0;	// Number of rows that have been parsed so far
			var _input;				// The input being parsed
			var _parser;			// The core parser being used
			var _paused = false;	// Whether we are paused or not
			var _aborted = false;	// Whether the parser has aborted or not
			var _delimiterError;	// Temporary state between delimiter detection and processing results
			var _fields = [];		// Fields are from the header row of the input, if there is one
			var _results = {		// The last results returned from the parser
				data: [],
				errors: [],
				meta: {}
			};

			if (isFunction(_config.step))
			{
				var userStep = _config.step;
				_config.step = function(results)
				{
					_results = results;

					if (needsHeaderRow())
						processResults();
					else	// only call user's step function after header row
					{
						processResults();

						// It's possbile that this line was empty and there's no row here after all
						if (_results.data.length === 0)
							return;

						_stepCounter += results.data.length;
						if (_config.preview && _stepCounter > _config.preview)
							_parser.abort();
						else {
							_results.data = _results.data[0];
							userStep(_results, self);
						}
					}
				};
			}

			/**
			 * Parses input. Most users won't need, and shouldn't mess with, the baseIndex
			 * and ignoreLastRow parameters. They are used by streamers (wrapper functions)
			 * when an input comes in multiple chunks, like from a file.
			 */
			this.parse = function(input, baseIndex, ignoreLastRow)
			{
				var quoteChar = _config.quoteChar || '"';
				if (!_config.newline)
					_config.newline = this.guessLineEndings(input, quoteChar);

				_delimiterError = false;
				if (!_config.delimiter)
				{
					var delimGuess = guessDelimiter(input, _config.newline, _config.skipEmptyLines, _config.comments, _config.delimitersToGuess);
					if (delimGuess.successful)
						_config.delimiter = delimGuess.bestDelimiter;
					else
					{
						_delimiterError = true;	// add error after parsing (otherwise it would be overwritten)
						_config.delimiter = Papa.DefaultDelimiter;
					}
					_results.meta.delimiter = _config.delimiter;
				}
				else if(isFunction(_config.delimiter))
				{
					_config.delimiter = _config.delimiter(input);
					_results.meta.delimiter = _config.delimiter;
				}

				var parserConfig = copy(_config);
				if (_config.preview && _config.header)
					parserConfig.preview++;	// to compensate for header row

				_input = input;
				_parser = new Parser(parserConfig);
				_results = _parser.parse(_input, baseIndex, ignoreLastRow);
				processResults();
				return _paused ? { meta: { paused: true } } : (_results || { meta: { paused: false } });
			};

			this.paused = function()
			{
				return _paused;
			};

			this.pause = function()
			{
				_paused = true;
				_parser.abort();

				// If it is streaming via "chunking", the reader will start appending correctly already so no need to substring,
				// otherwise we can get duplicate content within a row
				_input = isFunction(_config.chunk) ? "" : _input.substring(_parser.getCharIndex());
			};

			this.resume = function()
			{
				if(self.streamer._halted) {
					_paused = false;
					self.streamer.parseChunk(_input, true);
				} else {
					// Bugfix: #636 In case the processing hasn't halted yet
					// wait for it to halt in order to resume
					setTimeout(self.resume, 3);
				}
			};

			this.aborted = function()
			{
				return _aborted;
			};

			this.abort = function()
			{
				_aborted = true;
				_parser.abort();
				_results.meta.aborted = true;
				if (isFunction(_config.complete))
					_config.complete(_results);
				_input = '';
			};

			this.guessLineEndings = function(input, quoteChar)
			{
				input = input.substring(0, 1024 * 1024);	// max length 1 MB
				// Replace all the text inside quotes
				var re = new RegExp(escapeRegExp(quoteChar) + '([^]*?)' + escapeRegExp(quoteChar), 'gm');
				input = input.replace(re, '');

				var r = input.split('\r');

				var n = input.split('\n');

				var nAppearsFirst = (n.length > 1 && n[0].length < r[0].length);

				if (r.length === 1 || nAppearsFirst)
					return '\n';

				var numWithN = 0;
				for (var i = 0; i < r.length; i++)
				{
					if (r[i][0] === '\n')
						numWithN++;
				}

				return numWithN >= r.length / 2 ? '\r\n' : '\r';
			};

			function testEmptyLine(s) {
				return _config.skipEmptyLines === 'greedy' ? s.join('').trim() === '' : s.length === 1 && s[0].length === 0;
			}

			function testFloat(s) {
				if (FLOAT.test(s)) {
					var floatValue = parseFloat(s);
					if (floatValue > MIN_FLOAT && floatValue < MAX_FLOAT) {
						return true;
					}
				}
				return false;
			}

			function processResults()
			{
				if (_results && _delimiterError)
				{
					addError('Delimiter', 'UndetectableDelimiter', 'Unable to auto-detect delimiting character; defaulted to \'' + Papa.DefaultDelimiter + '\'');
					_delimiterError = false;
				}

				if (_config.skipEmptyLines)
				{
					_results.data = _results.data.filter(function(d) {
						return !testEmptyLine(d);
					});
				}

				if (needsHeaderRow())
					fillHeaderFields();

				return applyHeaderAndDynamicTypingAndTransformation();
			}

			function needsHeaderRow()
			{
				return _config.header && _fields.length === 0;
			}

			function fillHeaderFields()
			{
				if (!_results)
					return;

				function addHeader(header, i)
				{
					if (isFunction(_config.transformHeader))
						header = _config.transformHeader(header, i);

					_fields.push(header);
				}

				if (Array.isArray(_results.data[0]))
				{
					for (var i = 0; needsHeaderRow() && i < _results.data.length; i++)
						_results.data[i].forEach(addHeader);

					_results.data.splice(0, 1);
				}
				// if _results.data[0] is not an array, we are in a step where _results.data is the row.
				else
					_results.data.forEach(addHeader);
			}

			function shouldApplyDynamicTyping(field) {
				// Cache function values to avoid calling it for each row
				if (_config.dynamicTypingFunction && _config.dynamicTyping[field] === undefined) {
					_config.dynamicTyping[field] = _config.dynamicTypingFunction(field);
				}
				return (_config.dynamicTyping[field] || _config.dynamicTyping) === true;
			}

			function parseDynamic(field, value)
			{
				if (shouldApplyDynamicTyping(field))
				{
					if (value === 'true' || value === 'TRUE')
						return true;
					else if (value === 'false' || value === 'FALSE')
						return false;
					else if (testFloat(value))
						return parseFloat(value);
					else if (ISO_DATE.test(value))
						return new Date(value);
					else
						return (value === '' ? null : value);
				}
				return value;
			}

			function applyHeaderAndDynamicTypingAndTransformation()
			{
				if (!_results || (!_config.header && !_config.dynamicTyping && !_config.transform))
					return _results;

				function processRow(rowSource, i)
				{
					var row = _config.header ? {} : [];

					var j;
					for (j = 0; j < rowSource.length; j++)
					{
						var field = j;
						var value = rowSource[j];

						if (_config.header)
							field = j >= _fields.length ? '__parsed_extra' : _fields[j];

						if (_config.transform)
							value = _config.transform(value,field);

						value = parseDynamic(field, value);

						if (field === '__parsed_extra')
						{
							row[field] = row[field] || [];
							row[field].push(value);
						}
						else
							row[field] = value;
					}


					if (_config.header)
					{
						if (j > _fields.length)
							addError('FieldMismatch', 'TooManyFields', 'Too many fields: expected ' + _fields.length + ' fields but parsed ' + j, _rowCounter + i);
						else if (j < _fields.length)
							addError('FieldMismatch', 'TooFewFields', 'Too few fields: expected ' + _fields.length + ' fields but parsed ' + j, _rowCounter + i);
					}

					return row;
				}

				var incrementBy = 1;
				if (!_results.data.length || Array.isArray(_results.data[0]))
				{
					_results.data = _results.data.map(processRow);
					incrementBy = _results.data.length;
				}
				else
					_results.data = processRow(_results.data, 0);


				if (_config.header && _results.meta)
					_results.meta.fields = _fields;

				_rowCounter += incrementBy;
				return _results;
			}

			function guessDelimiter(input, newline, skipEmptyLines, comments, delimitersToGuess) {
				var bestDelim, bestDelta, fieldCountPrevRow, maxFieldCount;

				delimitersToGuess = delimitersToGuess || [',', '\t', '|', ';', Papa.RECORD_SEP, Papa.UNIT_SEP];

				for (var i = 0; i < delimitersToGuess.length; i++) {
					var delim = delimitersToGuess[i];
					var delta = 0, avgFieldCount = 0, emptyLinesCount = 0;
					fieldCountPrevRow = undefined;

					var preview = new Parser({
						comments: comments,
						delimiter: delim,
						newline: newline,
						preview: 10
					}).parse(input);

					for (var j = 0; j < preview.data.length; j++) {
						if (skipEmptyLines && testEmptyLine(preview.data[j])) {
							emptyLinesCount++;
							continue;
						}
						var fieldCount = preview.data[j].length;
						avgFieldCount += fieldCount;

						if (typeof fieldCountPrevRow === 'undefined') {
							fieldCountPrevRow = fieldCount;
							continue;
						}
						else if (fieldCount > 0) {
							delta += Math.abs(fieldCount - fieldCountPrevRow);
							fieldCountPrevRow = fieldCount;
						}
					}

					if (preview.data.length > 0)
						avgFieldCount /= (preview.data.length - emptyLinesCount);

					if ((typeof bestDelta === 'undefined' || delta <= bestDelta)
						&& (typeof maxFieldCount === 'undefined' || avgFieldCount > maxFieldCount) && avgFieldCount > 1.99) {
						bestDelta = delta;
						bestDelim = delim;
						maxFieldCount = avgFieldCount;
					}
				}

				_config.delimiter = bestDelim;

				return {
					successful: !!bestDelim,
					bestDelimiter: bestDelim
				};
			}

			function addError(type, code, msg, row)
			{
				var error = {
					type: type,
					code: code,
					message: msg
				};
				if(row !== undefined) {
					error.row = row;
				}
				_results.errors.push(error);
			}
		}

		/** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions */
		function escapeRegExp(string)
		{
			return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
		}

		/** The core parser implements speedy and correct CSV parsing */
		function Parser(config)
		{
			// Unpack the config object
			config = config || {};
			var delim = config.delimiter;
			var newline = config.newline;
			var comments = config.comments;
			var step = config.step;
			var preview = config.preview;
			var fastMode = config.fastMode;
			var quoteChar;
			var renamedHeaders = null;
			var headerParsed = false;

			if (config.quoteChar === undefined || config.quoteChar === null) {
				quoteChar = '"';
			} else {
				quoteChar = config.quoteChar;
			}
			var escapeChar = quoteChar;
			if (config.escapeChar !== undefined) {
				escapeChar = config.escapeChar;
			}

			// Delimiter must be valid
			if (typeof delim !== 'string'
				|| Papa.BAD_DELIMITERS.indexOf(delim) > -1)
				delim = ',';

			// Comment character must be valid
			if (comments === delim)
				throw new Error('Comment character same as delimiter');
			else if (comments === true)
				comments = '#';
			else if (typeof comments !== 'string'
				|| Papa.BAD_DELIMITERS.indexOf(comments) > -1)
				comments = false;

			// Newline must be valid: \r, \n, or \r\n
			if (newline !== '\n' && newline !== '\r' && newline !== '\r\n')
				newline = '\n';

			// We're gonna need these at the Parser scope
			var cursor = 0;
			var aborted = false;

			this.parse = function(input, baseIndex, ignoreLastRow)
			{
				// For some reason, in Chrome, this speeds things up (!?)
				if (typeof input !== 'string')
					throw new Error('Input must be a string');

				// We don't need to compute some of these every time parse() is called,
				// but having them in a more local scope seems to perform better
				var inputLen = input.length,
					delimLen = delim.length,
					newlineLen = newline.length,
					commentsLen = comments.length;
				var stepIsFunction = isFunction(step);

				// Establish starting state
				cursor = 0;
				var data = [], errors = [], row = [], lastCursor = 0;

				if (!input)
					return returnable();

				if (fastMode || (fastMode !== false && input.indexOf(quoteChar) === -1))
				{
					var rows = input.split(newline);
					for (var i = 0; i < rows.length; i++)
					{
						row = rows[i];
						cursor += row.length;

						if (i !== rows.length - 1)
							cursor += newline.length;
						else if (ignoreLastRow)
							return returnable();
						if (comments && row.substring(0, commentsLen) === comments)
							continue;
						if (stepIsFunction)
						{
							data = [];
							pushRow(row.split(delim));
							doStep();
							if (aborted)
								return returnable();
						}
						else
							pushRow(row.split(delim));
						if (preview && i >= preview)
						{
							data = data.slice(0, preview);
							return returnable(true);
						}
					}
					return returnable();
				}

				var nextDelim = input.indexOf(delim, cursor);
				var nextNewline = input.indexOf(newline, cursor);
				var quoteCharRegex = new RegExp(escapeRegExp(escapeChar) + escapeRegExp(quoteChar), 'g');
				var quoteSearch = input.indexOf(quoteChar, cursor);

				// Parser loop
				for (;;)
				{
					// Field has opening quote
					if (input[cursor] === quoteChar)
					{
						// Start our search for the closing quote where the cursor is
						quoteSearch = cursor;

						// Skip the opening quote
						cursor++;

						for (;;)
						{
							// Find closing quote
							quoteSearch = input.indexOf(quoteChar, quoteSearch + 1);

							//No other quotes are found - no other delimiters
							if (quoteSearch === -1)
							{
								if (!ignoreLastRow) {
									// No closing quote... what a pity
									errors.push({
										type: 'Quotes',
										code: 'MissingQuotes',
										message: 'Quoted field unterminated',
										row: data.length,	// row has yet to be inserted
										index: cursor
									});
								}
								return finish();
							}

							// Closing quote at EOF
							if (quoteSearch === inputLen - 1)
							{
								var value = input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar);
								return finish(value);
							}

							// If this quote is escaped, it's part of the data; skip it
							// If the quote character is the escape character, then check if the next character is the escape character
							if (quoteChar === escapeChar &&  input[quoteSearch + 1] === escapeChar)
							{
								quoteSearch++;
								continue;
							}

							// If the quote character is not the escape character, then check if the previous character was the escape character
							if (quoteChar !== escapeChar && quoteSearch !== 0 && input[quoteSearch - 1] === escapeChar)
							{
								continue;
							}

							if(nextDelim !== -1 && nextDelim < (quoteSearch + 1)) {
								nextDelim = input.indexOf(delim, (quoteSearch + 1));
							}
							if(nextNewline !== -1 && nextNewline < (quoteSearch + 1)) {
								nextNewline = input.indexOf(newline, (quoteSearch + 1));
							}
							// Check up to nextDelim or nextNewline, whichever is closest
							var checkUpTo = nextNewline === -1 ? nextDelim : Math.min(nextDelim, nextNewline);
							var spacesBetweenQuoteAndDelimiter = extraSpaces(checkUpTo);

							// Closing quote followed by delimiter or 'unnecessary spaces + delimiter'
							if (input.substr(quoteSearch + 1 + spacesBetweenQuoteAndDelimiter, delimLen) === delim)
							{
								row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
								cursor = quoteSearch + 1 + spacesBetweenQuoteAndDelimiter + delimLen;

								// If char after following delimiter is not quoteChar, we find next quote char position
								if (input[quoteSearch + 1 + spacesBetweenQuoteAndDelimiter + delimLen] !== quoteChar)
								{
									quoteSearch = input.indexOf(quoteChar, cursor);
								}
								nextDelim = input.indexOf(delim, cursor);
								nextNewline = input.indexOf(newline, cursor);
								break;
							}

							var spacesBetweenQuoteAndNewLine = extraSpaces(nextNewline);

							// Closing quote followed by newline or 'unnecessary spaces + newLine'
							if (input.substring(quoteSearch + 1 + spacesBetweenQuoteAndNewLine, quoteSearch + 1 + spacesBetweenQuoteAndNewLine + newlineLen) === newline)
							{
								row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
								saveRow(quoteSearch + 1 + spacesBetweenQuoteAndNewLine + newlineLen);
								nextDelim = input.indexOf(delim, cursor);	// because we may have skipped the nextDelim in the quoted field
								quoteSearch = input.indexOf(quoteChar, cursor);	// we search for first quote in next line

								if (stepIsFunction)
								{
									doStep();
									if (aborted)
										return returnable();
								}

								if (preview && data.length >= preview)
									return returnable(true);

								break;
							}


							// Checks for valid closing quotes are complete (escaped quotes or quote followed by EOF/delimiter/newline) -- assume these quotes are part of an invalid text string
							errors.push({
								type: 'Quotes',
								code: 'InvalidQuotes',
								message: 'Trailing quote on quoted field is malformed',
								row: data.length,	// row has yet to be inserted
								index: cursor
							});

							quoteSearch++;
							continue;

						}

						continue;
					}

					// Comment found at start of new line
					if (comments && row.length === 0 && input.substring(cursor, cursor + commentsLen) === comments)
					{
						if (nextNewline === -1)	// Comment ends at EOF
							return returnable();
						cursor = nextNewline + newlineLen;
						nextNewline = input.indexOf(newline, cursor);
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}

					// Next delimiter comes before next newline, so we've reached end of field
					if (nextDelim !== -1 && (nextDelim < nextNewline || nextNewline === -1))
					{
						row.push(input.substring(cursor, nextDelim));
						cursor = nextDelim + delimLen;
						// we look for next delimiter char
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}

					// End of row
					if (nextNewline !== -1)
					{
						row.push(input.substring(cursor, nextNewline));
						saveRow(nextNewline + newlineLen);

						if (stepIsFunction)
						{
							doStep();
							if (aborted)
								return returnable();
						}

						if (preview && data.length >= preview)
							return returnable(true);

						continue;
					}

					break;
				}

				return finish();


				function pushRow(row)
				{
					data.push(row);
					lastCursor = cursor;
				}

				/**
	             * checks if there are extra spaces after closing quote and given index without any text
	             * if Yes, returns the number of spaces
	             */
				function extraSpaces(index) {
					var spaceLength = 0;
					if (index !== -1) {
						var textBetweenClosingQuoteAndIndex = input.substring(quoteSearch + 1, index);
						if (textBetweenClosingQuoteAndIndex && textBetweenClosingQuoteAndIndex.trim() === '') {
							spaceLength = textBetweenClosingQuoteAndIndex.length;
						}
					}
					return spaceLength;
				}

				/**
				 * Appends the remaining input from cursor to the end into
				 * row, saves the row, calls step, and returns the results.
				 */
				function finish(value)
				{
					if (ignoreLastRow)
						return returnable();
					if (typeof value === 'undefined')
						value = input.substring(cursor);
					row.push(value);
					cursor = inputLen;	// important in case parsing is paused
					pushRow(row);
					if (stepIsFunction)
						doStep();
					return returnable();
				}

				/**
				 * Appends the current row to the results. It sets the cursor
				 * to newCursor and finds the nextNewline. The caller should
				 * take care to execute user's step function and check for
				 * preview and end parsing if necessary.
				 */
				function saveRow(newCursor)
				{
					cursor = newCursor;
					pushRow(row);
					row = [];
					nextNewline = input.indexOf(newline, cursor);
				}

				/** Returns an object with the results, errors, and meta. */
				function returnable(stopped)
				{
					if (config.header && !baseIndex && data.length && !headerParsed)
					{
						const result = data[0];
						const headerCount = Object.create(null); // To track the count of each base header
						const usedHeaders = new Set(result); // To track used headers and avoid duplicates
						let duplicateHeaders = false;

						for (let i = 0; i < result.length; i++) {
							let header = result[i];
							if (isFunction(config.transformHeader))
								header = config.transformHeader(header, i);

							if (!headerCount[header]) {
								headerCount[header] = 1;
								result[i] = header;
							} else {
								let newHeader;
								let suffixCount = headerCount[header];

								// Find a unique new header
								do {
									newHeader = `${header}_${suffixCount}`;
									suffixCount++;
								} while (usedHeaders.has(newHeader));

								usedHeaders.add(newHeader); // Mark this new Header as used
								result[i] = newHeader;
								headerCount[header]++;
								duplicateHeaders = true;
								if (renamedHeaders === null) {
									renamedHeaders = {};
								}
								renamedHeaders[newHeader] = header;
							}

							usedHeaders.add(header); // Ensure the original header is marked as used
						}
						if (duplicateHeaders) {
							console.warn('Duplicate headers found and renamed.');
						}
						headerParsed = true;
					}
					return {
						data: data,
						errors: errors,
						meta: {
							delimiter: delim,
							linebreak: newline,
							aborted: aborted,
							truncated: !!stopped,
							cursor: lastCursor + (baseIndex || 0),
							renamedHeaders: renamedHeaders
						}
					};
				}

				/** Executes the user's step function and resets data & errors. */
				function doStep()
				{
					step(returnable());
					data = [];
					errors = [];
				}
			};

			/** Sets the abort flag */
			this.abort = function()
			{
				aborted = true;
			};

			/** Gets the cursor position */
			this.getCharIndex = function()
			{
				return cursor;
			};
		}


		function newWorker()
		{
			if (!Papa.WORKERS_SUPPORTED)
				return false;

			var workerUrl = getWorkerBlob();
			var w = new global.Worker(workerUrl);
			w.onmessage = mainThreadReceivedMessage;
			w.id = workerIdCounter++;
			workers[w.id] = w;
			return w;
		}

		/** Callback when main thread receives a message */
		function mainThreadReceivedMessage(e)
		{
			var msg = e.data;
			var worker = workers[msg.workerId];
			var aborted = false;

			if (msg.error)
				worker.userError(msg.error, msg.file);
			else if (msg.results && msg.results.data)
			{
				var abort = function() {
					aborted = true;
					completeWorker(msg.workerId, { data: [], errors: [], meta: { aborted: true } });
				};

				var handle = {
					abort: abort,
					pause: notImplemented,
					resume: notImplemented
				};

				if (isFunction(worker.userStep))
				{
					for (var i = 0; i < msg.results.data.length; i++)
					{
						worker.userStep({
							data: msg.results.data[i],
							errors: msg.results.errors,
							meta: msg.results.meta
						}, handle);
						if (aborted)
							break;
					}
					delete msg.results;	// free memory ASAP
				}
				else if (isFunction(worker.userChunk))
				{
					worker.userChunk(msg.results, handle, msg.file);
					delete msg.results;
				}
			}

			if (msg.finished && !aborted)
				completeWorker(msg.workerId, msg.results);
		}

		function completeWorker(workerId, results) {
			var worker = workers[workerId];
			if (isFunction(worker.userComplete))
				worker.userComplete(results);
			worker.terminate();
			delete workers[workerId];
		}

		function notImplemented() {
			throw new Error('Not implemented.');
		}

		/** Callback when worker thread receives a message */
		function workerThreadReceivedMessage(e)
		{
			var msg = e.data;

			if (typeof Papa.WORKER_ID === 'undefined' && msg)
				Papa.WORKER_ID = msg.workerId;

			if (typeof msg.input === 'string')
			{
				global.postMessage({
					workerId: Papa.WORKER_ID,
					results: Papa.parse(msg.input, msg.config),
					finished: true
				});
			}
			else if ((global.File && msg.input instanceof File) || msg.input instanceof Object)	// thank you, Safari (see issue #106)
			{
				var results = Papa.parse(msg.input, msg.config);
				if (results)
					global.postMessage({
						workerId: Papa.WORKER_ID,
						results: results,
						finished: true
					});
			}
		}

		/** Makes a deep copy of an array or object (mostly) */
		function copy(obj)
		{
			if (typeof obj !== 'object' || obj === null)
				return obj;
			var cpy = Array.isArray(obj) ? [] : {};
			for (var key in obj)
				cpy[key] = copy(obj[key]);
			return cpy;
		}

		function bindFunction(f, self)
		{
			return function() { f.apply(self, arguments); };
		}
		function isFunction(func)
		{
			return typeof func === 'function';
		}

		return Papa;
	})); 
} (papaparse));

var papaparseExports = papaparse.exports;
var Papa = /*@__PURE__*/getDefaultExportFromCjs(papaparseExports);

var downloadCSVFile = function downloadCSVFile(downloadURL) {
  return __awaiter(undefined, undefined, undefined, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var res, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetch(downloadURL, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          });
        case 2:
          res = _context.sent;
          if (!res.ok) {
            _context.next = 8;
            break;
          }
          _context.next = 6;
          return res.blob();
        case 6:
          data = _context.sent;
          return _context.abrupt("return", data);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};
var getParsedCsvFile = function getParsedCsvFile(file) {
  return new Promise(function (resolve, reject) {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: function complete(result) {
        resolve(result.data);
      },
      error: function error(_error) {
        console.error('Error parsing CSV file:', _error);
        reject(_error);
      }
    });
  });
};
var uploadCsvFile = function uploadCsvFile(_a) {
  return __awaiter(undefined, [_a], undefined, function (_ref) {
    var url = _ref.url,
      contentType = _ref.contentType,
      file = _ref.file;
    return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var res;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(url, {
              method: 'PUT',
              headers: {
                'Content-Type': contentType
              },
              body: file
            });
          case 2:
            res = _context2.sent;
            return _context2.abrupt("return", res);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })();
  });
};

var CSVUpload = function CSVUpload(_ref) {
  var defaultOfferData = _ref.defaultOfferData,
    baseUrl = _ref.baseUrl,
    _ref$isInternalDashbo = _ref.isInternalDashboard,
    isInternalDashboard = _ref$isInternalDashbo === undefined ? false : _ref$isInternalDashbo,
    preSelectedLocation = _ref.preSelectedLocation,
    customerID = _ref.customerID;
  var _a, _b;
  var _useState = useState(defaultOfferData),
    _useState2 = _slicedToArray(_useState, 2),
    offerData = _useState2[0];
    _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    locationList = _useState4[0],
    setLocationList = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    locationOptions = _useState6[0],
    setLocationOptions = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    locationSearchValue = _useState8[0];
    _useState8[1];
  var _useState9 = useState({
      id: '',
      name: '',
      countryCode: ''
    }),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedLocation = _useState0[0],
    setSelectedLocation = _useState0[1];
  var _useState1 = useState(0),
    _useState10 = _slicedToArray(_useState1, 2),
    progressValue = _useState10[0],
    setProgressValue = _useState10[1];
  var defaultUploadState = getDefaultUploadState(offerData.theme.uploadButtonText);
  var _useState11 = useState(defaultUploadState),
    _useState12 = _slicedToArray(_useState11, 2),
    uploadState = _useState12[0],
    setUploadState = _useState12[1];
  var _useState13 = useState({
      downloadID: 0,
      downloadedFileData: {},
      downloadBtnLoading: false,
      downloadCatalogueURL: '',
      downloadCatalogueText: offerData.theme.downloadButtonText,
      isRequestForDownloadStatus: false,
      isHideDownloadButton: !offerData.isLatestProductCatalogueDownloadEnabled
    }),
    _useState14 = _slicedToArray(_useState13, 2),
    downloadState = _useState14[0],
    setDownloadState = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    errorList = _useState16[0],
    setErrorList = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isShowOrderTable = _useState18[0],
    setIsShowOrderTable = _useState18[1];
  var _useState19 = useState('by_download_upload'),
    _useState20 = _slicedToArray(_useState19, 2),
    activeTab = _useState20[0],
    setActiveTab = _useState20[1];
  var _useState21 = useState({
      createOrderButtonText: 'Create Order',
      createOrderUrl: '',
      createOrderLoading: false,
      mrOrderID: '',
      isCreateDraftOrder: false
    }),
    _useState22 = _slicedToArray(_useState21, 2),
    createOrderState = _useState22[0],
    setCreateOrderState = _useState22[1];
  var _useState23 = useState(1),
    _useState24 = _slicedToArray(_useState23, 2),
    currentPage = _useState24[0],
    setCurrentPage = _useState24[1];
  var totalPages = Math.ceil(((_a = uploadState.uploadedDataForTable) === null || _a === undefined ? undefined : _a.length) / rowsPerPage);
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    showDraftOrderURL = _useState26[0],
    setShowDraftOrderURL = _useState26[1];
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    isInHouseClick = _useState28[0],
    setIsInHouseClick = _useState28[1];
  var getGlobalErrorMessage = function getGlobalErrorMessage(errorKey) {
    return errorKeyMap[errorKey];
  };
  var getErrorMessageFromTheme = function getErrorMessageFromTheme(errorKey) {
    return offerData.theme[errorKey];
  };
  var isGoToCheckout = offerData.isGoToCheckout,
    isUploadedItemsPreviewEnabled = offerData.isUploadedItemsPreviewEnabled,
    isShowAvailableStock = offerData.isShowAvailableStock,
    watchTutorialLink = offerData.watchTutorialLink,
    isShowWatchTutorial = offerData.isShowWatchTutorial,
    isShowBarcode = offerData.isShowBarcode,
    columns = offerData.columns,
    csvUploadFormat = offerData.csvUploadFormat,
    isAvailableStockEnabledForQuickSearch = offerData.isAvailableStockEnabledForQuickSearch;
  var incrementToken = getColumnNameByIdentifier('increment', columns);
  var minQtyToken = getColumnNameByIdentifier('minimum_quantity', columns);
  var maxQtyToken = getColumnNameByIdentifier('maximum_quantity', columns);
  var availableQtyToken = getColumnNameByIdentifier('available_stock', columns);
  var qtyToken = getColumnNameByIdentifier('quantity', columns);
  var variantIdToken = getColumnNameByIdentifier('variant_id', columns);
  var variantSkuToken = getColumnNameByIdentifier('variant_sku', columns);
  var barcodeToken = getColumnNameByIdentifier('barcode', columns);
  var inventoryPolicyToken = getColumnNameByIdentifier('inventory_policy', columns);
  var columnsTokens = {
    increment: incrementToken || '',
    minimum_quantity: minQtyToken || '',
    maximum_quantity: maxQtyToken || '',
    available_stock: availableQtyToken || '',
    quantity: qtyToken || '',
    variant_id: variantIdToken || '',
    variant_sku: variantSkuToken || '',
    barcode: barcodeToken || ''
  };
  // quick search states
  var _useQuickSearchState = useQuickSearchState(offerData, selectedLocation, columns, isGoToCheckout, baseUrl, customerID, preSelectedLocation, isInternalDashboard),
    searchedValue = _useQuickSearchState.searchedValue,
    setSearchedValue = _useQuickSearchState.setSearchedValue,
    searchedProducts = _useQuickSearchState.searchedProducts,
    setSearchedProducts = _useQuickSearchState.setSearchedProducts,
    quickSearchSelectedProduct = _useQuickSearchState.quickSearchSelectedProduct,
    setQuickSearchSelectedProduct = _useQuickSearchState.setQuickSearchSelectedProduct,
    quickSearchedTableData = _useQuickSearchState.quickSearchedTableData,
    setQuickSearchedTableData = _useQuickSearchState.setQuickSearchedTableData,
    orderUrl = _useQuickSearchState.orderUrl,
    createOrderButtonLoading = _useQuickSearchState.createOrderButtonLoading,
    setCreateOrderButtonLoading = _useQuickSearchState.setCreateOrderButtonLoading,
    searchedProductsLoading = _useQuickSearchState.searchedProductsLoading,
    fetchSearchedProducts = _useQuickSearchState.fetchSearchedProducts,
    onQuickSearchProductAdd = _useQuickSearchState.onQuickSearchProductAdd,
    onQuickSearchProductChange = _useQuickSearchState.onQuickSearchProductChange,
    onClickCreateOrder = _useQuickSearchState.onClickCreateOrder,
    onQuickSearchProductChangeForSearchRow = _useQuickSearchState.onQuickSearchProductChangeForSearchRow;
  var updatedWatchTutorialLink = getValidUrl(watchTutorialLink);
  var getIncrementErrorGroups = function getIncrementErrorGroups(data) {
    return data.reduce(function (acc, obj) {
      var key = obj[incrementToken];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
  };
  // getting the updated error list based on the data
  var getUpdatedErrorList = function getUpdatedErrorList(data) {
    var errorArr = [];
    errorVariables.forEach(function (errorVar) {
      var rowsWithThisError = data.filter(function (elem) {
        return elem['Is Error'] === 'true' && elem.Error === errorVar;
      });
      if (rowsWithThisError.length > 0) {
        if (errorVar === 'errorIncrementQuantityText') {
          var incErrors = getIncrementErrorGroups(rowsWithThisError);
          Object.keys(incErrors).forEach(function (key) {
            var _a;
            var productList = (_a = incErrors[key]) === null || _a === undefined ? undefined : _a.map(function (elem, index) {
              var firstKey = errorSummaryVar || tableHeadings[0];
              return index === 0 ? "".concat(firstKey, ": ").concat(elem[firstKey]) : "".concat(elem[firstKey]);
            });
            var incrementErrorText = "".concat(productList.join(", "), ": ").concat(getIncrementQtyErrorText(Number(key)));
            errorArr.push(incrementErrorText);
          });
        } else {
          var productList = rowsWithThisError === null || rowsWithThisError === undefined ? undefined : rowsWithThisError.map(function (elem, index) {
            var firstKey = errorSummaryVar || tableHeadings[0];
            return index === 0 ? "".concat(firstKey, ": ").concat(elem[firstKey]) : "".concat(elem[firstKey]);
          });
          var _errorText = "".concat(productList.join(", "), ": ").concat(offerData.theme[errorVar]);
          errorArr.push(_errorText);
        }
      }
    });
    return errorArr;
  };
  // fetching the location list
  useEffect(function () {
    if (offerData && offerData.isEligible) {
      fetchingLocations();
      setDownloadState(Object.assign(Object.assign({}, downloadState), {
        downloadCatalogueText: offerData.theme.downloadButtonText,
        isHideDownloadButton: !offerData.isLatestProductCatalogueDownloadEnabled
      }));
      setUploadState(Object.assign(Object.assign({}, uploadState), {
        uploadCsvButtonText: String(offerData.theme.uploadButtonText)
      }));
      // set active tab based on the offer data
      if (offerData.isBulkOrderingEnabled && offerData.isQuickSearchEnabled) setActiveTab('by_download_upload');else if (offerData.isBulkOrderingEnabled) setActiveTab('by_download_upload');else if (offerData.isQuickSearchEnabled) setActiveTab('by_search');
    }
  }, [JSON.stringify(offerData)]);
  // updating the location options based on search value
  useEffect(function () {
    if (locationSearchValue === '') return;
    var filteredOptions = locationList.filter(function (elem) {
      return elem.name.toLowerCase().includes(locationSearchValue.toLowerCase());
    });
    setLocationOptions(_toConsumableArray(filteredOptions));
  }, [locationSearchValue]);
  // requesting upload status at a set time interval
  useEffect(function () {
    if (uploadState.isRequestForUploadStatus === true) {
      var interval = setInterval(function () {
        fetchingCsvUploadStatus();
      }, statusRequestInterval);
      return function () {
        return clearInterval(interval);
      };
    }
  }, [uploadState.isRequestForUploadStatus]);
  var fetchingCsvUploadStatus = function fetchingCsvUploadStatus() {
    return __awaiter(undefined, undefined, undefined, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var fetchStatusUrl, data, mappedErrors, fileData, parsedData, ttd;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            fetchStatusUrl = "".concat(baseUrl).concat(FETCH_CSV_UPLOAD_STATUS_API, "?id=").concat(uploadState.uploadID, "&shopURL=").concat(offerData.shopURL);
            _context.next = 3;
            return authenticatedFetch({
              api: fetchStatusUrl,
              method: 'GET'
            });
          case 3:
            data = _context.sent;
            if (!data) {
              _context.next = 17;
              break;
            }
            // progress value will be updated based on the status
            setProgressValue(getProgressValueByStatus(data.status));
            if (data.status === 'completed' && data.errors) {
              mappedErrors = data.errors.map(getGlobalErrorMessage);
              setErrorList(mappedErrors.map(getErrorMessageFromTheme));
              setUploadState(Object.assign(Object.assign({}, uploadState), {
                isRequestForUploadStatus: false
              }));
            }
            if (!(data.status === 'completed' && !data.errors)) {
              _context.next = 17;
              break;
            }
            setCreateOrderState(Object.assign(Object.assign({}, createOrderState), {
              mrOrderID: data.mrOrderID,
              isCreateDraftOrder: data.isCreateDraftOrder
            }));
            // here we download the file and get the data
            _context.next = 11;
            return downloadCSVFile(data.downloadURL);
          case 11:
            fileData = _context.sent;
            _context.next = 14;
            return getParsedCsvFile(fileData);
          case 14:
            parsedData = _context.sent;
            ttd = orderSummaryDataTransformation(columns, parsedData);
            setUploadState(Object.assign(Object.assign({}, uploadState), {
              isRequestForUploadStatus: false,
              uploadPageUrl: '',
              uploadCsvButtonText: String(offerData.theme.uploadButtonText),
              uploadedDataForTable: _toConsumableArray(ttd),
              submitButtonLoading: false
            }));
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  };
  useEffect(function () {
    // putting together all rows with errors to display above the table
    if (uploadState.uploadedDataForTable.length > 0) {
      var _data = [];
      uploadState.uploadedDataForTable.forEach(function (elem) {
        var updatedElem = Object.assign({}, elem);
        if (elem['Is Error'] === 'true') {
          if ((elem.Available == '' || elem[inventoryPolicyToken] === 'CONTINUE') && elem.Error === 'errorAvailableQuantityText') {
            updatedElem['Is Error'] = 'false';
            updatedElem.Error = '';
          }
        }
        _data.push(updatedElem);
      });
      var errorArr = getUpdatedErrorList(_data);
      setErrorList(errorArr);
      setUploadState(Object.assign(Object.assign({}, uploadState), {
        uploadedDataForTable: _data
      }));
    }
    // pagination edge case handling
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(totalPages);
    }
    if (isUploadedItemsPreviewEnabled && uploadState.uploadedDataForTable.length > 0) {
      setIsShowOrderTable(true);
    }
  }, [uploadState.uploadedDataForTable.length]);
  // fetching the location list
  var fetchingLocations = function fetchingLocations() {
    return __awaiter(undefined, undefined, undefined, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var locationsApi, updatedApi, locationData, customerDataElement, currentLocationId, matchedLocation;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            // todo maybe this entire call can be skipped for internal dashboard
            // const locationData = {
            //   locations: [
            //     { id: '1', name: 'Location 1', countryCode: 'US' },
            //     // { id: '2', name: 'Location 2', countryCode: getCountry(selectedLocation?.countryCode) },
            //   ],
            // };
            locationsApi = "".concat(baseUrl).concat(FETCH_LOCATIONS_API);
            updatedApi = isInternalDashboard ? getURLFromParams({
              api: locationsApi,
              customerID: customerID,
              shopURL: offerData.shopURL,
              locale: preSelectedLocation === null || preSelectedLocation === undefined ? undefined : preSelectedLocation.locale
            }) : getParamsFromWindow(locationsApi);
            _context2.next = 4;
            return authenticatedFetch({
              api: updatedApi
            });
          case 4:
            locationData = _context2.sent;
            if (!locationData) {
              _context2.next = 22;
              break;
            }
            setLocationList(locationData.locations);
            setLocationOptions(locationData.locations);
            if (!isInternalDashboard) {
              _context2.next = 11;
              break;
            }
            setSelectedLocation({
              id: (preSelectedLocation === null || preSelectedLocation === undefined ? undefined : preSelectedLocation.id) || '',
              name: (preSelectedLocation === null || preSelectedLocation === undefined ? undefined : preSelectedLocation.name) || '',
              countryCode: (preSelectedLocation === null || preSelectedLocation === undefined ? undefined : preSelectedLocation.countryCode) || ''
            });
            return _context2.abrupt("return");
          case 11:
            customerDataElement = document.getElementById('mrca-customer-data');
            if (!customerDataElement) {
              _context2.next = 21;
              break;
            }
            currentLocationId = customerDataElement.getAttribute('data-mrca-current-location-id'); // Use the currentLocationId for further logic
            if (!currentLocationId) {
              _context2.next = 19;
              break;
            }
            // Example: set the selected location based on the current location ID
            matchedLocation = locationData.locations.find(function (loc) {
              return loc.id.includes(currentLocationId);
            });
            if (!matchedLocation) {
              _context2.next = 19;
              break;
            }
            setSelectedLocation(matchedLocation);
            return _context2.abrupt("return");
          case 19:
            _context2.next = 22;
            break;
          case 21:
            setSelectedLocation(locationData === null || locationData === undefined ? undefined : locationData.locations[0]);
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  };
  var fetchDownloadStatus = function fetchDownloadStatus(downloadCatalogId, shopURL) {
    return __awaiter(undefined, undefined, undefined, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var fetchStatusUrl, data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            // load catalog id in the api call
            fetchStatusUrl = "".concat(baseUrl).concat(FETCH_DOWNLOAD_CATALOGUE_STATUS_API, "?id=").concat(downloadCatalogId, "&shopURL=").concat(shopURL);
            _context3.next = 3;
            return authenticatedFetch({
              api: fetchStatusUrl,
              method: 'GET'
            });
          case 3:
            data = _context3.sent;
            if (data && data.status === 'completed') {
              // progress value will be updated based on the status
              setProgressValue(getProgressValueByStatus(data.status));
              if (data.status === 'completed') {
                // once we have the catalog url, update it and set loading values to false and rerender button
                setDownloadState(Object.assign(Object.assign({}, downloadState), {
                  downloadBtnLoading: false,
                  downloadCatalogueURL: data.url,
                  isRequestForDownloadStatus: false,
                  downloadCatalogueText: offerData.theme.downloadButtonText
                }));
                setProgressValue(0);
              }
            }
            return _context3.abrupt("return", data.status);
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
  };
  var onDownloadButtonClick = function onDownloadButtonClick() {
    for (var _len = arguments.length, args_1 = new Array(_len), _key = 0; _key < _len; _key++) {
      args_1[_key] = arguments[_key];
    }
    return __awaiter(undefined, [].concat(args_1), undefined, function () {
      var inHouseClick = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var locationId, countryCode, api, updatedApi, downloadUrl, data;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // Update the inHouseClick state to prevent multiple status fetch calls. This is set to true when the download button is clicked via our UI, and false when triggered through the exposed function.
              setIsInHouseClick(inHouseClick);
              // set loading to true
              setDownloadState(Object.assign(Object.assign({}, downloadState), {
                downloadBtnLoading: true
              }));
              // add location id, country code to api call
              locationId = selectedLocation === null || selectedLocation === undefined ? undefined : selectedLocation.id;
              countryCode = getCountry(selectedLocation === null || selectedLocation === undefined ? undefined : selectedLocation.countryCode);
              api = "".concat(baseUrl).concat(FETCH_DOWNLOAD_CATALOGUE_API);
              updatedApi = isInternalDashboard ? getURLFromParams({
                api: api,
                customerID: customerID,
                shopURL: offerData.shopURL,
                locale: preSelectedLocation === null || preSelectedLocation === undefined ? undefined : preSelectedLocation.locale
              }) : "".concat(getParamsFromWindow(api));
              downloadUrl = "".concat(updatedApi, "&").concat(getURLFromParams({
                api: '',
                locationID: locationId,
                countryCode: countryCode
              }), "&extensionID=").concat(offerData.extensionID);
              _context4.next = 9;
              return authenticatedFetch({
                api: downloadUrl,
                method: 'GET'
              });
            case 9:
              data = _context4.sent;
              // if the res is ok, we'll load catalog id and call fetchDownloadStatus()
              if (data) {
                setDownloadState(Object.assign(Object.assign({}, downloadState), {
                  downloadID: Number(data.id),
                  isRequestForDownloadStatus: true,
                  downloadBtnLoading: true
                }));
                setProgressValue(25);
                updateWindowUpro({
                  downloadCatalogID: Number(data.id)
                });
              }
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      })();
    });
  };
  var downloadStatusInterval;
  var FetchStatus = function FetchStatus(downloadID, updateStatusCallback) {
    // Clear any existing interval to avoid multiple intervals
    if (downloadStatusInterval) {
      clearInterval(downloadStatusInterval);
    }
    downloadStatusInterval = setInterval(function () {
      return __awaiter(undefined, undefined, undefined, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var status;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return fetchDownloadStatus(downloadID, offerData.shopURL);
            case 3:
              status = _context5.sent;
              if (updateStatusCallback) {
                updateStatusCallback(status);
              }
              if (status === 'completed') {
                clearInterval(downloadStatusInterval);
              }
              _context5.next = 12;
              break;
            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);
              console.error('Error fetching download status:', _context5.t0);
              clearInterval(downloadStatusInterval);
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 8]]);
      }));
    }, statusRequestInterval);
  };
  updateWindowUpro({
    getDowloadCatalogStatus: FetchStatus
  });
  useEffect(function () {
    if (downloadState.isRequestForDownloadStatus && isInHouseClick) {
      FetchStatus(downloadState.downloadID);
    }
    if (downloadState.downloadCatalogueURL) {
      window.location.href = downloadState.downloadCatalogueURL;
      setDownloadState(Object.assign(Object.assign({}, downloadState), {
        downloadCatalogueURL: ''
      }));
    }
  }, [downloadState.isRequestForDownloadStatus, downloadState.downloadCatalogueURL]);
  // setting the current data to display based on page number and total rows
  var currentData = uploadState.uploadedDataForTable;
  // const incrementToken = getColumnNameByIdentifier('increment', columns);
  // const minQtyToken = getColumnNameByIdentifier('minimum_quantity', columns);
  // const maxQtyToken = getColumnNameByIdentifier('maximum_quantity', columns);
  // const availableQtyToken = getColumnNameByIdentifier(
  //   'available_stock',
  //   columns,
  // );
  // const qtyToken = getColumnNameByIdentifier('quantity', columns);
  // const variantIdToken = getColumnNameByIdentifier('variant_id', columns);
  // const variantSkuToken = getColumnNameByIdentifier('variant_sku', columns);
  // const barcodeToken = getColumnNameByIdentifier('barcode', columns);
  var getIncrementQtyErrorText = function getIncrementQtyErrorText(incrementValue) {
    return String(offerData.theme.errorIncrementQuantityText).replace('{increment_qty}', String(incrementValue));
  };
  // const isValueMultipleOfIncrement = (
  //   value: number,
  //   incrementValue: number,
  // ) => {
  //   return value % incrementValue === 0;
  // };
  // const closestMultiples = (increment: number, value: number) => {
  //   const lowerMultiple = value - (value % increment);
  //   const upperMultiple =
  //     lowerMultiple + increment * (value % increment === 0 ? 0 : 1);
  //   return [lowerMultiple, upperMultiple];
  // };
  // updating the state on quantity increment or decrement in the table
  /*
    Test Cases :
      ✔ Exceeds Available Stock → Error: errorAvailableQuantityText
      ✔ Below Minimum Quantity → Error: errorMinOrderQuantityText
      ✔ Exceeds Max Allowed Quantity → Error: errorMaxOrderQuantityText
      ✔ Not multiple of increment → Error: errorIncrementQuantityText
      ✔ Rounds to Nearest value → Adjusts quantity based on increment rule
      x Max check →  Ensures cart quantity does not exceed the defined maximum when available stock is higher // TODO
         ✔ Clears Error on Valid Entry → Removes error when correct quantity is entered
      ✔ Clears Error on Zero Quantity → Resets error messages
  */
  var onTableRowQuantityChange = function onTableRowQuantityChange(index, value) {
    if ((uploadState === null || uploadState === undefined ? undefined : uploadState.uploadedDataForTable.length) > 0) {
      // extracting values
      var tableData = structuredClone(uploadState.uploadedDataForTable);
      var ignoreAvailableStock = tableData[index][inventoryPolicyToken] === "CONTINUE";
      var maxQty = getSafeNumber(tableData[index], maxQtyToken || '', maxPossibleItemQty);
      var availableStock = ignoreAvailableStock ? maxPossibleItemQty : Math.max(0, getSafeNumber(tableData[index], availableQtyToken || '', maxPossibleItemQty));
      var minQty = getSafeNumber(tableData[index], minQtyToken || '', 0);
      var increment = getSafeNumber(tableData[index], incrementToken || '', 1);
      var currentQty = getSafeNumber(tableData[index], qtyToken || '', 0);
      var subtracting = value < currentQty;
      var sameValue = value === currentQty;
      // calculating the maximum quantity that can be added
      var maxQtyThatCanBeAdded = Math.min(maxQty, availableStock);
      var minQtyToBeAdded = Math.min(minQty, availableStock);
      var isCurrentValMultipleOfIncrement = isValueMultipleOfIncrement(currentQty, increment);
      // handling value change based on increment
      var updatedValue = value;
      if (!sameValue) {
        var _closestMultiples = closestMultiples(increment, isCurrentValMultipleOfIncrement ? value : currentQty),
          _closestMultiples2 = _slicedToArray(_closestMultiples, 2),
          lowerMultiple = _closestMultiples2[0],
          upperMultiple = _closestMultiples2[1];
        var valueAfterSubtracting = Math.max(lowerMultiple, minQtyToBeAdded);
        // if the upper multiple is greater than the quantity that can be added, we can't increase the value
        var valueAfterAdding = upperMultiple > maxQtyThatCanBeAdded ? currentQty : upperMultiple;
        updatedValue = subtracting ? valueAfterSubtracting : valueAfterAdding;
      }
      if (updatedValue < minQtyToBeAdded) {
        var qtyToAddWhenLessThanMin = Math.min(minQtyToBeAdded, maxQtyThatCanBeAdded);
        updatedValue = qtyToAddWhenLessThanMin;
      }
      if (updatedValue > maxQtyThatCanBeAdded) {
        updatedValue = maxQtyThatCanBeAdded;
      }
      var isAddedQuantityLessThanMin = updatedValue < minQty;
      var isAddedQuantityMoreThanMax = updatedValue > maxQty;
      var isAddedQuantityMoreThanAvailable = updatedValue > availableStock;
      // we will update the quantity only if it's within limits. refer to the if condition below
      if (updatedValue <= maxQtyThatCanBeAdded && updatedValue >= minQtyToBeAdded) {
        var elementWithUpdatedQuantity = Object.assign(Object.assign({}, tableData[index]), _defineProperty({}, qtyToken || '', String(updatedValue)));
        // Handling the error within the element
        if (elementWithUpdatedQuantity['Is Error'] === 'true') {
          var _elementWithUpdatedQu = elementWithUpdatedQuantity,
            _Error = _elementWithUpdatedQu.Error;
          // Clear the error if it's a known quantity error or increment issue is resolved
          if (quantityErrors.includes(_Error) || _Error === 'errorIncrementQuantityText' && isValueMultipleOfIncrement(updatedValue, increment)) {
            elementWithUpdatedQuantity = Object.assign(Object.assign({}, elementWithUpdatedQuantity), _defineProperty(_defineProperty({}, 'Is Error', 'false'), "Error", ''));
          }
        }
        // error conditions in a structured manner
        var errorConditions = [{
          condition: elementWithUpdatedQuantity['Is Error'] === 'false' && !isValueMultipleOfIncrement(updatedValue, increment),
          error: 'errorIncrementQuantityText'
        }, {
          condition: elementWithUpdatedQuantity['Is Error'] === 'false' && isAddedQuantityMoreThanAvailable,
          error: 'errorAvailableQuantityText'
        }, {
          condition: elementWithUpdatedQuantity['Is Error'] === 'false' && isAddedQuantityLessThanMin,
          error: 'errorMinOrderQuantityText'
        }, {
          condition: elementWithUpdatedQuantity['Is Error'] === 'false' && isAddedQuantityMoreThanMax,
          error: 'errorMaxOrderQuantityText'
        }];
        // Apply the first matching error condition
        for (var _i = 0, _errorConditions = errorConditions; _i < _errorConditions.length; _i++) {
          var _errorConditions$_i = _errorConditions[_i],
            condition = _errorConditions$_i.condition,
            error = _errorConditions$_i.error;
          if (condition) {
            elementWithUpdatedQuantity = Object.assign(Object.assign({}, elementWithUpdatedQuantity), _defineProperty(_defineProperty({}, 'Is Error', 'true'), "Error", error));
            break;
          }
        }
        // If quantity is 0, clear any errors
        if (updatedValue === 0) {
          elementWithUpdatedQuantity = Object.assign(Object.assign({}, elementWithUpdatedQuantity), _defineProperty(_defineProperty({}, 'Is Error', 'false'), "Error", ''));
        }
        var updatedTableData = [].concat(_toConsumableArray(tableData.slice(0, index)), [elementWithUpdatedQuantity], _toConsumableArray(tableData.slice(index + 1)));
        // Setting the data for table and error list
        setUploadState(Object.assign(Object.assign({}, uploadState), {
          uploadedDataForTable: updatedTableData
        }));
        setErrorList(getUpdatedErrorList(updatedTableData));
      }
    }
  };
  // handling the row deletion in table
  var onTableRowDelete = function onTableRowDelete(idx) {
    var tableData = _toConsumableArray(uploadState === null || uploadState === undefined ? undefined : uploadState.uploadedDataForTable);
    var idxToRemove = idx + (currentPage - 1) * rowsPerPage;
    var filteredTableData = tableData.filter(function (_, index) {
      return index !== idxToRemove;
    });
    setUploadState(Object.assign(Object.assign({}, uploadState), {
      uploadedDataForTable: filteredTableData
    }));
    var updatedErrorArr = getUpdatedErrorList(filteredTableData);
    setErrorList(updatedErrorArr);
  };
  var isShowCSVUpload = offerData.isEligible;
  // we have to reset the data in case of file deletion
  var onDeleteFile = function onDeleteFile() {
    setErrorList([]);
    setUploadState(Object.assign({}, defaultUploadState));
    setCreateOrderState({
      createOrderButtonText: 'Create Order',
      createOrderUrl: '',
      createOrderLoading: false,
      mrOrderID: '',
      isCreateDraftOrder: false
    });
  };
  var isShowCreateOrderBtn = currentData.length > 0 && errorList.length === 0;
  var onCreateOrderClick = function onCreateOrderClick() {
    return __awaiter(undefined, undefined, undefined, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var showLineItemProperties, createOrderApi, updatedApi, requestBody, data, _orderUrl, shopUrl, _data2, redirectPath, toastParam;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (!isInternalDashboard) {
              _context6.next = 2;
              break;
            }
            return _context6.abrupt("return");
          case 2:
            setCreateOrderState(Object.assign(Object.assign({}, createOrderState), {
              createOrderLoading: true
            }));
            showLineItemProperties = getProductNoteColumnIDs(columns);
            createOrderApi = "".concat(baseUrl).concat(FETCH_APP_ORDER_API);
            updatedApi = isInternalDashboard ? getURLFromParams({
              api: createOrderApi,
              customerID: customerID,
              shopURL: offerData.shopURL,
              locale: preSelectedLocation === null || preSelectedLocation === undefined ? undefined : preSelectedLocation.locale
            }) : "".concat(getParamsFromWindow(createOrderApi));
            requestBody = {
              locationID: (selectedLocation === null || selectedLocation === undefined ? undefined : selectedLocation.id) || null,
              countryCode: getCountry(selectedLocation === null || selectedLocation === undefined ? undefined : selectedLocation.countryCode),
              mrOrderID: createOrderState.mrOrderID,
              source: 'bulk_order'
            }; // we redirect the user to cart or checkout based on the extension setup where they can purchase the items
            _context6.next = 9;
            return authenticatedFetch({
              api: updatedApi,
              method: 'POST',
              isRequestBodyPresent: true,
              requestBody: requestBody
            });
          case 9:
            data = _context6.sent;
            if (!data) {
              _context6.next = 35;
              break;
            }
            _orderUrl = ''; // if the button is clicked for the first time
            if (!createOrderState.isCreateDraftOrder) {
              _context6.next = 19;
              break;
            }
            _context6.next = 15;
            return createDraftOrder();
          case 15:
            _orderUrl = _context6.sent;
            setShowDraftOrderURL(true);
            _context6.next = 34;
            break;
          case 19:
            shopUrl = getShop();
            _orderUrl = getCreateOrderUrl(offerData.shopURL, uploadState.uploadedDataForTable, columnsTokens, createOrderState.mrOrderID, isGoToCheckout);
            // manually creating cart for large orders and orders with line item properties enabled and cart merge shops
            if (!(showLineItemProperties.length > 0 || _orderUrl.length > 2000 || ShopExcludedForClearingCart.includes(shopUrl || ''))) {
              _context6.next = 33;
              break;
            }
            _context6.next = 24;
            return createCart(uploadState.uploadedDataForTable, columnsTokens, columns);
          case 24:
            _data2 = _context6.sent;
            _context6.next = 27;
            return addAttributesToCart(createOrderState.mrOrderID);
          case 27:
            redirectPath = '/cart';
            if (isGoToCheckout) {
              redirectPath = '/checkout';
            }
            toastParam = _data2 ? "?toast=".concat(_data2) : '';
            window.location.href = "".concat(redirectPath).concat(toastParam);
            _context6.next = 34;
            break;
          case 33:
            // creating cart using order url for small orders
            window.location.href = _orderUrl;
          case 34:
            setCreateOrderState(Object.assign(Object.assign({}, createOrderState), {
              createOrderLoading: false,
              createOrderUrl: _orderUrl
            }));
          case 35:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
  };
  // can be moved elsewhere
  var createDraftOrder = function createDraftOrder() {
    return __awaiter(undefined, undefined, undefined, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      var lineItems, draftOrderApi, updatedApi, requestBody, data;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            lineItems = uploadState.uploadedDataForTable.filter(function (item) {
              return Number(item[qtyToken]) > 0;
            }) /* Exclude items with Quantity <= 0 */.map(function (item) {
              return {
                variantID: Number(item[variantIdToken]),
                quantity: Number(item[qtyToken])
              };
            });
            draftOrderApi = "".concat(baseUrl).concat(CREATE_DRAFT_ORDER_API);
            updatedApi = isInternalDashboard ? getURLFromParams({
              api: draftOrderApi,
              customerID: customerID,
              shopURL: offerData.shopURL,
              locale: preSelectedLocation === null || preSelectedLocation === undefined ? undefined : preSelectedLocation.locale
            }) : "".concat(getParamsFromWindow(draftOrderApi));
            requestBody = {
              mrOrderID: createOrderState.mrOrderID,
              uploadID: uploadState.uploadID,
              lineItems: lineItems,
              source: 'bulk_order'
            };
            _context7.next = 6;
            return authenticatedFetch({
              api: updatedApi,
              method: 'POST',
              isRequestBodyPresent: true,
              requestBody: requestBody
            });
          case 6:
            data = _context7.sent;
            return _context7.abrupt("return", data.orderURL);
          case 8:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
  };
  var onFileInput = function onFileInput(file) {
    setUploadState(Object.assign(Object.assign({}, uploadState), {
      uploadFileName: file.name,
      fileToUpload: file
    }));
  };
  var onFileSubmit = function onFileSubmit() {
    return __awaiter(undefined, undefined, undefined, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      var _a, _b, submitFileApi, updatedApi, requestBody, fileUploadData, uploadURL, id, res;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            // enable loading as soon as the user clicks on submit and reset the progress value
            setErrorList([]);
            setUploadState(Object.assign(Object.assign({}, uploadState), {
              submitButtonLoading: true
            }));
            setProgressValue(0);
            submitFileApi = "".concat(baseUrl).concat(FETCH_CSV_UPLOAD_URL_API);
            updatedApi = isInternalDashboard ? getURLFromParams({
              api: submitFileApi,
              customerID: customerID,
              shopURL: offerData.shopURL,
              locale: preSelectedLocation === null || preSelectedLocation === undefined ? undefined : preSelectedLocation.locale
            }) : "".concat(getParamsFromWindow(submitFileApi));
            requestBody = {
              extensionID: offerData.extensionID,
              locationID: (selectedLocation === null || selectedLocation === undefined ? undefined : selectedLocation.id) || null,
              countryCode: getCountry(selectedLocation === null || selectedLocation === undefined ? undefined : selectedLocation.countryCode),
              fileName: (_a = uploadState === null || uploadState === undefined ? undefined : uploadState.fileToUpload) === null || _a === undefined ? undefined : _a.name
            }; // in the below request we get uploadID and `uploadURL` to which we will upload the file
            _context8.next = 8;
            return authenticatedFetch({
              api: updatedApi,
              method: 'POST',
              requestBody: requestBody,
              isRequestBodyPresent: true
            });
          case 8:
            fileUploadData = _context8.sent;
            if (!fileUploadData) {
              _context8.next = 16;
              break;
            }
            uploadURL = fileUploadData.uploadURL, id = fileUploadData.id; // below we upload the file to the url we got from the above request
            _context8.next = 13;
            return uploadCsvFile({
              url: uploadURL,
              contentType: ((_b = uploadState === null || uploadState === undefined ? undefined : uploadState.fileToUpload) === null || _b === undefined ? undefined : _b.type) || '',
              file: uploadState.fileToUpload
            });
          case 13:
            res = _context8.sent;
            if (res && res.status === 200) {
              // when the request is successful we set the uploadID and start requesting for the status
              setUploadState(Object.assign(Object.assign({}, uploadState), {
                isRequestForUploadStatus: true,
                uploadID: Number(id),
                uploadedDataForTable: [],
                fileToUpload: null,
                uploadError: ''
              }));
              setErrorList([]);
              // ui.overlay.close('upload-modal');
            }
            if (res && res.status !== 200) {
              // error handling
              setUploadState(Object.assign(Object.assign({}, uploadState), {
                isRequestForUploadStatus: false,
                uploadedDataForTable: [],
                fileToUpload: null,
                uploadID: 0,
                uploadError: 'There has been an error while uploading'
              }));
            }
          case 16:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
  };
  useEffect(function () {
    if (uploadState.fileToUpload) {
      onFileSubmit();
    }
  }, [uploadState.fileToUpload]);
  var handleFileUpload = function handleFileUpload(file) {
    return __awaiter(undefined, undefined, undefined, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            onFileInput(file);
          case 1:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
  };
  if (!isShowCSVUpload) return null;
  var theme = offerData.theme;
  var tabs = {
    bulkOrderTabText: theme.bulkOrderTabText,
    quickSearchTabText: theme.quickSearchTabText
  };
  var tabsStyle = {
    tabsBackgroundColor: theme.tabsBackgroundColor,
    tabsDefaultTextColor: theme.tabsDefaultTextColor,
    tabsActiveBackgroundColor: theme.tabsActiveBackgroundColor,
    tabsActiveTextColor: theme.tabsActiveTextColor,
    tabsFontFamily: theme.tabsFontFamily,
    tabsFontSize: theme.tabsFontSize
  };
  var triggerButton = {
    triggerButtonText: theme.triggerButtonText,
    triggerButtonFontFamily: theme.triggerButtonFontFamily,
    triggerButtonFontSize: theme.triggerButtonFontSize,
    triggerButtonBackgroundColor: theme.triggerButtonBackgroundColor,
    triggerButtonTextColor: theme.triggerButtonTextColor,
    triggerButtonStyle: theme.triggerButtonStyle
  };
  var bannerLayout = {
    uploadBannerTitleFontFamily: theme.uploadBannerTitleFontFamily,
    uploadBannerSubtitleFontFamily: theme.uploadBannerSubtitleFontFamily,
    uploadBannerTitleFontSize: theme.uploadBannerTitleFontSize,
    uploadBannerSubtitleFontSize: theme.uploadBannerSubtitleFontSize,
    uploadBannerBackgroundColor: theme.uploadBannerBackgroundColor,
    uploadBannerTitleTextColor: theme.uploadBannerTitleTextColor,
    uploadBannerSubtitleTextColor: theme.uploadBannerSubtitleTextColor,
    uploadBannerImportTitleText: theme.uploadBannerImportTitleText,
    uploadBannerImportSubtitleText: theme.uploadBannerImportSubtitleText,
    uploadBannerCatalogTitleText: theme.uploadBannerCatalogTitleText,
    uploadBannerCatalogSubtitleText: theme.uploadBannerCatalogSubtitleText
  };
  var title = {
    headerTitleText: theme.headerTitleText,
    headerTitleFontFamily: theme.headerTitleFontFamily,
    headerTitleFontSize: theme.headerTitleFontSize,
    headerTitleTextColor: theme.headerTitleTextColor,
    quickSearchTitleText: theme.quickSearchTitleText,
    titleText: theme.titleText,
    titleFontSize: theme.titleFontSize,
    titleFontFamily: theme.titleFontFamily,
    titleTextColor: theme.titleTextColor,
    uploadPopupHeaderBackgroundColor: theme === null || theme === undefined ? undefined : theme.uploadPopupHeaderBackgroundColor,
    uploadPopupLocationBackgroundColor: theme === null || theme === undefined ? undefined : theme.uploadPopupLocationBackgroundColor,
    uploadBannerImportHeaderTitleText: theme.uploadBannerImportHeaderTitleText
  };
  var subtitle = {
    quickSearchSubtitleText: theme.quickSearchSubtitleText,
    subtitleText: theme.subtitleText,
    subtitleFontFamily: theme.subtitleFontFamily,
    subtitleFontSize: theme.subtitleFontSize,
    subtitleTextColor: theme.subtitleTextColor,
    watchTutorialText: theme === null || theme === undefined ? undefined : theme.watchTutorialText,
    watchTutorialTextColor: theme === null || theme === undefined ? undefined : theme.watchTutorialTextColor,
    watchTutorialFontSize: theme === null || theme === undefined ? undefined : theme.watchTutorialFontSize,
    watchTutorialFontFamily: theme === null || theme === undefined ? undefined : theme.watchTutorialFontFamily,
    watchTutorialButtonStyle: theme === null || theme === undefined ? undefined : theme.watchTutorialButtonStyle
  };
  var uploadCSVButton = {
    uploadButtonText: theme.uploadButtonText,
    uploadButtonFontSize: theme.uploadButtonFontSize,
    uploadCSVButtonFontFamily: theme.uploadCSVButtonFontFamily,
    uploadCSVButtonBackgroundColor: theme.uploadCSVButtonBackgroundColor,
    uploadCSVButtonTextColor: theme.uploadCSVButtonTextColor,
    uploadButtonStyle: theme.uploadButtonStyle
  };
  var downloadCatalogButton = {
    downloadButtonText: theme.downloadButtonText,
    downloadCatalogButtonFontFamily: theme.downloadCatalogButtonFontFamily,
    downloadButtonFontSize: theme.downloadButtonFontSize,
    downloadCatalogButtonBackgroundColor: theme.downloadCatalogButtonBackgroundColor,
    downloadCatalogButtonTextColor: theme.downloadCatalogButtonTextColor,
    downloadButtonStyle: theme.downloadButtonStyle
  };
  var createOrderButton = {
    createOrderText: theme.createOrderText,
    createOrderButtonFontFamily: theme.createOrderButtonFontFamily,
    createOrderButtonFontSize: theme.createOrderButtonFontSize,
    createOrderButtonBackgroundColor: theme.createOrderButtonBackgroundColor,
    createOrderButtonTextColor: theme.createOrderButtonTextColor,
    createOrderButtonStyle: theme.createOrderButtonStyle
  };
  var quickSearchButtonAndPlaceholder = {
    quickSearchAddButtonText: theme.quickSearchAddButtonText,
    quickSearchAddButtonBackgroundColor: theme.quickSearchAddButtonBackgroundColor,
    quickSearchAddButtonTextColor: theme.quickSearchAddButtonTextColor,
    quickSearchAddButtonFontSize: theme.quickSearchAddButtonFontSize,
    quickSearchAddButtonFontFamily: theme.quickSearchAddButtonFontFamily,
    quickSearchAddButtonStyle: theme.quickSearchAddButtonStyle,
    quickSearchPlaceholderText: theme.quickSearchPlaceholderText
  };
  var location = {
    locationFontFamily: theme.locationFontFamily,
    locationFontSize: theme.locationFontSize,
    locationTextColor: theme.locationTextColor
  };
  var fileName = {
    fileNameFontFamily: theme.fileNameFontFamily,
    fileNameFontSize: theme.fileNameFontSize,
    fileNameTextColor: theme.fileNameTextColor
  };
  var orderTableHeader = {
    orderSummaryTableTitleText: theme.orderSummaryTableTitleText,
    orderTableHeaderFontFamily: theme.orderTableHeaderFontFamily,
    orderTableHeaderFontSize: theme.orderTableHeaderFontSize,
    orderTableHeaderTextColor: theme.orderTableHeaderTextColor,
    orderSummaryTableShowSummaryText: theme.orderSummaryTableShowSummaryText,
    orderSummaryTableHideSummaryText: theme.orderSummaryTableHideSummaryText,
    orderTableHeaderBackgroundColor: theme.orderTableColumnNameBackgroundColor
  };
  var orderTableColumnName = {
    quickSearchProductColumnText: theme.quickSearchProductColumnText,
    quickSearchQuantityText: theme.quickSearchQuantityText,
    // orderSummaryTableProductText: theme.orderSummaryTableProductText,
    // orderSummaryTableQuantityText: theme.orderSummaryTableQuantityText,
    // orderSummaryTableAvailableStockText:
    //   theme.orderSummaryTableAvailableStockText,
    // orderSummaryTableMinimumQuantityText:
    //   theme.orderSummaryTableMinimumQuantityText,
    // orderSummaryTableVariantSKUText: theme.orderSummaryTableVariantSKUText,
    orderTableColumnNameFontFamily: theme.orderTableColumnNameFontFamily,
    orderTableColumnNameFontSize: theme.orderTableColumnNameFontSize,
    orderTableColumnNameTextColor: theme.orderTableColumnNameTextColor
  };
  var orderTableContent = {
    orderTableContentFontFamily: theme.orderTableContentFontFamily,
    orderTableContentFontSize: theme.orderTableContentFontSize,
    orderTableContentTextColor: theme.orderTableContentTextColor
  };
  var errorSummaryTitle = {
    errorTitleText: theme.errorTitleText,
    errorSummaryTitleFontFamily: theme.errorSummaryTitleFontFamily,
    errorSummaryTitleFontSize: theme.errorSummaryTitleFontSize,
    errorSummaryBackgroundColor: theme.errorSummaryBackgroundColor,
    errorCardTitleTextColor: theme.errorCardTitleTextColor
  };
  var errorText = {
    errorInvalidVariantText: theme.errorInvalidVariantText,
    // this is used when the uploaded csv has data in it
    errorMinOrderQuantityText: theme.errorMinOrderQuantityText,
    errorMaxOrderQuantityText: theme.errorMaxOrderQuantityText,
    errorFileFormatText: theme.errorFileFormatText,
    errorIncrementQuantityText: theme.errorIncrementQuantityText,
    errorAvailableQuantityText: theme.errorAvailableQuantityText,
    errorMaxRowsLimitReachedText: theme.errorMaxRowsLimitReachedText,
    errorEmptyCSVText: theme.errorEmptyCSVText,
    errorIncorrectVariantText: theme.errorIncorrectVariantText,
    // this is used when uploaded csv is empty
    errorInvalidQuantityText: theme.errorInvalidQuantityText,
    errorOutOfStockText: theme.errorOutOfStockText
  };
  var errorSummaryContent = {
    errorSummaryContentFontFamily: theme.errorSummaryContentFontFamily,
    errorSummaryContentFontSize: theme.errorSummaryContentFontSize,
    errorCardContentTextColor: theme.errorCardContentTextColor
  };
  var lineItemError = {
    lineItemErrorFontFamily: theme.lineItemErrorFontFamily,
    lineItemErrorFontSize: theme.lineItemErrorFontSize,
    lineItemErrorTextColor: theme.lineItemErrorTextColor
  };
  var otherText = {
    uploadPopupTitleText: theme.uploadPopupTitleText,
    uploadPopupDescriptionText: theme.uploadPopupDescriptionText,
    uploadPopupCancelButtonText: theme.uploadPopupCancelButtonText,
    uploadPopupSubmitButtonText: theme.uploadPopupSubmitButtonText,
    downloadCompletedText: theme.downloadCompletedText,
    fetchingCatalogueText: theme.fetchingCatalogueText,
    processingText: (theme === null || theme === undefined ? undefined : theme.processingText) || 'Processing'
  };
  var themeProps = {
    tabs: tabs,
    tabsStyle: tabsStyle,
    triggerButton: triggerButton,
    bannerLayout: bannerLayout,
    title: title,
    subtitle: subtitle,
    uploadCSVButton: uploadCSVButton,
    downloadCatalogButton: downloadCatalogButton,
    createOrderButton: createOrderButton,
    quickSearchButtonAndPlaceholder: quickSearchButtonAndPlaceholder,
    location: location,
    fileName: fileName,
    orderTableHeader: orderTableHeader,
    orderTableColumnName: orderTableColumnName,
    orderTableContent: orderTableContent,
    errorSummaryTitle: errorSummaryTitle,
    errorSummaryContent: errorSummaryContent,
    lineItemError: lineItemError,
    errorText: errorText,
    otherText: otherText
  };
  var data = (_b = uploadState.uploadedDataForTable) !== null && _b !== undefined ? _b : [];
  var tableHeadings = getColumnHeadings(data, columns);
  var errorSummaryVar = getErrorSummaryVariable(columns);
  var columnTokens = {
    qtyToken: qtyToken || '',
    variantSkuToken: variantSkuToken || '',
    barcodeToken: barcodeToken || '',
    availableQtyToken: availableQtyToken || ''
  };
  return /*#__PURE__*/React.createElement(CSVUpload$1, {
    themeProps: themeProps,
    watchTutorialLink: updatedWatchTutorialLink,
    isShowWatchTutorial: isShowWatchTutorial,
    locationOptions: locationOptions,
    selectedLocation: selectedLocation,
    setSelectedLocation: setSelectedLocation,
    onDownloadButtonClick: onDownloadButtonClick,
    downloadBtnLoading: downloadState.downloadBtnLoading,
    progressValue: progressValue,
    tableData: currentData,
    onTableRowQuantityChange: onTableRowQuantityChange,
    onTableRowDelete: onTableRowDelete,
    onDeleteFile: onDeleteFile,
    fileName: uploadState.uploadFileName,
    isShowOrderTable: isShowOrderTable,
    setIsShowOrderTable: setIsShowOrderTable,
    createOrderUrl: createOrderState.createOrderUrl,
    showOrderURL: showDraftOrderURL,
    errorList: errorList,
    isHideDownloadButton: downloadState.isHideDownloadButton,
    createOrderLoading: createOrderState.createOrderLoading,
    onCreateOrderClick: onCreateOrderClick,
    isShowCreateOrderBtn: isShowCreateOrderBtn,
    handleFileUpload: handleFileUpload,
    fileUploadError: uploadState.uploadError,
    isShowProgressBar: uploadState.isRequestForUploadStatus,
    isShowBackBtn: false,
    isShowLocationOptions: false,
    isShowAvailableStock: isShowAvailableStock,
    isShowBarcode: isShowBarcode,
    incrementToken: incrementToken,
    minQtyToken: minQtyToken,
    maxQtyToken: maxQtyToken,
    availableQtyToken: availableQtyToken,
    inventoryPolicyToken: inventoryPolicyToken,
    columnTokens: columnTokens,
    tableHeadings: tableHeadings,
    csvUploadFormat: csvUploadFormat,
    tabsShouldBeVisible: offerData.isBulkOrderingEnabled && offerData.isQuickSearchEnabled,
    activeTab: activeTab,
    setActiveTab: setActiveTab,
    searchedValue: searchedValue,
    setSearchedValue: setSearchedValue,
    fetchSearchedProducts: fetchSearchedProducts,
    searchedProducts: searchedProducts,
    setSearchedProducts: setSearchedProducts,
    quickSearchSelectedProduct: quickSearchSelectedProduct,
    setQuickSearchSelectedProduct: setQuickSearchSelectedProduct,
    quickSearchedTableData: quickSearchedTableData,
    setQuickSearchedTableData: setQuickSearchedTableData,
    onQuickSearchProductAdd: onQuickSearchProductAdd,
    onQuickSearchProductChange: onQuickSearchProductChange,
    onClickCreateOrder: onClickCreateOrder,
    orderUrl: orderUrl,
    createOrderButtonLoading: createOrderButtonLoading,
    setCreateOrderButtonLoading: setCreateOrderButtonLoading,
    onQuickSearchProductChangeForSearchRow: onQuickSearchProductChangeForSearchRow,
    searchedProductsLoading: searchedProductsLoading,
    getInlineError: getInlineError,
    closestMultiples: closestMultiples,
    isValueMultipleOfIncrement: isValueMultipleOfIncrement,
    env: process.env.ENV === 'stage' || process.env.ENV === 'prod' ? process.env.ENV : 'dev',
    isAvailableStockEnabledForQuickSearch: isAvailableStockEnabledForQuickSearch,
    isAdmin: false,
    isInternalDashboard: isInternalDashboard
  });
};

export { CSVUpload, CSVUpload$1 as CSVUploadPreview, CreditLimit as CreditLimitPreview, Toast };
